namespace RioERP.Texts {

    declare namespace Db {

        namespace Administration {

            namespace Language {
                export const Id: string;
                export const LanguageId: string;
                export const LanguageName: string;
            }

            namespace Role {
                export const RoleId: string;
                export const RoleKey: string;
                export const RoleName: string;
            }

            namespace RolePermission {
                export const PermissionKey: string;
                export const RoleId: string;
                export const RolePermissionId: string;
                export const RoleRoleName: string;
            }

            namespace Translation {
                export const CustomText: string;
                export const EntityPlural: string;
                export const Key: string;
                export const OverrideConfirmation: string;
                export const SaveChangesButton: string;
                export const SourceLanguage: string;
                export const SourceText: string;
                export const TargetLanguage: string;
                export const TargetText: string;
            }

            namespace User {
                export const AllowedIps: string;
                export const CCEmails: string;
                export const DisplayName: string;
                export const Email: string;
                export const ImpersonationToken: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const LastDirectoryUpdate: string;
                export const MobilePhoneNumber: string;
                export const MobilePhoneVerified: string;
                export const Password: string;
                export const PasswordConfirm: string;
                export const PasswordHash: string;
                export const PasswordSalt: string;
                export const Roles: string;
                export const SecretKey: string;
                export const Source: string;
                export const TwoFactorAuth: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
                export const UserId: string;
                export const UserImage: string;
                export const Username: string;
                export const xapikey: string;
                export const xapisecret: string;
            }

            namespace UserPermission {
                export const Granted: string;
                export const PermissionKey: string;
                export const User: string;
                export const UserId: string;
                export const UserPermissionId: string;
                export const Username: string;
            }

            namespace UserRole {
                export const RoleId: string;
                export const User: string;
                export const UserId: string;
                export const UserRoleId: string;
                export const Username: string;
            }
        }

        namespace Carts {

            namespace Cart {
                export const CartProducts: string;
                export const CustomerEmail1: string;
                export const CustomerEmail2: string;
                export const CustomerId: string;
                export const CustomerMobile1: string;
                export const CustomerMobile2: string;
                export const CustomerName: string;
                export const DiscountAmount: string;
                export const DiscountCoupon: string;
                export const EFranchiseeDiscount: string;
                export const EFranchiseeDiscountType: string;
                export const EInvoiceTo: string;
                export const FranchiseeDiscountAmount: string;
                export const FranchiseeDiscountValue: string;
                export const FranchiseeId: string;
                export const FranchiseeName: string;
                export const GrossAmount: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const InvoiceCompanyId: string;
                export const IsActive: string;
                export const Name: string;
                export const NetAmount: string;
                export const ShippingAddress1: string;
                export const ShippingAddress2: string;
                export const ShippingCity: string;
                export const ShippingPincode: string;
                export const ShippingStateId: string;
                export const SourceOrderNumber: string;
                export const TaxAmount: string;
                export const TaxableAmount: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace CartProductBillingItems {
                export const CartCustomerEmail1: string;
                export const CartCustomerEmail2: string;
                export const CartCustomerId: string;
                export const CartCustomerMobile1: string;
                export const CartCustomerMobile2: string;
                export const CartCustomerName: string;
                export const CartDiscountAmount: string;
                export const CartDiscountCoupon: string;
                export const CartEFranchiseeDiscount: string;
                export const CartEFranchiseeDiscountType: string;
                export const CartEInvoiceTo: string;
                export const CartFranchiseeDiscountAmount: string;
                export const CartFranchiseeDiscountValue: string;
                export const CartFranchiseeId: string;
                export const CartGrossAmount: string;
                export const CartId: string;
                export const CartInsertDate: string;
                export const CartInsertUserId: string;
                export const CartInvoiceCompanyId: string;
                export const CartIsActive: string;
                export const CartName: string;
                export const CartNetAmount: string;
                export const CartProductsAllowedDevices: string;
                export const CartProductsCartId: string;
                export const CartProductsCost: string;
                export const CartProductsDiscountAmt: string;
                export const CartProductsDownloadUrl1: string;
                export const CartProductsDownloadUrl2: string;
                export const CartProductsEAccessStatus: string;
                export const CartProductsEFranchiseeDiscountType: string;
                export const CartProductsEOpens: string;
                export const CartProductsESerialkeyStatus: string;
                export const CartProductsEValidity: string;
                export const CartProductsEValidityType: string;
                export const CartProductsEWatchTime: string;
                export const CartProductsFranchiseeDiscountAmount: string;
                export const CartProductsFranchiseeDiscountValue: string;
                export const CartProductsGrossAmount: string;
                export const CartProductsHasBooks: string;
                export const CartProductsHasCourier: string;
                export const CartProductsHasPendrive: string;
                export const CartProductsId: string;
                export const CartProductsInsertDate: string;
                export const CartProductsInsertUserId: string;
                export const CartProductsInvoiceCompanyId: string;
                export const CartProductsIsActive: string;
                export const CartProductsIsLive: string;
                export const CartProductsIsTemplateSerialKey: string;
                export const CartProductsNetAmount: string;
                export const CartProductsNote: string;
                export const CartProductsProductId: string;
                export const CartProductsQuantity: string;
                export const CartProductsSerialKey: string;
                export const CartProductsTaxableAmount: string;
                export const CartProductsTotalAllowedDuration: string;
                export const CartProductsUpdateDate: string;
                export const CartProductsUpdateUserId: string;
                export const CartProductsValidTill: string;
                export const CartShippingAddress1: string;
                export const CartShippingAddress2: string;
                export const CartShippingCity: string;
                export const CartShippingPincode: string;
                export const CartShippingStateId: string;
                export const CartTaxableAmount: string;
                export const CartUpdateDate: string;
                export const CartUpdateUserId: string;
                export const DiscountAmount: string;
                export const GrossAmount: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const InvoiceCompanyAddress: string;
                export const InvoiceCompanyDisableInvoiceGenration: string;
                export const InvoiceCompanyFooterNote: string;
                export const InvoiceCompanyGstIn: string;
                export const InvoiceCompanyId: string;
                export const InvoiceCompanyInvoiceChangeDate: string;
                export const InvoiceCompanyInvoiceCode: string;
                export const InvoiceCompanyIsDefault: string;
                export const InvoiceCompanyIsTaxApplicable: string;
                export const InvoiceCompanyLogo1: string;
                export const InvoiceCompanyLogo2: string;
                export const InvoiceCompanyName: string;
                export const InvoiceCompanyStampImage: string;
                export const InvoiceCompanyTaxApplicable: string;
                export const IsActive: string;
                export const NetAmount: string;
                export const ProductBillingItemBillingItemName: string;
                export const ProductBillingItemEDiscountType: string;
                export const ProductBillingItemEndDate: string;
                export const ProductBillingItemGrossAmount: string;
                export const ProductBillingItemHsnMasterId: string;
                export const ProductBillingItemId: string;
                export const ProductBillingItemIncludingTax: string;
                export const ProductBillingItemInsertDate: string;
                export const ProductBillingItemInsertUserId: string;
                export const ProductBillingItemInvoiceCompanyId: string;
                export const ProductBillingItemIsActive: string;
                export const ProductBillingItemProductId: string;
                export const ProductBillingItemSpecialGrossAmount: string;
                export const ProductBillingItemStartDate: string;
                export const ProductBillingItemTaxCategoryId: string;
                export const ProductBillingItemUpdateDate: string;
                export const ProductBillingItemUpdateUserId: string;
                export const TaxCategoryId: string;
                export const TaxCategoryInsertDate: string;
                export const TaxCategoryInsertUserId: string;
                export const TaxCategoryIsActive: string;
                export const TaxCategoryName: string;
                export const TaxCategoryUpdateDate: string;
                export const TaxCategoryUpdateUserId: string;
                export const TaxableAmount: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace CartProductBillingItemsTax {
                export const CartCustomerEmail1: string;
                export const CartCustomerEmail2: string;
                export const CartCustomerId: string;
                export const CartCustomerMobile1: string;
                export const CartCustomerMobile2: string;
                export const CartCustomerName: string;
                export const CartDiscountAmount: string;
                export const CartDiscountCoupon: string;
                export const CartEFranchiseeDiscount: string;
                export const CartEFranchiseeDiscountType: string;
                export const CartEInvoiceTo: string;
                export const CartFranchiseeDiscountAmount: string;
                export const CartFranchiseeDiscountValue: string;
                export const CartFranchiseeId: string;
                export const CartGrossAmount: string;
                export const CartId: string;
                export const CartInsertDate: string;
                export const CartInsertUserId: string;
                export const CartInvoiceCompanyId: string;
                export const CartIsActive: string;
                export const CartName: string;
                export const CartNetAmount: string;
                export const CartProductBillingItemsCartId: string;
                export const CartProductBillingItemsCartProductsId: string;
                export const CartProductBillingItemsDiscountAmount: string;
                export const CartProductBillingItemsGrossAmount: string;
                export const CartProductBillingItemsId: string;
                export const CartProductBillingItemsInsertDate: string;
                export const CartProductBillingItemsInsertUserId: string;
                export const CartProductBillingItemsInvoiceCompanyId: string;
                export const CartProductBillingItemsIsActive: string;
                export const CartProductBillingItemsNetAmount: string;
                export const CartProductBillingItemsProductBillingItemId: string;
                export const CartProductBillingItemsTaxCategoryId: string;
                export const CartProductBillingItemsUpdateDate: string;
                export const CartProductBillingItemsUpdateUserId: string;
                export const CartProductsAllowedDevices: string;
                export const CartProductsCartId: string;
                export const CartProductsCost: string;
                export const CartProductsDiscountAmt: string;
                export const CartProductsDownloadUrl1: string;
                export const CartProductsDownloadUrl2: string;
                export const CartProductsEAccessStatus: string;
                export const CartProductsEFranchiseeDiscountType: string;
                export const CartProductsEOpens: string;
                export const CartProductsESerialkeyStatus: string;
                export const CartProductsEValidity: string;
                export const CartProductsEValidityType: string;
                export const CartProductsEWatchTime: string;
                export const CartProductsFranchiseeDiscountAmount: string;
                export const CartProductsFranchiseeDiscountValue: string;
                export const CartProductsGrossAmount: string;
                export const CartProductsHasBooks: string;
                export const CartProductsHasCourier: string;
                export const CartProductsHasPendrive: string;
                export const CartProductsId: string;
                export const CartProductsInsertDate: string;
                export const CartProductsInsertUserId: string;
                export const CartProductsInvoiceCompanyId: string;
                export const CartProductsIsActive: string;
                export const CartProductsIsLive: string;
                export const CartProductsIsTemplateSerialKey: string;
                export const CartProductsNetAmount: string;
                export const CartProductsNote: string;
                export const CartProductsProductId: string;
                export const CartProductsQuantity: string;
                export const CartProductsSerialKey: string;
                export const CartProductsTaxableAmount: string;
                export const CartProductsTotalAllowedDuration: string;
                export const CartProductsUpdateDate: string;
                export const CartProductsUpdateUserId: string;
                export const CartProductsValidTill: string;
                export const CartShippingAddress1: string;
                export const CartShippingAddress2: string;
                export const CartShippingCity: string;
                export const CartShippingPincode: string;
                export const CartShippingStateId: string;
                export const CartTaxableAmount: string;
                export const CartUpdateDate: string;
                export const CartUpdateUserId: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const Rate: string;
                export const TaxAmount: string;
                export const TaxTypeId: string;
                export const TaxTypeName: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace CartProductSpecifications {
                export const CartCustomerEmail1: string;
                export const CartCustomerEmail2: string;
                export const CartCustomerId: string;
                export const CartCustomerMobile1: string;
                export const CartCustomerMobile2: string;
                export const CartCustomerName: string;
                export const CartDiscountAmount: string;
                export const CartDiscountCoupon: string;
                export const CartEFranchiseeDiscount: string;
                export const CartEFranchiseeDiscountType: string;
                export const CartEInvoiceTo: string;
                export const CartFranchiseeDiscountAmount: string;
                export const CartFranchiseeDiscountValue: string;
                export const CartFranchiseeId: string;
                export const CartGrossAmount: string;
                export const CartId: string;
                export const CartInsertDate: string;
                export const CartInsertUserId: string;
                export const CartInvoiceCompanyId: string;
                export const CartIsActive: string;
                export const CartName: string;
                export const CartNetAmount: string;
                export const CartProductsAllowedDevices: string;
                export const CartProductsCartId: string;
                export const CartProductsCost: string;
                export const CartProductsDiscountAmt: string;
                export const CartProductsDownloadUrl1: string;
                export const CartProductsDownloadUrl2: string;
                export const CartProductsEAccessStatus: string;
                export const CartProductsEFranchiseeDiscountType: string;
                export const CartProductsEOpens: string;
                export const CartProductsESerialkeyStatus: string;
                export const CartProductsEValidity: string;
                export const CartProductsEValidityType: string;
                export const CartProductsEWatchTime: string;
                export const CartProductsFranchiseeDiscountAmount: string;
                export const CartProductsFranchiseeDiscountValue: string;
                export const CartProductsGrossAmount: string;
                export const CartProductsHasBooks: string;
                export const CartProductsHasCourier: string;
                export const CartProductsHasPendrive: string;
                export const CartProductsId: string;
                export const CartProductsInsertDate: string;
                export const CartProductsInsertUserId: string;
                export const CartProductsInvoiceCompanyId: string;
                export const CartProductsIsActive: string;
                export const CartProductsIsLive: string;
                export const CartProductsIsTemplateSerialKey: string;
                export const CartProductsNetAmount: string;
                export const CartProductsNote: string;
                export const CartProductsProductId: string;
                export const CartProductsQuantity: string;
                export const CartProductsSerialKey: string;
                export const CartProductsTaxableAmount: string;
                export const CartProductsTotalAllowedDuration: string;
                export const CartProductsUpdateDate: string;
                export const CartProductsUpdateUserId: string;
                export const CartProductsValidTill: string;
                export const CartShippingAddress1: string;
                export const CartShippingAddress2: string;
                export const CartShippingCity: string;
                export const CartShippingPincode: string;
                export const CartShippingStateId: string;
                export const CartTaxableAmount: string;
                export const CartUpdateDate: string;
                export const CartUpdateUserId: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const ProductSpecificationAllowedDevices: string;
                export const ProductSpecificationEValidity: string;
                export const ProductSpecificationEValidityType: string;
                export const ProductSpecificationEWatchtime: string;
                export const ProductSpecificationEopens: string;
                export const ProductSpecificationHasBooks: string;
                export const ProductSpecificationHasCourier: string;
                export const ProductSpecificationHasPendrive: string;
                export const ProductSpecificationId: string;
                export const ProductSpecificationInsertDate: string;
                export const ProductSpecificationInsertUserId: string;
                export const ProductSpecificationIsLive: string;
                export const ProductSpecificationProcessOrderOnPaid: string;
                export const ProductSpecificationProductId: string;
                export const ProductSpecificationSpecificationCode: string;
                export const ProductSpecificationSpecificationName: string;
                export const ProductSpecificationUpdateDate: string;
                export const ProductSpecificationUpdateUserId: string;
                export const ProductSpecificationValidTill: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace CartProducts {
                export const AllowedDevice: string;
                export const AllowedDevices: string;
                export const CartCustomerEmail1: string;
                export const CartCustomerEmail2: string;
                export const CartCustomerId: string;
                export const CartCustomerMobile1: string;
                export const CartCustomerMobile2: string;
                export const CartCustomerName: string;
                export const CartDiscountAmount: string;
                export const CartDiscountCoupon: string;
                export const CartEFranchiseeDiscount: string;
                export const CartEFranchiseeDiscountType: string;
                export const CartEInvoiceTo: string;
                export const CartFranchiseeDiscountAmount: string;
                export const CartFranchiseeDiscountValue: string;
                export const CartFranchiseeId: string;
                export const CartGrossAmount: string;
                export const CartId: string;
                export const CartInsertDate: string;
                export const CartInsertUserId: string;
                export const CartInvoiceCompanyId: string;
                export const CartIsActive: string;
                export const CartName: string;
                export const CartNetAmount: string;
                export const CartProductSpecificationId: string;
                export const CartShippingAddress1: string;
                export const CartShippingAddress2: string;
                export const CartShippingCity: string;
                export const CartShippingPincode: string;
                export const CartShippingStateId: string;
                export const CartTaxableAmount: string;
                export const CartUpdateDate: string;
                export const CartUpdateUserId: string;
                export const Cost: string;
                export const DiscountAmt: string;
                export const DownloadUrl1: string;
                export const DownloadUrl2: string;
                export const EAccessStatus: string;
                export const EFranchiseeDiscountType: string;
                export const EOpens: string;
                export const ESerialkeyStatus: string;
                export const EValidity: string;
                export const EValidityType: string;
                export const EWatchTime: string;
                export const FranchiseeDiscountAmount: string;
                export const FranchiseeDiscountValue: string;
                export const GrossAmount: string;
                export const HasBooks: string;
                export const HasCourier: string;
                export const HasPendrive: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const InvoiceCompanyAddress: string;
                export const InvoiceCompanyDisableInvoiceGenration: string;
                export const InvoiceCompanyFooterNote: string;
                export const InvoiceCompanyGstIn: string;
                export const InvoiceCompanyId: string;
                export const InvoiceCompanyInvoiceChangeDate: string;
                export const InvoiceCompanyInvoiceCode: string;
                export const InvoiceCompanyIsDefault: string;
                export const InvoiceCompanyIsTaxApplicable: string;
                export const InvoiceCompanyLogo1: string;
                export const InvoiceCompanyLogo2: string;
                export const InvoiceCompanyName: string;
                export const InvoiceCompanyStampImage: string;
                export const InvoiceCompanyTaxApplicable: string;
                export const IsActive: string;
                export const IsLive: string;
                export const IsTemplateSerialKey: string;
                export const NetAmount: string;
                export const NetAmountAfterFrDiscount: string;
                export const Note: string;
                export const ProductActivateSerialKey: string;
                export const ProductAllowSerialKeyGeneration: string;
                export const ProductAllowedDevices: string;
                export const ProductDescription: string;
                export const ProductDownloadUrl1: string;
                export const ProductDownloadUrl2: string;
                export const ProductEAccessStatus: string;
                export const ProductEOpens: string;
                export const ProductEPackingType: string;
                export const ProductEProductType: string;
                export const ProductERioplayVersion: string;
                export const ProductEShippedby: string;
                export const ProductEValidity: string;
                export const ProductEValidityType: string;
                export const ProductEWatchTime: string;
                export const ProductGrossAmount: string;
                export const ProductHasBooks: string;
                export const ProductHasCourier: string;
                export const ProductHasPenDrive: string;
                export const ProductHasVod: string;
                export const ProductHeight: string;
                export const ProductId: string;
                export const ProductInAppDownload: string;
                export const ProductInsertDate: string;
                export const ProductInsertUserId: string;
                export const ProductIsActive: string;
                export const ProductIsCombo: string;
                export const ProductIsLive: string;
                export const ProductLength: string;
                export const ProductNote: string;
                export const ProductProcesOrderOnPaid: string;
                export const ProductProductIds: string;
                export const ProductProductName: string;
                export const ProductProductQueryInfo: string;
                export const ProductRioPlayTenantId: string;
                export const ProductRioplayProductCode: string;
                export const ProductSecretkey: string;
                export const ProductSkuCode: string;
                export const ProductSupportInfo: string;
                export const ProductTeacherName: string;
                export const ProductTemplateSerialKeyId: string;
                export const ProductThumbnail: string;
                export const ProductTotalAllowedDuration: string;
                export const ProductUpdateDate: string;
                export const ProductUpdateUserId: string;
                export const ProductValidTill: string;
                export const ProductVendorId: string;
                export const ProductWebsiteUrl: string;
                export const ProductWeight: string;
                export const ProductWidth: string;
                export const Quantity: string;
                export const SerialKey: string;
                export const TaxAmount: string;
                export const TaxableAmount: string;
                export const TotalAllowedDuration: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
                export const ValidTill: string;
            }

            namespace FranchiseeProductCategory {
                export const CategoryDescription: string;
                export const CategoryId: string;
                export const CategoryInsertDate: string;
                export const CategoryInsertUserId: string;
                export const CategoryIsActive: string;
                export const CategoryIsWebsiteCategory: string;
                export const CategoryName: string;
                export const CategoryParentId: string;
                export const CategoryUpdateDate: string;
                export const CategoryUpdateUserId: string;
                export const CategoryWebsiteCategoryId: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const ProductActivateSerialKey: string;
                export const ProductAllowSerialKeyGeneration: string;
                export const ProductAllowedDevices: string;
                export const ProductDescription: string;
                export const ProductDownloadUrl1: string;
                export const ProductDownloadUrl2: string;
                export const ProductEAccessStatus: string;
                export const ProductEOpens: string;
                export const ProductEPackingType: string;
                export const ProductEProductType: string;
                export const ProductERioplayVersion: string;
                export const ProductEShippedby: string;
                export const ProductEValidity: string;
                export const ProductEValidityType: string;
                export const ProductEWatchTime: string;
                export const ProductGrossAmount: string;
                export const ProductHasBooks: string;
                export const ProductHasCourier: string;
                export const ProductHasPenDrive: string;
                export const ProductHasVod: string;
                export const ProductHeight: string;
                export const ProductId: string;
                export const ProductInAppDownload: string;
                export const ProductInsertDate: string;
                export const ProductInsertUserId: string;
                export const ProductIsActive: string;
                export const ProductIsCombo: string;
                export const ProductIsLive: string;
                export const ProductLength: string;
                export const ProductNote: string;
                export const ProductProcesOrderOnPaid: string;
                export const ProductProductIds: string;
                export const ProductProductName: string;
                export const ProductProductQueryInfo: string;
                export const ProductRioPlayTenantId: string;
                export const ProductRioplayProductCode: string;
                export const ProductSecretkey: string;
                export const ProductSkuCode: string;
                export const ProductSupportInfo: string;
                export const ProductTeacherName: string;
                export const ProductTemplateSerialKeyId: string;
                export const ProductThumbnail: string;
                export const ProductTotalAllowedDuration: string;
                export const ProductUpdateDate: string;
                export const ProductUpdateUserId: string;
                export const ProductValidTill: string;
                export const ProductVendorId: string;
                export const ProductWebsiteUrl: string;
                export const ProductWeight: string;
                export const ProductWidth: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace FranchiseeProducts {
                export const ActivateSerialKey: string;
                export const AllowSerialKeyGeneration: string;
                export const AllowedDevices: string;
                export const Description: string;
                export const DownloadUrl1: string;
                export const DownloadUrl2: string;
                export const EAccessStatus: string;
                export const EOpens: string;
                export const EPackingType: string;
                export const EProductType: string;
                export const ERioplayVersion: string;
                export const EShippedby: string;
                export const EValidity: string;
                export const EValidityType: string;
                export const EWatchTime: string;
                export const GrossAmount: string;
                export const HasBooks: string;
                export const HasCourier: string;
                export const HasPenDrive: string;
                export const HasVod: string;
                export const Height: string;
                export const Id: string;
                export const InAppDownload: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const IsCombo: string;
                export const IsLive: string;
                export const Length: string;
                export const Note: string;
                export const ProcesOrderOnPaid: string;
                export const ProductCategList: string;
                export const ProductIds: string;
                export const ProductName: string;
                export const ProductQueryInfo: string;
                export const RioPlayTenantId: string;
                export const RioplayProductCode: string;
                export const Secretkey: string;
                export const SkuCode: string;
                export const SupportInfo: string;
                export const TeacherName: string;
                export const TemplateSerialKeyId: string;
                export const Thumbnail: string;
                export const TotalAllowedDuration: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
                export const ValidTill: string;
                export const VendorAddress: string;
                export const VendorBankAccountName: string;
                export const VendorBankAccountNo: string;
                export const VendorBankAccountType: string;
                export const VendorBankIfscCode: string;
                export const VendorBankName: string;
                export const VendorCity: string;
                export const VendorCountry: string;
                export const VendorDescription: string;
                export const VendorEmail: string;
                export const VendorGstCertificate: string;
                export const VendorGstin: string;
                export const VendorId: string;
                export const VendorInsertDate: string;
                export const VendorInsertUserId: string;
                export const VendorIsActive: string;
                export const VendorName: string;
                export const VendorPan: string;
                export const VendorPincode: string;
                export const VendorStateId: string;
                export const VendorUpdateDate: string;
                export const VendorUpdateUserId: string;
                export const VendorUserId: string;
                export const WebsiteUrl: string;
                export const Weight: string;
                export const Width: string;
            }
        }

        namespace Common {

            namespace Mail {
                export const AwsPassword: string;
                export const AwsUserId: string;
                export const Bcc: string;
                export const Body: string;
                export const Cc: string;
                export const ErrorMessage: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const LockExpiration: string;
                export const MailFrom: string;
                export const MailId: string;
                export const MailTo: string;
                export const Priority: string;
                export const ReplyTo: string;
                export const RetryCount: string;
                export const SentDate: string;
                export const SerializedMessage: string;
                export const Status: string;
                export const Subject: string;
                export const Uid: string;
            }

            namespace SMS {
                export const ApiKey: string;
                export const AwsPassword: string;
                export const AwsUserId: string;
                export const Bcc: string;
                export const Body: string;
                export const Cc: string;
                export const EntityId: string;
                export const ErrorMessage: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const LockExpiration: string;
                export const Priority: string;
                export const ReplyTo: string;
                export const RetryCount: string;
                export const Sender: string;
                export const SentDate: string;
                export const SmsFrom: string;
                export const SmsId: string;
                export const SmsTo: string;
                export const Status: string;
                export const Subject: string;
                export const TemplateId: string;
                export const Uid: string;
            }
        }

        namespace Enquiry {

            namespace Enquiry {
                export const Address1: string;
                export const Address2: string;
                export const City: string;
                export const Country: string;
                export const CustomerCouponCode: string;
                export const CustomerECustomerType: string;
                export const CustomerEmailId1: string;
                export const CustomerEmailId2: string;
                export const CustomerGstin: string;
                export const CustomerId: string;
                export const CustomerInsertDate: string;
                export const CustomerInsertUserId: string;
                export const CustomerIsActive: string;
                export const CustomerMobile1: string;
                export const CustomerMobile2: string;
                export const CustomerName: string;
                export const CustomerUpdateDate: string;
                export const CustomerUpdateUserId: string;
                export const EEnquiryMode: string;
                export const EStatus: string;
                export const EmailId1: string;
                export const EmailId2: string;
                export const EnquiryDate: string;
                export const EnquiryFollowUp: string;
                export const EnquiryName: string;
                export const EnquiryProduct: string;
                export const EnquiryProducts: string;
                export const EnquiryType: string;
                export const FollowUpTime: string;
                export const FollowupDate: string;
                export const HandledBy: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const Mobile1: string;
                export const Mobile2: string;
                export const Note: string;
                export const OrderIds: string;
                export const Pincode: string;
                export const RowIds: string;
                export const StateId: string;
                export const StateName: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
                export const UserUsername: string;
            }

            namespace EnquiryFollowup {
                export const EnquiryAddress1: string;
                export const EnquiryAddress2: string;
                export const EnquiryCity: string;
                export const EnquiryCountry: string;
                export const EnquiryCustomerId: string;
                export const EnquiryEEnquiryMode: string;
                export const EnquiryEStatus: string;
                export const EnquiryEmailId1: string;
                export const EnquiryEmailId2: string;
                export const EnquiryEnquiryDate: string;
                export const EnquiryEnquiryName: string;
                export const EnquiryFollowupDate: string;
                export const EnquiryHandledBy: string;
                export const EnquiryId: string;
                export const EnquiryInsertDate: string;
                export const EnquiryInsertUserId: string;
                export const EnquiryIsActive: string;
                export const EnquiryMobile1: string;
                export const EnquiryMobile2: string;
                export const EnquiryPincode: string;
                export const EnquiryStateId: string;
                export const EnquiryUpdateDate: string;
                export const EnquiryUpdateUserId: string;
                export const FollowUpDate: string;
                export const FollowUpMode: string;
                export const FollowedBy: string;
                export const Id: string;
                export const Note: string;
                export const UserUsername: string;
            }

            namespace EnquiryProducts {
                export const EnquiryAddress1: string;
                export const EnquiryAddress2: string;
                export const EnquiryCity: string;
                export const EnquiryCountry: string;
                export const EnquiryCustomerId: string;
                export const EnquiryEEnquiryMode: string;
                export const EnquiryEStatus: string;
                export const EnquiryEmailId1: string;
                export const EnquiryEmailId2: string;
                export const EnquiryEnquiryDate: string;
                export const EnquiryEnquiryName: string;
                export const EnquiryFollowupDate: string;
                export const EnquiryHandledBy: string;
                export const EnquiryId: string;
                export const EnquiryInsertDate: string;
                export const EnquiryInsertUserId: string;
                export const EnquiryIsActive: string;
                export const EnquiryMobile1: string;
                export const EnquiryMobile2: string;
                export const EnquiryPincode: string;
                export const EnquiryStateId: string;
                export const EnquiryUpdateDate: string;
                export const EnquiryUpdateUserId: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const ProductActivateSerialKey: string;
                export const ProductAllowSerialKeyGeneration: string;
                export const ProductAllowedDevices: string;
                export const ProductDescription: string;
                export const ProductDownloadUrl1: string;
                export const ProductDownloadUrl2: string;
                export const ProductEAccessStatus: string;
                export const ProductEOpens: string;
                export const ProductEPackingType: string;
                export const ProductEProductType: string;
                export const ProductERioplayVersion: string;
                export const ProductEShippedby: string;
                export const ProductEValidity: string;
                export const ProductEValidityType: string;
                export const ProductEWatchTime: string;
                export const ProductGrossAmount: string;
                export const ProductHasBooks: string;
                export const ProductHasCourier: string;
                export const ProductHasPenDrive: string;
                export const ProductHasVod: string;
                export const ProductHeight: string;
                export const ProductId: string;
                export const ProductInAppDownload: string;
                export const ProductInsertDate: string;
                export const ProductInsertUserId: string;
                export const ProductIsActive: string;
                export const ProductIsCombo: string;
                export const ProductIsLive: string;
                export const ProductLength: string;
                export const ProductNote: string;
                export const ProductProcesOrderOnPaid: string;
                export const ProductProductIds: string;
                export const ProductProductName: string;
                export const ProductProductQueryInfo: string;
                export const ProductRioplayProductCode: string;
                export const ProductSkuCode: string;
                export const ProductSupportInfo: string;
                export const ProductTeacherName: string;
                export const ProductTemplateSerialKeyId: string;
                export const ProductTotalAllowedDuration: string;
                export const ProductUpdateDate: string;
                export const ProductUpdateUserId: string;
                export const ProductValidTill: string;
                export const ProductVendorId: string;
                export const ProductWebsiteUrl: string;
                export const ProductWeight: string;
                export const ProductWidth: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace PendingOrderProducts {
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const Name: string;
                export const PendingOrderAddress: string;
                export const PendingOrderCity: string;
                export const PendingOrderCustomerName: string;
                export const PendingOrderEmail: string;
                export const PendingOrderId: string;
                export const PendingOrderInsertDate: string;
                export const PendingOrderInsertUserId: string;
                export const PendingOrderIsActive: string;
                export const PendingOrderMobile: string;
                export const PendingOrderNopOrderId: string;
                export const PendingOrderPincode: string;
                export const PendingOrderStateId: string;
                export const PendingOrderUpdateDate: string;
                export const PendingOrderUpdateUserId: string;
                export const ProductId: string;
                export const Sku: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace PendingOrders {
                export const Address: string;
                export const City: string;
                export const CustomerId: string;
                export const CustomerName: string;
                export const Email: string;
                export const HandledBy: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const Mobile: string;
                export const NopOrderId: string;
                export const OrderDate: string;
                export const OrderProducts: string;
                export const OrderStatus: string;
                export const Pincode: string;
                export const StateId: string;
                export const StateInsertDate: string;
                export const StateInsertUserId: string;
                export const StateIsActive: string;
                export const StateIsHomeState: string;
                export const StateName: string;
                export const StateUpdateDate: string;
                export const StateUpdateUserId: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
                export const UserUsername: string;
            }
        }

        namespace Inventory {

            namespace BookInward {
                export const Amount: string;
                export const BillDocument: string;
                export const BookBookName: string;
                export const BookCost: string;
                export const BookEBookType: string;
                export const BookId: string;
                export const BookInsertDate: string;
                export const BookInsertUserId: string;
                export const BookIsActive: string;
                export const BookIsbn: string;
                export const BookNoOfPages: string;
                export const BookTaxCategoryId: string;
                export const BookUpdateDate: string;
                export const BookUpdateUserId: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const InwardDate: string;
                export const IsActive: string;
                export const Notes: string;
                export const Qty: string;
                export const Rate: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
                export const VendorAddress: string;
                export const VendorBankAccountName: string;
                export const VendorBankAccountNo: string;
                export const VendorBankAccountType: string;
                export const VendorBankIfscCode: string;
                export const VendorBankName: string;
                export const VendorCity: string;
                export const VendorCountry: string;
                export const VendorDescription: string;
                export const VendorEmail: string;
                export const VendorGstCertificate: string;
                export const VendorGstin: string;
                export const VendorId: string;
                export const VendorInsertDate: string;
                export const VendorInsertUserId: string;
                export const VendorIsActive: string;
                export const VendorName: string;
                export const VendorPan: string;
                export const VendorPincode: string;
                export const VendorStateId: string;
                export const VendorUpdateDate: string;
                export const VendorUpdateUserId: string;
                export const VendorUserId: string;
            }

            namespace BookOutward {
                export const BalanceQuantity: string;
                export const BookBookName: string;
                export const BookCost: string;
                export const BookEBookType: string;
                export const BookId: string;
                export const BookInsertDate: string;
                export const BookInsertUserId: string;
                export const BookIsActive: string;
                export const BookIsbn: string;
                export const BookNoOfPages: string;
                export const BookTaxCategoryId: string;
                export const BookUpdateDate: string;
                export const BookUpdateUserId: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const Notes: string;
                export const OpeningBalance: string;
                export const OutwardMonth: string;
                export const TotalInward: string;
                export const TotalOutward: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace PendriveInward {
                export const BillDocument: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const InwardDate: string;
                export const IsActive: string;
                export const Notes: string;
                export const PenDriveTypeId: string;
                export const PendriveType: string;
                export const Qty: string;
                export const Rate: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
                export const VendorAddress: string;
                export const VendorBankAccountName: string;
                export const VendorBankAccountNo: string;
                export const VendorBankAccountType: string;
                export const VendorBankIfscCode: string;
                export const VendorBankName: string;
                export const VendorCity: string;
                export const VendorCountry: string;
                export const VendorDescription: string;
                export const VendorEmail: string;
                export const VendorGstCertificate: string;
                export const VendorGstin: string;
                export const VendorId: string;
                export const VendorInsertDate: string;
                export const VendorInsertUserId: string;
                export const VendorIsActive: string;
                export const VendorName: string;
                export const VendorPan: string;
                export const VendorPincode: string;
                export const VendorStateId: string;
                export const VendorUpdateDate: string;
                export const VendorUpdateUserId: string;
                export const VendorUserId: string;
            }

            namespace PendriveOutward {
                export const BalanceQuantity: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const Notes: string;
                export const OpeningBalance: string;
                export const OutwardMonth: string;
                export const PenDriveTypeId: string;
                export const PendriveType: string;
                export const TotalInward: string;
                export const TotalOutward: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }
        }

        namespace Invoices {

            namespace FinancialYear {
                export const FromDate: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const ToDate: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
                export const YearCode: string;
            }

            namespace InvoiceHsn {
                export const HsnMasterBillingAddress1: string;
                export const HsnMasterBillingAddress2: string;
                export const HsnMasterBillingCity: string;
                export const HsnMasterBillingPincode: string;
                export const HsnMasterBillingStateId: string;
                export const HsnMasterCustomerId: string;
                export const HsnMasterDiscountAmount: string;
                export const HsnMasterEInvoiceStatus: string;
                export const HsnMasterEInvoiceTo: string;
                export const HsnMasterEInvoiceType: string;
                export const HsnMasterFranchiseeId: string;
                export const HsnMasterGrossAmount: string;
                export const HsnMasterId: string;
                export const HsnMasterInsertDate: string;
                export const HsnMasterInsertUserId: string;
                export const HsnMasterInvoiceCompanyId: string;
                export const HsnMasterInvoiceDate: string;
                export const HsnMasterInvoicenumber: string;
                export const HsnMasterIsActive: string;
                export const HsnMasterIsRecalculated: string;
                export const HsnMasterNetAmount: string;
                export const HsnMasterTaxableAmount: string;
                export const HsnMasterUpdateDate: string;
                export const HsnMasterUpdateUserId: string;
                export const Id: string;
                export const OrderBillingAddress1: string;
                export const OrderBillingAddress2: string;
                export const OrderBillingCity: string;
                export const OrderBillingPincode: string;
                export const OrderBillingStateId: string;
                export const OrderCustomerEmail1: string;
                export const OrderCustomerEmail2: string;
                export const OrderCustomerId: string;
                export const OrderCustomerMobile1: string;
                export const OrderCustomerMobile2: string;
                export const OrderCustomerName: string;
                export const OrderDiscountAmount: string;
                export const OrderDiscountCoupon: string;
                export const OrderDiscountPer: string;
                export const OrderEFranchiseeDiscount: string;
                export const OrderEFranchiseeDiscountType: string;
                export const OrderEInvoiceStatus: string;
                export const OrderEInvoiceTo: string;
                export const OrderEOrderProcessBy: string;
                export const OrderEOrderStatus: string;
                export const OrderEPaymentStatus: string;
                export const OrderEPaymentType: string;
                export const OrderEShippingStatus: string;
                export const OrderEShippingType: string;
                export const OrderESourceType: string;
                export const OrderEmailSendCount: string;
                export const OrderExpectedShippingDate: string;
                export const OrderFranchiseeDiscountAmount: string;
                export const OrderFranchiseeDiscountValue: string;
                export const OrderFranchiseeId: string;
                export const OrderGrossAmount: string;
                export const OrderGstin: string;
                export const OrderId: string;
                export const OrderInsertDate: string;
                export const OrderInsertUserId: string;
                export const OrderInvoiceCompanyId: string;
                export const OrderIsActive: string;
                export const OrderIsEmailSent: string;
                export const OrderLastEmailSentDate: string;
                export const OrderMailId: string;
                export const OrderNetAmount: string;
                export const OrderOrderDate: string;
                export const OrderOrderNumber: string;
                export const OrderShippingAddress1: string;
                export const OrderShippingAddress2: string;
                export const OrderShippingCity: string;
                export const OrderShippingNote: string;
                export const OrderShippingPincode: string;
                export const OrderShippingStateId: string;
                export const OrderShippingToName: string;
                export const OrderSourceName: string;
                export const OrderSourceOrderNumber: string;
                export const OrderTaxableAmount: string;
                export const OrderUpdateDate: string;
                export const OrderUpdateUserId: string;
                export const OrderVendorId: string;
                export const TaxAmount: string;
                export const TaxCategoryId: string;
                export const TaxCategoryInsertDate: string;
                export const TaxCategoryInsertUserId: string;
                export const TaxCategoryIsActive: string;
                export const TaxCategoryName: string;
                export const TaxCategoryUpdateDate: string;
                export const TaxCategoryUpdateUserId: string;
                export const TaxTypeId: string;
                export const TaxTypeName: string;
                export const TaxableAmount: string;
            }

            namespace InvoiceNumberFormat {
                export const AutoIncrementLimit: string;
                export const CalculationCurrency: string;
                export const CurrencyId: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const InvoiceCompanyAddress: string;
                export const InvoiceCompanyFooterNote: string;
                export const InvoiceCompanyGstIn: string;
                export const InvoiceCompanyId: string;
                export const InvoiceCompanyInvoiceChangeDate: string;
                export const InvoiceCompanyInvoiceCode: string;
                export const InvoiceCompanyIsDefault: string;
                export const InvoiceCompanyIsTaxApplicable: string;
                export const InvoiceCompanyLogo1: string;
                export const InvoiceCompanyLogo2: string;
                export const InvoiceCompanyName: string;
                export const InvoiceCompanyStampImage: string;
                export const InvoicePrefix: string;
                export const IsActive: string;
                export const MonthlyReset: string;
                export const Part1: string;
                export const Part2: string;
                export const Part3: string;
                export const Part4: string;
                export const ResetDate: string;
                export const SourceType: string;
                export const SourceTypeId: string;
                export const SourceTypes: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace InvoiceOrders {
                export const Id: string;
                export const InvoiceBillingAddress1: string;
                export const InvoiceBillingAddress2: string;
                export const InvoiceBillingCity: string;
                export const InvoiceBillingPincode: string;
                export const InvoiceBillingStateId: string;
                export const InvoiceCustomerId: string;
                export const InvoiceDiscountAmount: string;
                export const InvoiceEInvoiceStatus: string;
                export const InvoiceEInvoiceTo: string;
                export const InvoiceEInvoiceType: string;
                export const InvoiceFranchiseeId: string;
                export const InvoiceGrossAmount: string;
                export const InvoiceId: string;
                export const InvoiceInsertDate: string;
                export const InvoiceInsertUserId: string;
                export const InvoiceInvoiceCompanyId: string;
                export const InvoiceInvoiceDate: string;
                export const InvoiceInvoicenumber: string;
                export const InvoiceIsActive: string;
                export const InvoiceIsRecalculated: string;
                export const InvoiceNetAmount: string;
                export const InvoiceTaxableAmount: string;
                export const InvoiceUpdateDate: string;
                export const InvoiceUpdateUserId: string;
                export const OrderBillingAddress1: string;
                export const OrderBillingAddress2: string;
                export const OrderBillingCity: string;
                export const OrderBillingPincode: string;
                export const OrderBillingStateId: string;
                export const OrderCustomerEmail1: string;
                export const OrderCustomerEmail2: string;
                export const OrderCustomerId: string;
                export const OrderCustomerMobile1: string;
                export const OrderCustomerMobile2: string;
                export const OrderCustomerName: string;
                export const OrderDiscountAmount: string;
                export const OrderDiscountCoupon: string;
                export const OrderDiscountPer: string;
                export const OrderEFranchiseeDiscount: string;
                export const OrderEFranchiseeDiscountType: string;
                export const OrderEInvoiceStatus: string;
                export const OrderEInvoiceTo: string;
                export const OrderEOrderProcessBy: string;
                export const OrderEOrderStatus: string;
                export const OrderEPaymentStatus: string;
                export const OrderEPaymentType: string;
                export const OrderEShippingStatus: string;
                export const OrderEShippingType: string;
                export const OrderESourceType: string;
                export const OrderEmailSendCount: string;
                export const OrderExpectedShippingDate: string;
                export const OrderFranchiseeDiscountAmount: string;
                export const OrderFranchiseeDiscountValue: string;
                export const OrderFranchiseeId: string;
                export const OrderGrossAmount: string;
                export const OrderGstin: string;
                export const OrderId: string;
                export const OrderInsertDate: string;
                export const OrderInsertUserId: string;
                export const OrderInvoiceCompanyId: string;
                export const OrderIsActive: string;
                export const OrderIsEmailSent: string;
                export const OrderLastEmailSentDate: string;
                export const OrderMailId: string;
                export const OrderNetAmount: string;
                export const OrderOrderDate: string;
                export const OrderOrderNumber: string;
                export const OrderShippingAddress1: string;
                export const OrderShippingAddress2: string;
                export const OrderShippingCity: string;
                export const OrderShippingNote: string;
                export const OrderShippingPincode: string;
                export const OrderShippingStateId: string;
                export const OrderShippingToName: string;
                export const OrderSourceName: string;
                export const OrderSourceOrderNumber: string;
                export const OrderTaxableAmount: string;
                export const OrderUpdateDate: string;
                export const OrderUpdateUserId: string;
                export const OrderVendorId: string;
            }

            namespace InvoicePayment {
                export const Amount: string;
                export const BankName: string;
                export const ChequeNumber: string;
                export const EPaymentMode: string;
                export const EStatus: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const InvoiceBillingAddress1: string;
                export const InvoiceBillingAddress2: string;
                export const InvoiceBillingCity: string;
                export const InvoiceBillingPincode: string;
                export const InvoiceBillingStateId: string;
                export const InvoiceCustomerId: string;
                export const InvoiceDiscountAmount: string;
                export const InvoiceEInvoiceStatus: string;
                export const InvoiceEInvoiceTo: string;
                export const InvoiceEInvoiceType: string;
                export const InvoiceFranchiseeId: string;
                export const InvoiceGrossAmount: string;
                export const InvoiceId: string;
                export const InvoiceInsertDate: string;
                export const InvoiceInsertUserId: string;
                export const InvoiceInvoiceCompanyId: string;
                export const InvoiceInvoiceDate: string;
                export const InvoiceInvoicenumber: string;
                export const InvoiceIsActive: string;
                export const InvoiceIsRecalculated: string;
                export const InvoiceNetAmount: string;
                export const InvoiceTaxableAmount: string;
                export const InvoiceUpdateDate: string;
                export const InvoiceUpdateUserId: string;
                export const IsActive: string;
                export const Note: string;
                export const PaymentDate: string;
                export const TransactionId: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace Invoices {
                export const BillingAddress1: string;
                export const BillingAddress2: string;
                export const BillingCity: string;
                export const BillingPincode: string;
                export const BillingStateId: string;
                export const BillingStateInsertDate: string;
                export const BillingStateInsertUserId: string;
                export const BillingStateIsActive: string;
                export const BillingStateIsHomeState: string;
                export const BillingStateName: string;
                export const BillingStateUpdateDate: string;
                export const BillingStateUpdateUserId: string;
                export const CalculationCurrency: string;
                export const CurrencyId: string;
                export const CustomerCouponCode: string;
                export const CustomerECustomerType: string;
                export const CustomerEmailId1: string;
                export const CustomerEmailId2: string;
                export const CustomerGstin: string;
                export const CustomerId: string;
                export const CustomerInsertDate: string;
                export const CustomerInsertUserId: string;
                export const CustomerIsActive: string;
                export const CustomerMobile1: string;
                export const CustomerMobile2: string;
                export const CustomerName: string;
                export const CustomerUpdateDate: string;
                export const CustomerUpdateUserId: string;
                export const DiscountAmount: string;
                export const EInvoiceStatus: string;
                export const EInvoiceTo: string;
                export const EInvoiceType: string;
                export const ESourceType: string;
                export const FranchiseeAddress: string;
                export const FranchiseeAlternateEmail: string;
                export const FranchiseeAlternateMobile: string;
                export const FranchiseeBankAccountName: string;
                export const FranchiseeBankAccountNo: string;
                export const FranchiseeBankAccountType: string;
                export const FranchiseeBankIfscCode: string;
                export const FranchiseeBankName: string;
                export const FranchiseeCity: string;
                export const FranchiseeCustomerId: string;
                export const FranchiseeDescription: string;
                export const FranchiseeDiscountCoupon: string;
                export const FranchiseeEmail: string;
                export const FranchiseeGstCertificate: string;
                export const FranchiseeGstin: string;
                export const FranchiseeId: string;
                export const FranchiseeInsertDate: string;
                export const FranchiseeInsertUserId: string;
                export const FranchiseeIsActive: string;
                export const FranchiseeIsCustomer: string;
                export const FranchiseeIsPostPayAllowed: string;
                export const FranchiseeMobile: string;
                export const FranchiseeName: string;
                export const FranchiseePan: string;
                export const FranchiseePincode: string;
                export const FranchiseeStateId: string;
                export const FranchiseeUpdateDate: string;
                export const FranchiseeUpdateUserId: string;
                export const FranchiseeUserId: string;
                export const FreezeData: string;
                export const GrossAmount: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const InvoiceCompanyAddress: string;
                export const InvoiceCompanyFooterNote: string;
                export const InvoiceCompanyGstIn: string;
                export const InvoiceCompanyId: string;
                export const InvoiceCompanyInvoiceChangeDate: string;
                export const InvoiceCompanyInvoiceCode: string;
                export const InvoiceCompanyIsDefault: string;
                export const InvoiceCompanyIsTaxApplicable: string;
                export const InvoiceCompanyLogo1: string;
                export const InvoiceCompanyLogo2: string;
                export const InvoiceCompanyName: string;
                export const InvoiceCompanyStampImage: string;
                export const InvoiceDate: string;
                export const Invoicenumber: string;
                export const IsActive: string;
                export const IsRecalculated: string;
                export const NetAmount: string;
                export const TaxAmount: string;
                export const TaxableAmount: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace OrderSources {
                export const Id: string;
                export const SourceType: string;
            }
        }

        namespace Masters {

            namespace AllowedDevices {
                export const Device: string;
                export const Id: string;
            }

            namespace Attempts {
                export const AttemptDate: string;
                export const CourseId: string;
                export const CourseInsertDate: string;
                export const CourseInsertUserId: string;
                export const CourseIsActive: string;
                export const CourseName: string;
                export const CourseUpdateDate: string;
                export const CourseUpdateUserId: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const LevelCourseId: string;
                export const LevelId: string;
                export const LevelInsertDate: string;
                export const LevelInsertUserId: string;
                export const LevelIsActive: string;
                export const LevelName: string;
                export const LevelUpdateDate: string;
                export const LevelUpdateUserId: string;
                export const Name: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace Books {
                export const BookName: string;
                export const Cost: string;
                export const EBookType: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const Isbn: string;
                export const NoOfPages: string;
                export const TaxCategoryId: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace BrandAmbassadorSettings {
                export const BrandAmbassadorSharePercentage: string;
                export const CouponCodePrefix: string;
                export const CreateGiftCard: string;
                export const CreateGiftCardUrl: string;
                export const CreateNopTokenUrl: string;
                export const DiscountCategoryId: string;
                export const DiscountCategoryMappingNopUrl: string;
                export const DiscountCreateNopUrl: string;
                export const DiscountPercentage: string;
                export const Id: string;
                export const NopEmail: string;
                export const NopPassword: string;
                export const NopUserName: string;
                export const OnOrOff: string;
                export const RunProgram: string;
                export const SendEmails: string;
                export const SiteUrl: string;
            }

            namespace Courses {
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const Name: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace Currencies {
                export const CurrencyCode: string;
                export const Id: string;
                export const InrRate: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const IsDefault: string;
                export const Name: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace DelhiveryApiDetails {
                export const Address: string;
                export const City: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const Name: string;
                export const Phone: string;
                export const Pincode: string;
                export const ShippingMode: string;
                export const Token: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace DtdcApiDetails {
                export const AccessToken: string;
                export const Address1: string;
                export const Address2: string;
                export const ApiKey: string;
                export const City: string;
                export const Cookie: string;
                export const CustomerCode: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const Name: string;
                export const Phone: string;
                export const Pincode: string;
                export const ServiceTypeId: string;
                export const State: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace EmailTemplateVariables {
                export const Id: string;
                export const VariableCode: string;
                export const VariableName: string;
            }

            namespace EmailTemplates {
                export const EmailTemplate: string;
                export const Id: string;
                export const IsActive: string;
                export const Status: string;
                export const Variable: string;
                export const VariableCodes: string;
                export const Variables: string;
            }

            namespace HsnMaster {
                export const HsnCode: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const Name: string;
                export const TaxCategoryId: string;
                export const TaxCategoryInsertDate: string;
                export const TaxCategoryInsertUserId: string;
                export const TaxCategoryIsActive: string;
                export const TaxCategoryName: string;
                export const TaxCategoryUpdateDate: string;
                export const TaxCategoryUpdateUserId: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace InvoiceCompany {
                export const Address: string;
                export const DisableInvoiceGenration: string;
                export const FooterNote: string;
                export const GstIn: string;
                export const Id: string;
                export const InvoiceChangeDate: string;
                export const InvoiceCode: string;
                export const IsDefault: string;
                export const IsTaxApplicable: string;
                export const Logo1: string;
                export const Logo2: string;
                export const Name: string;
                export const StampImage: string;
                export const TaxApplicable: string;
            }

            namespace Levels {
                export const CourseId: string;
                export const CourseInsertDate: string;
                export const CourseInsertUserId: string;
                export const CourseIsActive: string;
                export const CourseName: string;
                export const CourseUpdateDate: string;
                export const CourseUpdateUserId: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const Name: string;
                export const SortOrder: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace Mode {
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const Name: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace PendingOrderJobSettings {
                export const Id: string;
                export const NopUrl: string;
                export const RunJob: string;
            }

            namespace PendriveTypes {
                export const Id: string;
                export const PendriveType: string;
            }

            namespace Rioplay8AllowedDevices {
                export const Device: string;
                export const Id: string;
            }

            namespace SmsGatewaySettings {
                export const ApiKey: string;
                export const EntityId: string;
                export const Id: string;
                export const IsActive: string;
                export const Sender: string;
                export const TemplateId: string;
            }

            namespace SmsTemplateVariables {
                export const Id: string;
                export const VariableCode: string;
                export const VariableName: string;
            }

            namespace SmsTemplates {
                export const ApiKey: string;
                export const EntityId: string;
                export const Id: string;
                export const IsActive: string;
                export const Sender: string;
                export const SmsTemplate: string;
                export const Status: string;
                export const TemplateId: string;
                export const VariableCodes: string;
                export const Variables: string;
            }

            namespace SmtpSettings {
                export const FromEmail: string;
                export const FromName: string;
                export const Id: string;
                export const IsActive: string;
                export const IsAws: string;
                export const Password: string;
                export const Port: string;
                export const SendEmailOnWebsiteSync: string;
                export const ServerAddress: string;
                export const UserName: string;
            }

            namespace States {
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const IsHomeState: string;
                export const Name: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace TawkToChat {
                export const ChatId: string;
                export const ChatLog: string;
                export const CustomerId: string;
                export const Department: string;
                export const Email: string;
                export const EndTime: string;
                export const HandledBy: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const Mobile: string;
                export const Name: string;
                export const Note: string;
                export const SerialKey: string;
                export const StartTime: string;
                export const Subject: string;
                export const TawkToEvent: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace TaxCategory {
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const Name: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace TaxRate {
                export const FromDate: string;
                export const Id: string;
                export const Rate: string;
                export const StateId: string;
                export const StateInsertDate: string;
                export const StateInsertUserId: string;
                export const StateIsActive: string;
                export const StateIsHomeState: string;
                export const StateName: string;
                export const StateUpdateDate: string;
                export const StateUpdateUserId: string;
                export const TaxCategoryId: string;
                export const TaxCategoryInsertDate: string;
                export const TaxCategoryInsertUserId: string;
                export const TaxCategoryIsActive: string;
                export const TaxCategoryName: string;
                export const TaxCategoryUpdateDate: string;
                export const TaxCategoryUpdateUserId: string;
                export const TaxTypeId: string;
                export const TaxTypeName: string;
                export const ToDate: string;
            }

            namespace TaxTypes {
                export const Id: string;
                export const Name: string;
            }

            namespace WhatsAppGatewaySettings {
                export const ApiKey: string;
                export const ApiUrl: string;
                export const Id: string;
                export const IsActive: string;
                export const Sender: string;
            }

            namespace WhatsAppMessages {
                export const CustomerId: string;
                export const ErrorMessage: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const SentDate: string;
                export const Status: string;
                export const Type: string;
                export const Wid: string;
            }

            namespace WhatsAppTemplateVariableMap {
                export const Id: string;
                export const WhatsAppTemplateId: string;
                export const WhatsAppTemplateVariableId: string;
            }

            namespace WhatsAppTemplateVariables {
                export const Id: string;
                export const VariableCode: string;
                export const VariableName: string;
            }

            namespace WhatsAppTemplates {
                export const Id: string;
                export const IsActive: string;
                export const LanguageCode: string;
                export const MessagingProduct: string;
                export const Status: string;
                export const TemplateName: string;
                export const Type: string;
                export const Variable: string;
                export const VariableCodes: string;
                export const Variables: string;
                export const Wid: string;
            }
        }

        namespace Orders {

            namespace BrandAmbassadorPayments {
                export const BankName: string;
                export const BrandAmbassadorAddress: string;
                export const BrandAmbassadorAlternateEmail: string;
                export const BrandAmbassadorAlternateMobile: string;
                export const BrandAmbassadorBankAccountName: string;
                export const BrandAmbassadorBankAccountNo: string;
                export const BrandAmbassadorBankAccountType: string;
                export const BrandAmbassadorBankIfscCode: string;
                export const BrandAmbassadorBankName: string;
                export const BrandAmbassadorCity: string;
                export const BrandAmbassadorCustomerId: string;
                export const BrandAmbassadorDescription: string;
                export const BrandAmbassadorDiscountCoupon: string;
                export const BrandAmbassadorEmail: string;
                export const BrandAmbassadorGstCertificate: string;
                export const BrandAmbassadorGstin: string;
                export const BrandAmbassadorId: string;
                export const BrandAmbassadorInsertDate: string;
                export const BrandAmbassadorInsertUserId: string;
                export const BrandAmbassadorIsActive: string;
                export const BrandAmbassadorMobile: string;
                export const BrandAmbassadorName: string;
                export const BrandAmbassadorPan: string;
                export const BrandAmbassadorPincode: string;
                export const BrandAmbassadorStateId: string;
                export const BrandAmbassadorUpdateDate: string;
                export const BrandAmbassadorUpdateUserId: string;
                export const BrandAmbassadorUserId: string;
                export const Comment: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const PaidAmount: string;
                export const PaymentDate: string;
                export const PaymentMode: string;
                export const PaymentRefNo: string;
                export const ReceiptNo: string;
                export const Remark: string;
                export const RowIds: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace CustomerGiftCards {
                export const Amount: string;
                export const CustomerAttemptId: string;
                export const CustomerCouponCode: string;
                export const CustomerCourseId: string;
                export const CustomerECustomerType: string;
                export const CustomerEmailId1: string;
                export const CustomerEmailId2: string;
                export const CustomerGstin: string;
                export const CustomerId: string;
                export const CustomerInsertDate: string;
                export const CustomerInsertUserId: string;
                export const CustomerIsActive: string;
                export const CustomerLevelId: string;
                export const CustomerMobile1: string;
                export const CustomerMobile2: string;
                export const CustomerName: string;
                export const CustomerUpdateDate: string;
                export const CustomerUpdateUserId: string;
                export const GiftCardCode: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const NopOrderId: string;
                export const OrderBillingAddress1: string;
                export const OrderBillingAddress2: string;
                export const OrderBillingCity: string;
                export const OrderBillingPincode: string;
                export const OrderBillingStateId: string;
                export const OrderCurrencyAmount: string;
                export const OrderCurrencyId: string;
                export const OrderCustomerEmail1: string;
                export const OrderCustomerEmail2: string;
                export const OrderCustomerId: string;
                export const OrderCustomerMobile1: string;
                export const OrderCustomerMobile2: string;
                export const OrderCustomerName: string;
                export const OrderDiscountAmount: string;
                export const OrderDiscountCoupon: string;
                export const OrderDiscountPer: string;
                export const OrderEFranchiseeDiscount: string;
                export const OrderEFranchiseeDiscountType: string;
                export const OrderEInvoiceStatus: string;
                export const OrderEInvoiceTo: string;
                export const OrderEOrderProcessBy: string;
                export const OrderEOrderStatus: string;
                export const OrderEPaymentStatus: string;
                export const OrderEPaymentType: string;
                export const OrderEShippingStatus: string;
                export const OrderEShippingType: string;
                export const OrderESourceType: string;
                export const OrderEmailSendCount: string;
                export const OrderExpectedShippingDate: string;
                export const OrderFranchiseeDiscountAmount: string;
                export const OrderFranchiseeDiscountValue: string;
                export const OrderFranchiseeId: string;
                export const OrderFreezeData: string;
                export const OrderGrossAmount: string;
                export const OrderGstin: string;
                export const OrderId: string;
                export const OrderInsertDate: string;
                export const OrderInsertUserId: string;
                export const OrderInvoiceCompanyId: string;
                export const OrderIsActive: string;
                export const OrderIsEmailSent: string;
                export const OrderLastEmailSentDate: string;
                export const OrderMailId: string;
                export const OrderNetAmount: string;
                export const OrderNetAmountAfterFrDiscount: string;
                export const OrderOrderDate: string;
                export const OrderOrderNumber: string;
                export const OrderShippingAddress1: string;
                export const OrderShippingAddress2: string;
                export const OrderShippingCity: string;
                export const OrderShippingNote: string;
                export const OrderShippingPincode: string;
                export const OrderShippingProviderId: string;
                export const OrderShippingStateId: string;
                export const OrderShippingToName: string;
                export const OrderSourceName: string;
                export const OrderSourceOrderNumber: string;
                export const OrderTaxAmount: string;
                export const OrderTaxableAmount: string;
                export const OrderUpdateDate: string;
                export const OrderUpdateUserId: string;
                export const OrderVendorId: string;
                export const Percentage: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace EaseBuzzSettings {
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const Key: string;
                export const RedirectUrl: string;
                export const Salt: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
                export const WebhookUrl: string;
            }

            namespace FranchiseeOrders {
                export const BillingAddress1: string;
                export const BillingAddress2: string;
                export const BillingCity: string;
                export const BillingPincode: string;
                export const BillingStateId: string;
                export const BillingStateInsertDate: string;
                export const BillingStateInsertUserId: string;
                export const BillingStateIsActive: string;
                export const BillingStateIsHomeState: string;
                export const BillingStateName: string;
                export const BillingStateUpdateDate: string;
                export const BillingStateUpdateUserId: string;
                export const CustomerAttemptId: string;
                export const CustomerCouponCode: string;
                export const CustomerCourseId: string;
                export const CustomerECustomerType: string;
                export const CustomerEmail1: string;
                export const CustomerEmail2: string;
                export const CustomerGstin: string;
                export const CustomerId: string;
                export const CustomerInsertDate: string;
                export const CustomerInsertUserId: string;
                export const CustomerIsActive: string;
                export const CustomerLevelId: string;
                export const CustomerMobile11: string;
                export const CustomerMobile21: string;
                export const CustomerName1: string;
                export const CustomerUpdateDate: string;
                export const CustomerUpdateUserId: string;
                export const DiscountAmount: string;
                export const DiscountCoupon: string;
                export const DiscountPer: string;
                export const EFranchiseeDiscount: string;
                export const EFranchiseeDiscountType: string;
                export const EInvoiceStatus: string;
                export const EInvoiceTo: string;
                export const EOrderProcessBy: string;
                export const EOrderStatus: string;
                export const EPaymentStatus: string;
                export const EPaymentType: string;
                export const EShippingStatus: string;
                export const EShippingType: string;
                export const ESourceType: string;
                export const EmailSendCount: string;
                export const ExpectedShippingDate: string;
                export const FranchiseeAddress: string;
                export const FranchiseeAffiliateId: string;
                export const FranchiseeAlternateEmail: string;
                export const FranchiseeAlternateMobile: string;
                export const FranchiseeBankAccountName: string;
                export const FranchiseeBankAccountNo: string;
                export const FranchiseeBankAccountType: string;
                export const FranchiseeBankIfscCode: string;
                export const FranchiseeBankName: string;
                export const FranchiseeCity: string;
                export const FranchiseeCustomerId: string;
                export const FranchiseeDescription: string;
                export const FranchiseeDiscountAmount: string;
                export const FranchiseeDiscountCoupon: string;
                export const FranchiseeDiscountValue: string;
                export const FranchiseeEmail: string;
                export const FranchiseeGstCertificate: string;
                export const FranchiseeGstin: string;
                export const FranchiseeId: string;
                export const FranchiseeInsertDate: string;
                export const FranchiseeInsertUserId: string;
                export const FranchiseeIsActive: string;
                export const FranchiseeIsCustomer: string;
                export const FranchiseeIsPostPayAllowed: string;
                export const FranchiseeMobile: string;
                export const FranchiseeName: string;
                export const FranchiseePan: string;
                export const FranchiseePincode: string;
                export const FranchiseeStateId: string;
                export const FranchiseeUpdateDate: string;
                export const FranchiseeUpdateUserId: string;
                export const FranchiseeUserId: string;
                export const FreezeData: string;
                export const GenerateSerialKey: string;
                export const GrossAmount: string;
                export const Gstin: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const InvoiceCompanyAddress: string;
                export const InvoiceCompanyFooterNote: string;
                export const InvoiceCompanyGstIn: string;
                export const InvoiceCompanyId: string;
                export const InvoiceCompanyInvoiceChangeDate: string;
                export const InvoiceCompanyInvoiceCode: string;
                export const InvoiceCompanyIsDefault: string;
                export const InvoiceCompanyIsTaxApplicable: string;
                export const InvoiceCompanyLogo1: string;
                export const InvoiceCompanyLogo2: string;
                export const InvoiceCompanyName: string;
                export const InvoiceCompanyStampImage: string;
                export const IsActive: string;
                export const IsEmailSent: string;
                export const LastEmailSentDate: string;
                export const MailId: string;
                export const MarkAsPaid: string;
                export const NetAmount: string;
                export const OrderDate: string;
                export const OrderNumber: string;
                export const OrderProduct: string;
                export const OrderProducts: string;
                export const ShippingAddress1: string;
                export const ShippingAddress2: string;
                export const ShippingCity: string;
                export const ShippingNote: string;
                export const ShippingPincode: string;
                export const ShippingProviderBankAccountNo: string;
                export const ShippingProviderBankIfscCode: string;
                export const ShippingProviderBankName: string;
                export const ShippingProviderDescription: string;
                export const ShippingProviderEApiStatus: string;
                export const ShippingProviderEShippingProviderType: string;
                export const ShippingProviderGstCertificate: string;
                export const ShippingProviderGstin: string;
                export const ShippingProviderId: string;
                export const ShippingProviderInsertDate: string;
                export const ShippingProviderInsertUserId: string;
                export const ShippingProviderIsActive: string;
                export const ShippingProviderIsDefault: string;
                export const ShippingProviderPan: string;
                export const ShippingProviderSecret: string;
                export const ShippingProviderShippingProviderName: string;
                export const ShippingProviderTrackingUrl: string;
                export const ShippingProviderUpdateDate: string;
                export const ShippingProviderUpdateUserId: string;
                export const ShippingProviderVendorId: string;
                export const ShippingStateId: string;
                export const ShippingStateInsertDate: string;
                export const ShippingStateInsertUserId: string;
                export const ShippingStateIsActive: string;
                export const ShippingStateIsHomeState: string;
                export const ShippingStateName: string;
                export const ShippingStateUpdateDate: string;
                export const ShippingStateUpdateUserId: string;
                export const ShippingToName: string;
                export const SourceName: string;
                export const SourceOrderNumber: string;
                export const TaxAmount: string;
                export const TaxableAmount: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
                export const VendorAddress: string;
                export const VendorBankAccountName: string;
                export const VendorBankAccountNo: string;
                export const VendorBankAccountType: string;
                export const VendorBankIfscCode: string;
                export const VendorBankName: string;
                export const VendorCity: string;
                export const VendorCountry: string;
                export const VendorDescription: string;
                export const VendorEmail: string;
                export const VendorGstCertificate: string;
                export const VendorGstin: string;
                export const VendorId: string;
                export const VendorInsertDate: string;
                export const VendorInsertUserId: string;
                export const VendorIsActive: string;
                export const VendorName: string;
                export const VendorPan: string;
                export const VendorPincode: string;
                export const VendorStateId: string;
                export const VendorUpdateDate: string;
                export const VendorUpdateUserId: string;
                export const VendorUserId: string;
            }

            namespace FranchiseePayments {
                export const BankName: string;
                export const Comment: string;
                export const FranchiseeAddress: string;
                export const FranchiseeAffiliateId: string;
                export const FranchiseeAlternateEmail: string;
                export const FranchiseeAlternateMobile: string;
                export const FranchiseeAvailableCreditBalance: string;
                export const FranchiseeBankAccountName: string;
                export const FranchiseeBankAccountNo: string;
                export const FranchiseeBankAccountType: string;
                export const FranchiseeBankIfscCode: string;
                export const FranchiseeBankName: string;
                export const FranchiseeCity: string;
                export const FranchiseeCustomerId: string;
                export const FranchiseeDescription: string;
                export const FranchiseeDiscountCoupon: string;
                export const FranchiseeEmail: string;
                export const FranchiseeGstCertificate: string;
                export const FranchiseeGstin: string;
                export const FranchiseeId: string;
                export const FranchiseeInsertDate: string;
                export const FranchiseeInsertUserId: string;
                export const FranchiseeIsActive: string;
                export const FranchiseeIsCustomer: string;
                export const FranchiseeIsPostPayAllowed: string;
                export const FranchiseeMobile: string;
                export const FranchiseeName: string;
                export const FranchiseePan: string;
                export const FranchiseePincode: string;
                export const FranchiseeStateId: string;
                export const FranchiseeUpdateDate: string;
                export const FranchiseeUpdateUserId: string;
                export const FranchiseeUserId: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const PaidAmount: string;
                export const PaymentDate: string;
                export const PaymentMode: string;
                export const PaymentRefNo: string;
                export const ReceiptNo: string;
                export const Remark: string;
                export const RowIds: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace InstamojoSettings {
                export const ClientId: string;
                export const ClientSecret: string;
                export const Currency: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const RedirectUrl: string;
                export const TransactionIdPrefix: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
                export const WebhookUrl: string;
            }

            namespace OrderBook {
                export const BookBookName: string;
                export const BookCost: string;
                export const BookEBookType: string;
                export const BookId: string;
                export const BookInsertDate: string;
                export const BookInsertUserId: string;
                export const BookIsActive: string;
                export const BookIsbn: string;
                export const BookNoOfPages: string;
                export const BookTaxCategoryId: string;
                export const BookUpdateDate: string;
                export const BookUpdateUserId: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const OrderBillingAddress1: string;
                export const OrderBillingAddress2: string;
                export const OrderBillingCity: string;
                export const OrderBillingCountry: string;
                export const OrderBillingPincode: string;
                export const OrderBillingStateId: string;
                export const OrderCalculationCurrency: string;
                export const OrderCurrencyAmount: string;
                export const OrderCurrencyId: string;
                export const OrderCustomerEmail1: string;
                export const OrderCustomerEmail2: string;
                export const OrderCustomerId: string;
                export const OrderCustomerMobile1: string;
                export const OrderCustomerMobile2: string;
                export const OrderCustomerName: string;
                export const OrderDiscountAmount: string;
                export const OrderDiscountCoupon: string;
                export const OrderDiscountPer: string;
                export const OrderEFranchiseeDiscount: string;
                export const OrderEFranchiseeDiscountType: string;
                export const OrderEInvoiceStatus: string;
                export const OrderEInvoiceTo: string;
                export const OrderEOrderProcessBy: string;
                export const OrderEOrderStatus: string;
                export const OrderEPaymentStatus: string;
                export const OrderEPaymentType: string;
                export const OrderEShippingStatus: string;
                export const OrderEShippingType: string;
                export const OrderESourceType: string;
                export const OrderEmailSendCount: string;
                export const OrderExpectedShippingDate: string;
                export const OrderFranchiseeDiscountAmount: string;
                export const OrderFranchiseeDiscountValue: string;
                export const OrderFranchiseeId: string;
                export const OrderFreezeData: string;
                export const OrderGrossAmount: string;
                export const OrderGstin: string;
                export const OrderId: string;
                export const OrderInsertDate: string;
                export const OrderInsertUserId: string;
                export const OrderInvoiceCompanyId: string;
                export const OrderIsActive: string;
                export const OrderIsEmailSent: string;
                export const OrderLastEmailSentDate: string;
                export const OrderLevel: string;
                export const OrderMailId: string;
                export const OrderMode: string;
                export const OrderNetAmount: string;
                export const OrderNetAmountAfterFrDiscount: string;
                export const OrderNote: string;
                export const OrderOrderDate: string;
                export const OrderOrderNumber: string;
                export const OrderShippingAddress1: string;
                export const OrderShippingAddress2: string;
                export const OrderShippingCity: string;
                export const OrderShippingCountry: string;
                export const OrderShippingNote: string;
                export const OrderShippingPincode: string;
                export const OrderShippingProviderId: string;
                export const OrderShippingStateId: string;
                export const OrderShippingToName: string;
                export const OrderSourceName: string;
                export const OrderSourceOrderNumber: string;
                export const OrderTaxAmount: string;
                export const OrderTaxableAmount: string;
                export const OrderUpdateDate: string;
                export const OrderUpdateUserId: string;
                export const OrderVendorId: string;
                export const ProductActivateSerialKey: string;
                export const ProductAllowSerialKeyGeneration: string;
                export const ProductAllowedDevices: string;
                export const ProductDescription: string;
                export const ProductDownloadUrl1: string;
                export const ProductDownloadUrl2: string;
                export const ProductEAccessStatus: string;
                export const ProductEOpens: string;
                export const ProductEPackingType: string;
                export const ProductEProductType: string;
                export const ProductERioplayVersion: string;
                export const ProductEShippedby: string;
                export const ProductEValidity: string;
                export const ProductEValidityType: string;
                export const ProductEWatchTime: string;
                export const ProductGrossAmount: string;
                export const ProductHasBooks: string;
                export const ProductHasCourier: string;
                export const ProductHasPenDrive: string;
                export const ProductHasVod: string;
                export const ProductHeight: string;
                export const ProductId: string;
                export const ProductInAppDownload: string;
                export const ProductInsertDate: string;
                export const ProductInsertUserId: string;
                export const ProductIsActive: string;
                export const ProductIsCombo: string;
                export const ProductIsLive: string;
                export const ProductLength: string;
                export const ProductNote: string;
                export const ProductProcesOrderOnPaid: string;
                export const ProductProductIds: string;
                export const ProductProductName: string;
                export const ProductProductQueryInfo: string;
                export const ProductRioPlayTenantId: string;
                export const ProductRioplayProductCode: string;
                export const ProductSecretkey: string;
                export const ProductSkuCode: string;
                export const ProductSupportInfo: string;
                export const ProductTeacherName: string;
                export const ProductTemplateSerialKeyId: string;
                export const ProductTotalAllowedDuration: string;
                export const ProductUpdateDate: string;
                export const ProductUpdateUserId: string;
                export const ProductValidTill: string;
                export const ProductVendorId: string;
                export const ProductWebsiteUrl: string;
                export const ProductWeight: string;
                export const ProductWidth: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace OrderBrandAmbassadorShare {
                export const BrandAmbassadorAddress: string;
                export const BrandAmbassadorAlternateEmail: string;
                export const BrandAmbassadorAlternateMobile: string;
                export const BrandAmbassadorBankAccountName: string;
                export const BrandAmbassadorBankAccountNo: string;
                export const BrandAmbassadorBankAccountType: string;
                export const BrandAmbassadorBankIfscCode: string;
                export const BrandAmbassadorBankName: string;
                export const BrandAmbassadorCity: string;
                export const BrandAmbassadorCustomerId: string;
                export const BrandAmbassadorDescription: string;
                export const BrandAmbassadorDiscountCoupon: string;
                export const BrandAmbassadorEmail: string;
                export const BrandAmbassadorGstCertificate: string;
                export const BrandAmbassadorGstin: string;
                export const BrandAmbassadorId: string;
                export const BrandAmbassadorInsertDate: string;
                export const BrandAmbassadorInsertUserId: string;
                export const BrandAmbassadorIsActive: string;
                export const BrandAmbassadorMobile: string;
                export const BrandAmbassadorName: string;
                export const BrandAmbassadorPan: string;
                export const BrandAmbassadorPincode: string;
                export const BrandAmbassadorStateId: string;
                export const BrandAmbassadorUpdateDate: string;
                export const BrandAmbassadorUpdateUserId: string;
                export const BrandAmbassadorUserId: string;
                export const ESettelementStatus: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const OrderBillingAddress1: string;
                export const OrderBillingAddress2: string;
                export const OrderBillingCity: string;
                export const OrderBillingPincode: string;
                export const OrderBillingStateId: string;
                export const OrderCustomerEmail1: string;
                export const OrderCustomerEmail2: string;
                export const OrderCustomerId: string;
                export const OrderCustomerMobile1: string;
                export const OrderCustomerMobile2: string;
                export const OrderCustomerName: string;
                export const OrderDiscountAmount: string;
                export const OrderDiscountCoupon: string;
                export const OrderDiscountPer: string;
                export const OrderEFranchiseeDiscount: string;
                export const OrderEFranchiseeDiscountType: string;
                export const OrderEInvoiceStatus: string;
                export const OrderEInvoiceTo: string;
                export const OrderEOrderProcessBy: string;
                export const OrderEOrderStatus: string;
                export const OrderEPaymentStatus: string;
                export const OrderEPaymentType: string;
                export const OrderEShippingStatus: string;
                export const OrderEShippingType: string;
                export const OrderESourceType: string;
                export const OrderEmailSendCount: string;
                export const OrderExpectedShippingDate: string;
                export const OrderFranchiseeDiscountAmount: string;
                export const OrderFranchiseeDiscountValue: string;
                export const OrderFranchiseeId: string;
                export const OrderFreezeData: string;
                export const OrderGrossAmount: string;
                export const OrderGstin: string;
                export const OrderId: string;
                export const OrderInsertDate: string;
                export const OrderInsertUserId: string;
                export const OrderInvoiceCompanyId: string;
                export const OrderIsActive: string;
                export const OrderIsEmailSent: string;
                export const OrderLastEmailSentDate: string;
                export const OrderMailId: string;
                export const OrderNetAmount: string;
                export const OrderOrderDate: string;
                export const OrderOrderNumber: string;
                export const OrderShippingAddress1: string;
                export const OrderShippingAddress2: string;
                export const OrderShippingCity: string;
                export const OrderShippingNote: string;
                export const OrderShippingPincode: string;
                export const OrderShippingProviderId: string;
                export const OrderShippingStateId: string;
                export const OrderShippingToName: string;
                export const OrderSourceName: string;
                export const OrderSourceOrderNumber: string;
                export const OrderTaxAmount: string;
                export const OrderTaxableAmount: string;
                export const OrderUpdateDate: string;
                export const OrderUpdateUserId: string;
                export const OrderVendorId: string;
                export const SettelmentId: string;
                export const ShareAmount: string;
                export const SharePercentage: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace OrderFranchiseeShareCalculation {
                export const ESettelementStatus: string;
                export const FranchiseeAddress: string;
                export const FranchiseeAlternateEmail: string;
                export const FranchiseeAlternateMobile: string;
                export const FranchiseeBankAccountName: string;
                export const FranchiseeBankAccountNo: string;
                export const FranchiseeBankAccountType: string;
                export const FranchiseeBankIfscCode: string;
                export const FranchiseeBankName: string;
                export const FranchiseeCity: string;
                export const FranchiseeCustomerId: string;
                export const FranchiseeDescription: string;
                export const FranchiseeDiscountCoupon: string;
                export const FranchiseeEmail: string;
                export const FranchiseeGstCertificate: string;
                export const FranchiseeGstin: string;
                export const FranchiseeId: string;
                export const FranchiseeInsertDate: string;
                export const FranchiseeInsertUserId: string;
                export const FranchiseeIsActive: string;
                export const FranchiseeIsCustomer: string;
                export const FranchiseeIsPostPayAllowed: string;
                export const FranchiseeMobile: string;
                export const FranchiseeName: string;
                export const FranchiseePan: string;
                export const FranchiseePincode: string;
                export const FranchiseeStateId: string;
                export const FranchiseeUpdateDate: string;
                export const FranchiseeUpdateUserId: string;
                export const FranchiseeUserId: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const OrderBillingAddress1: string;
                export const OrderBillingAddress2: string;
                export const OrderBillingCity: string;
                export const OrderBillingPincode: string;
                export const OrderBillingStateId: string;
                export const OrderCustomerEmail1: string;
                export const OrderCustomerEmail2: string;
                export const OrderCustomerId: string;
                export const OrderCustomerMobile1: string;
                export const OrderCustomerMobile2: string;
                export const OrderCustomerName: string;
                export const OrderDiscountAmount: string;
                export const OrderDiscountCoupon: string;
                export const OrderDiscountPer: string;
                export const OrderEFranchiseeDiscount: string;
                export const OrderEFranchiseeDiscountType: string;
                export const OrderEInvoiceStatus: string;
                export const OrderEInvoiceTo: string;
                export const OrderEOrderProcessBy: string;
                export const OrderEOrderStatus: string;
                export const OrderEPaymentStatus: string;
                export const OrderEPaymentType: string;
                export const OrderEShippingStatus: string;
                export const OrderEShippingType: string;
                export const OrderESourceType: string;
                export const OrderEmailSendCount: string;
                export const OrderExpectedShippingDate: string;
                export const OrderFranchiseeDiscountAmount: string;
                export const OrderFranchiseeDiscountValue: string;
                export const OrderFranchiseeId: string;
                export const OrderGrossAmount: string;
                export const OrderGstin: string;
                export const OrderId: string;
                export const OrderInsertDate: string;
                export const OrderInsertUserId: string;
                export const OrderInvoiceCompanyId: string;
                export const OrderIsActive: string;
                export const OrderIsEmailSent: string;
                export const OrderLastEmailSentDate: string;
                export const OrderMailId: string;
                export const OrderNetAmount: string;
                export const OrderOrderDate: string;
                export const OrderOrderNumber: string;
                export const OrderProductsAllowedDevices: string;
                export const OrderProductsCost: string;
                export const OrderProductsDiscountAmt: string;
                export const OrderProductsDownloadUrl1: string;
                export const OrderProductsDownloadUrl2: string;
                export const OrderProductsEAccessStatus: string;
                export const OrderProductsEFranchiseeDiscountType: string;
                export const OrderProductsEOpens: string;
                export const OrderProductsESerialkeyStatus: string;
                export const OrderProductsEValidity: string;
                export const OrderProductsEValidityType: string;
                export const OrderProductsEWatchTime: string;
                export const OrderProductsFranchiseeDiscountAmount: string;
                export const OrderProductsFranchiseeDiscountValue: string;
                export const OrderProductsHasBooks: string;
                export const OrderProductsHasCourier: string;
                export const OrderProductsHasPendrive: string;
                export const OrderProductsId: string;
                export const OrderProductsInsertDate: string;
                export const OrderProductsInsertUserId: string;
                export const OrderProductsInvoiceCompanyId: string;
                export const OrderProductsIsActive: string;
                export const OrderProductsIsLive: string;
                export const OrderProductsIsTemplateSerialKey: string;
                export const OrderProductsNetAmount: string;
                export const OrderProductsNote: string;
                export const OrderProductsOrderId: string;
                export const OrderProductsProductId: string;
                export const OrderProductsQuantity: string;
                export const OrderProductsSerialKey: string;
                export const OrderProductsTaxableAmount: string;
                export const OrderProductsTotalAllowedDuration: string;
                export const OrderProductsUpdateDate: string;
                export const OrderProductsUpdateUserId: string;
                export const OrderProductsValidTill: string;
                export const OrderProdutcsGrossAmount: string;
                export const OrderShippingAddress1: string;
                export const OrderShippingAddress2: string;
                export const OrderShippingCity: string;
                export const OrderShippingNote: string;
                export const OrderShippingPincode: string;
                export const OrderShippingStateId: string;
                export const OrderShippingToName: string;
                export const OrderSourceName: string;
                export const OrderSourceOrderNumber: string;
                export const OrderTaxableAmount: string;
                export const OrderUpdateDate: string;
                export const OrderUpdateUserId: string;
                export const OrderVendorId: string;
                export const Quantity: string;
                export const SettelmentId: string;
                export const ShareAmount: string;
                export const SharePercentage: string;
                export const TotalShare: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace OrderGiftCards {
                export const Amount: string;
                export const BalanceAmount: string;
                export const GiftCardCouponCode: string;
                export const GiftCardId: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const OrderBillingAddress1: string;
                export const OrderBillingAddress2: string;
                export const OrderBillingCity: string;
                export const OrderBillingCountry: string;
                export const OrderBillingPincode: string;
                export const OrderBillingStateId: string;
                export const OrderCurrencyAmount: string;
                export const OrderCurrencyId: string;
                export const OrderCustomerEmail1: string;
                export const OrderCustomerEmail2: string;
                export const OrderCustomerId: string;
                export const OrderCustomerMobile1: string;
                export const OrderCustomerMobile2: string;
                export const OrderCustomerName: string;
                export const OrderDiscountAmount: string;
                export const OrderDiscountCoupon: string;
                export const OrderDiscountPer: string;
                export const OrderEFranchiseeDiscount: string;
                export const OrderEFranchiseeDiscountType: string;
                export const OrderEInvoiceStatus: string;
                export const OrderEInvoiceTo: string;
                export const OrderEOrderProcessBy: string;
                export const OrderEOrderStatus: string;
                export const OrderEPaymentStatus: string;
                export const OrderEPaymentType: string;
                export const OrderEShippingStatus: string;
                export const OrderEShippingType: string;
                export const OrderESourceType: string;
                export const OrderEmailSendCount: string;
                export const OrderExpectedShippingDate: string;
                export const OrderFranchiseeDiscountAmount: string;
                export const OrderFranchiseeDiscountValue: string;
                export const OrderFranchiseeId: string;
                export const OrderFreezeData: string;
                export const OrderGrossAmount: string;
                export const OrderGstin: string;
                export const OrderId: string;
                export const OrderInsertDate: string;
                export const OrderInsertUserId: string;
                export const OrderInvoiceCompanyId: string;
                export const OrderIsActive: string;
                export const OrderIsEmailSent: string;
                export const OrderLastEmailSentDate: string;
                export const OrderMailId: string;
                export const OrderMode: string;
                export const OrderNetAmount: string;
                export const OrderNetAmountAfterFrDiscount: string;
                export const OrderOrderDate: string;
                export const OrderOrderNumber: string;
                export const OrderShippingAddress1: string;
                export const OrderShippingAddress2: string;
                export const OrderShippingCity: string;
                export const OrderShippingCountry: string;
                export const OrderShippingNote: string;
                export const OrderShippingPincode: string;
                export const OrderShippingProviderId: string;
                export const OrderShippingStateId: string;
                export const OrderShippingToName: string;
                export const OrderSourceName: string;
                export const OrderSourceOrderNumber: string;
                export const OrderTaxAmount: string;
                export const OrderTaxableAmount: string;
                export const OrderUpdateDate: string;
                export const OrderUpdateUserId: string;
                export const OrderVendorId: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace OrderInstallments {
                export const Amount: string;
                export const EStatus: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const InstallmentDate: string;
                export const IsActive: string;
                export const Note: string;
                export const OrderBillingAddress1: string;
                export const OrderBillingAddress2: string;
                export const OrderBillingCity: string;
                export const OrderBillingCountry: string;
                export const OrderBillingPincode: string;
                export const OrderBillingStateId: string;
                export const OrderCurrencyAmount: string;
                export const OrderCurrencyId: string;
                export const OrderCustomerEmail1: string;
                export const OrderCustomerEmail2: string;
                export const OrderCustomerId: string;
                export const OrderCustomerMobile1: string;
                export const OrderCustomerMobile2: string;
                export const OrderCustomerName: string;
                export const OrderDiscountAmount: string;
                export const OrderDiscountCoupon: string;
                export const OrderDiscountPer: string;
                export const OrderEFranchiseeDiscount: string;
                export const OrderEFranchiseeDiscountType: string;
                export const OrderEInvoiceStatus: string;
                export const OrderEInvoiceTo: string;
                export const OrderEOrderProcessBy: string;
                export const OrderEOrderStatus: string;
                export const OrderEPaymentStatus: string;
                export const OrderEPaymentType: string;
                export const OrderEShippingStatus: string;
                export const OrderEShippingType: string;
                export const OrderESourceType: string;
                export const OrderEmailSendCount: string;
                export const OrderExpectedShippingDate: string;
                export const OrderFranchiseeDiscountAmount: string;
                export const OrderFranchiseeDiscountValue: string;
                export const OrderFranchiseeId: string;
                export const OrderFreezeData: string;
                export const OrderGrossAmount: string;
                export const OrderGstin: string;
                export const OrderId: string;
                export const OrderInsertDate: string;
                export const OrderInsertUserId: string;
                export const OrderInvoiceCompanyId: string;
                export const OrderIsActive: string;
                export const OrderIsEmailSent: string;
                export const OrderLastEmailSentDate: string;
                export const OrderMailId: string;
                export const OrderMode: string;
                export const OrderNetAmount: string;
                export const OrderNetAmountAfterFrDiscount: string;
                export const OrderOrderDate: string;
                export const OrderOrderNumber: string;
                export const OrderShippingAddress1: string;
                export const OrderShippingAddress2: string;
                export const OrderShippingCity: string;
                export const OrderShippingCountry: string;
                export const OrderShippingNote: string;
                export const OrderShippingPincode: string;
                export const OrderShippingProviderId: string;
                export const OrderShippingStateId: string;
                export const OrderShippingToName: string;
                export const OrderSourceName: string;
                export const OrderSourceOrderNumber: string;
                export const OrderTaxAmount: string;
                export const OrderTaxableAmount: string;
                export const OrderUpdateDate: string;
                export const OrderUpdateUserId: string;
                export const OrderVendorId: string;
                export const OutstandingAmount: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace OrderPayment {
                export const Amount: string;
                export const BankName: string;
                export const ChequeNumber: string;
                export const EPaymentMode: string;
                export const EStatus: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const Note: string;
                export const OrderBillingAddress1: string;
                export const OrderBillingAddress2: string;
                export const OrderBillingCity: string;
                export const OrderBillingPincode: string;
                export const OrderBillingStateId: string;
                export const OrderCustomerEmail1: string;
                export const OrderCustomerEmail2: string;
                export const OrderCustomerId: string;
                export const OrderCustomerMobile1: string;
                export const OrderCustomerMobile2: string;
                export const OrderCustomerName: string;
                export const OrderDiscountAmount: string;
                export const OrderDiscountCoupon: string;
                export const OrderDiscountPer: string;
                export const OrderEFranchiseeDiscount: string;
                export const OrderEFranchiseeDiscountType: string;
                export const OrderEInvoiceStatus: string;
                export const OrderEInvoiceTo: string;
                export const OrderEOrderProcessBy: string;
                export const OrderEOrderStatus: string;
                export const OrderEPaymentStatus: string;
                export const OrderEPaymentType: string;
                export const OrderEShippingStatus: string;
                export const OrderEShippingType: string;
                export const OrderESourceType: string;
                export const OrderEmailSendCount: string;
                export const OrderExpectedShippingDate: string;
                export const OrderFranchiseeDiscountAmount: string;
                export const OrderFranchiseeDiscountValue: string;
                export const OrderFranchiseeId: string;
                export const OrderGrossAmount: string;
                export const OrderGstin: string;
                export const OrderId: string;
                export const OrderInsertDate: string;
                export const OrderInsertUserId: string;
                export const OrderInvoiceCompanyId: string;
                export const OrderIsActive: string;
                export const OrderIsEmailSent: string;
                export const OrderLastEmailSentDate: string;
                export const OrderMailId: string;
                export const OrderNetAmount: string;
                export const OrderOrderDate: string;
                export const OrderOrderNumber: string;
                export const OrderShippingAddress1: string;
                export const OrderShippingAddress2: string;
                export const OrderShippingCity: string;
                export const OrderShippingNote: string;
                export const OrderShippingPincode: string;
                export const OrderShippingStateId: string;
                export const OrderShippingToName: string;
                export const OrderSourceName: string;
                export const OrderSourceOrderNumber: string;
                export const OrderTaxableAmount: string;
                export const OrderUpdateDate: string;
                export const OrderUpdateUserId: string;
                export const OrderVendorId: string;
                export const PaymentDate: string;
                export const TransactionId: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace OrderProductBillingItems {
                export const DiscountAmount: string;
                export const GrossAmount: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const InvoiceCompanyAddress: string;
                export const InvoiceCompanyFooterNote: string;
                export const InvoiceCompanyGstIn: string;
                export const InvoiceCompanyId: string;
                export const InvoiceCompanyInvoiceChangeDate: string;
                export const InvoiceCompanyInvoiceCode: string;
                export const InvoiceCompanyIsDefault: string;
                export const InvoiceCompanyIsTaxApplicable: string;
                export const InvoiceCompanyLogo1: string;
                export const InvoiceCompanyLogo2: string;
                export const InvoiceCompanyName: string;
                export const InvoiceCompanyStampImage: string;
                export const IsActive: string;
                export const NetAmount: string;
                export const OrderBillingAddress1: string;
                export const OrderBillingAddress2: string;
                export const OrderBillingCity: string;
                export const OrderBillingPincode: string;
                export const OrderBillingStateId: string;
                export const OrderCustomerEmail1: string;
                export const OrderCustomerEmail2: string;
                export const OrderCustomerId: string;
                export const OrderCustomerMobile1: string;
                export const OrderCustomerMobile2: string;
                export const OrderCustomerName: string;
                export const OrderDiscountAmount: string;
                export const OrderDiscountCoupon: string;
                export const OrderDiscountPer: string;
                export const OrderEFranchiseeDiscount: string;
                export const OrderEFranchiseeDiscountType: string;
                export const OrderEInvoiceStatus: string;
                export const OrderEInvoiceTo: string;
                export const OrderEOrderProcessBy: string;
                export const OrderEOrderStatus: string;
                export const OrderEPaymentStatus: string;
                export const OrderEPaymentType: string;
                export const OrderEShippingStatus: string;
                export const OrderEShippingType: string;
                export const OrderESourceType: string;
                export const OrderEmailSendCount: string;
                export const OrderExpectedShippingDate: string;
                export const OrderFranchiseeDiscountAmount: string;
                export const OrderFranchiseeDiscountValue: string;
                export const OrderFranchiseeId: string;
                export const OrderGrossAmount: string;
                export const OrderGstin: string;
                export const OrderId: string;
                export const OrderInsertDate: string;
                export const OrderInsertUserId: string;
                export const OrderInvoiceCompanyId: string;
                export const OrderIsActive: string;
                export const OrderIsEmailSent: string;
                export const OrderLastEmailSentDate: string;
                export const OrderMailId: string;
                export const OrderNetAmount: string;
                export const OrderOrderDate: string;
                export const OrderOrderNumber: string;
                export const OrderProductBillingItemsTax: string;
                export const OrderProductsAllowedDevices: string;
                export const OrderProductsCost: string;
                export const OrderProductsDiscountAmt: string;
                export const OrderProductsDownloadUrl1: string;
                export const OrderProductsDownloadUrl2: string;
                export const OrderProductsEAccessStatus: string;
                export const OrderProductsEFranchiseeDiscountType: string;
                export const OrderProductsEOpens: string;
                export const OrderProductsESerialkeyStatus: string;
                export const OrderProductsEValidity: string;
                export const OrderProductsEValidityType: string;
                export const OrderProductsEWatchTime: string;
                export const OrderProductsFranchiseeDiscountAmount: string;
                export const OrderProductsFranchiseeDiscountValue: string;
                export const OrderProductsGrossAmount: string;
                export const OrderProductsHasBooks: string;
                export const OrderProductsHasCourier: string;
                export const OrderProductsHasPendrive: string;
                export const OrderProductsId: string;
                export const OrderProductsInsertDate: string;
                export const OrderProductsInsertUserId: string;
                export const OrderProductsInvoiceCompanyId: string;
                export const OrderProductsIsActive: string;
                export const OrderProductsIsLive: string;
                export const OrderProductsIsTemplateSerialKey: string;
                export const OrderProductsNetAmount: string;
                export const OrderProductsNote: string;
                export const OrderProductsOrderId: string;
                export const OrderProductsProductId: string;
                export const OrderProductsQuantity: string;
                export const OrderProductsSerialKey: string;
                export const OrderProductsTaxableAmount: string;
                export const OrderProductsTotalAllowedDuration: string;
                export const OrderProductsUpdateDate: string;
                export const OrderProductsUpdateUserId: string;
                export const OrderProductsValidTill: string;
                export const OrderShippingAddress1: string;
                export const OrderShippingAddress2: string;
                export const OrderShippingCity: string;
                export const OrderShippingNote: string;
                export const OrderShippingPincode: string;
                export const OrderShippingStateId: string;
                export const OrderShippingToName: string;
                export const OrderSourceName: string;
                export const OrderSourceOrderNumber: string;
                export const OrderTaxableAmount: string;
                export const OrderUpdateDate: string;
                export const OrderUpdateUserId: string;
                export const OrderVendorId: string;
                export const ProductBillingItemBillingItemName: string;
                export const ProductBillingItemEDiscountType: string;
                export const ProductBillingItemEndDate: string;
                export const ProductBillingItemGrossAmount: string;
                export const ProductBillingItemHsnMasterId: string;
                export const ProductBillingItemId: string;
                export const ProductBillingItemIncludingTax: string;
                export const ProductBillingItemInsertDate: string;
                export const ProductBillingItemInsertUserId: string;
                export const ProductBillingItemInvoiceCompanyId: string;
                export const ProductBillingItemIsActive: string;
                export const ProductBillingItemProductId: string;
                export const ProductBillingItemSpecialGrossAmount: string;
                export const ProductBillingItemStartDate: string;
                export const ProductBillingItemTaxCategoryId: string;
                export const ProductBillingItemUpdateDate: string;
                export const ProductBillingItemUpdateUserId: string;
                export const TaxCategoryId: string;
                export const TaxCategoryInsertDate: string;
                export const TaxCategoryInsertUserId: string;
                export const TaxCategoryIsActive: string;
                export const TaxCategoryName: string;
                export const TaxCategoryUpdateDate: string;
                export const TaxCategoryUpdateUserId: string;
                export const TaxableAmount: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace OrderProductBillingItemsTax {
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const OrderBillingAddress1: string;
                export const OrderBillingAddress2: string;
                export const OrderBillingCity: string;
                export const OrderBillingPincode: string;
                export const OrderBillingStateId: string;
                export const OrderCustomerEmail1: string;
                export const OrderCustomerEmail2: string;
                export const OrderCustomerId: string;
                export const OrderCustomerMobile1: string;
                export const OrderCustomerMobile2: string;
                export const OrderCustomerName: string;
                export const OrderDiscountAmount: string;
                export const OrderDiscountCoupon: string;
                export const OrderDiscountPer: string;
                export const OrderEFranchiseeDiscount: string;
                export const OrderEFranchiseeDiscountType: string;
                export const OrderEInvoiceStatus: string;
                export const OrderEInvoiceTo: string;
                export const OrderEOrderProcessBy: string;
                export const OrderEOrderStatus: string;
                export const OrderEPaymentStatus: string;
                export const OrderEPaymentType: string;
                export const OrderEShippingStatus: string;
                export const OrderEShippingType: string;
                export const OrderESourceType: string;
                export const OrderEmailSendCount: string;
                export const OrderExpectedShippingDate: string;
                export const OrderFranchiseeDiscountAmount: string;
                export const OrderFranchiseeDiscountValue: string;
                export const OrderFranchiseeId: string;
                export const OrderGrossAmount: string;
                export const OrderGstin: string;
                export const OrderId: string;
                export const OrderInsertDate: string;
                export const OrderInsertUserId: string;
                export const OrderInvoiceCompanyId: string;
                export const OrderIsActive: string;
                export const OrderIsEmailSent: string;
                export const OrderLastEmailSentDate: string;
                export const OrderMailId: string;
                export const OrderNetAmount: string;
                export const OrderOrderDate: string;
                export const OrderOrderNumber: string;
                export const OrderProductBillingItemsDiscountAmount: string;
                export const OrderProductBillingItemsGrossAmount: string;
                export const OrderProductBillingItemsId: string;
                export const OrderProductBillingItemsInsertDate: string;
                export const OrderProductBillingItemsInsertUserId: string;
                export const OrderProductBillingItemsInvoiceCompanyId: string;
                export const OrderProductBillingItemsIsActive: string;
                export const OrderProductBillingItemsNetAmount: string;
                export const OrderProductBillingItemsOrderId: string;
                export const OrderProductBillingItemsOrderProductsId: string;
                export const OrderProductBillingItemsProductBillingItemId: string;
                export const OrderProductBillingItemsTaxCategoryId: string;
                export const OrderProductBillingItemsUpdateDate: string;
                export const OrderProductBillingItemsUpdateUserId: string;
                export const OrderProductsAllowedDevices: string;
                export const OrderProductsCost: string;
                export const OrderProductsDiscountAmt: string;
                export const OrderProductsDownloadUrl1: string;
                export const OrderProductsDownloadUrl2: string;
                export const OrderProductsEAccessStatus: string;
                export const OrderProductsEFranchiseeDiscountType: string;
                export const OrderProductsEOpens: string;
                export const OrderProductsESerialkeyStatus: string;
                export const OrderProductsEValidity: string;
                export const OrderProductsEValidityType: string;
                export const OrderProductsEWatchTime: string;
                export const OrderProductsFranchiseeDiscountAmount: string;
                export const OrderProductsFranchiseeDiscountValue: string;
                export const OrderProductsGrossAmount: string;
                export const OrderProductsHasBooks: string;
                export const OrderProductsHasCourier: string;
                export const OrderProductsHasPendrive: string;
                export const OrderProductsId: string;
                export const OrderProductsInsertDate: string;
                export const OrderProductsInsertUserId: string;
                export const OrderProductsInvoiceCompanyId: string;
                export const OrderProductsIsActive: string;
                export const OrderProductsIsLive: string;
                export const OrderProductsIsTemplateSerialKey: string;
                export const OrderProductsNetAmount: string;
                export const OrderProductsNote: string;
                export const OrderProductsOrderId: string;
                export const OrderProductsProductId: string;
                export const OrderProductsQuantity: string;
                export const OrderProductsSerialKey: string;
                export const OrderProductsTaxableAmount: string;
                export const OrderProductsTotalAllowedDuration: string;
                export const OrderProductsUpdateDate: string;
                export const OrderProductsUpdateUserId: string;
                export const OrderProductsValidTill: string;
                export const OrderShippingAddress1: string;
                export const OrderShippingAddress2: string;
                export const OrderShippingCity: string;
                export const OrderShippingNote: string;
                export const OrderShippingPincode: string;
                export const OrderShippingStateId: string;
                export const OrderShippingToName: string;
                export const OrderSourceName: string;
                export const OrderSourceOrderNumber: string;
                export const OrderTaxableAmount: string;
                export const OrderUpdateDate: string;
                export const OrderUpdateUserId: string;
                export const OrderVendorId: string;
                export const Rate: string;
                export const TaxAmount: string;
                export const TaxTypeId: string;
                export const TaxTypeName: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace OrderProductSpecifications {
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const OrderBillingAddress1: string;
                export const OrderBillingAddress2: string;
                export const OrderBillingCity: string;
                export const OrderBillingPincode: string;
                export const OrderBillingStateId: string;
                export const OrderCustomerEmail1: string;
                export const OrderCustomerEmail2: string;
                export const OrderCustomerId: string;
                export const OrderCustomerMobile1: string;
                export const OrderCustomerMobile2: string;
                export const OrderCustomerName: string;
                export const OrderDiscountAmount: string;
                export const OrderDiscountCoupon: string;
                export const OrderDiscountPer: string;
                export const OrderEFranchiseeDiscount: string;
                export const OrderEFranchiseeDiscountType: string;
                export const OrderEInvoiceStatus: string;
                export const OrderEInvoiceTo: string;
                export const OrderEOrderProcessBy: string;
                export const OrderEOrderStatus: string;
                export const OrderEPaymentStatus: string;
                export const OrderEPaymentType: string;
                export const OrderEShippingStatus: string;
                export const OrderEShippingType: string;
                export const OrderESourceType: string;
                export const OrderEmailSendCount: string;
                export const OrderExpectedShippingDate: string;
                export const OrderFranchiseeDiscountAmount: string;
                export const OrderFranchiseeDiscountValue: string;
                export const OrderFranchiseeId: string;
                export const OrderGrossAmount: string;
                export const OrderGstin: string;
                export const OrderId: string;
                export const OrderInsertDate: string;
                export const OrderInsertUserId: string;
                export const OrderInvoiceCompanyId: string;
                export const OrderIsActive: string;
                export const OrderIsEmailSent: string;
                export const OrderLastEmailSentDate: string;
                export const OrderMailId: string;
                export const OrderNetAmount: string;
                export const OrderOrderDate: string;
                export const OrderOrderNumber: string;
                export const OrderProductsAllowedDevices: string;
                export const OrderProductsCost: string;
                export const OrderProductsDiscountAmt: string;
                export const OrderProductsDownloadUrl1: string;
                export const OrderProductsDownloadUrl2: string;
                export const OrderProductsEAccessStatus: string;
                export const OrderProductsEFranchiseeDiscountType: string;
                export const OrderProductsEOpens: string;
                export const OrderProductsESerialkeyStatus: string;
                export const OrderProductsEValidity: string;
                export const OrderProductsEValidityType: string;
                export const OrderProductsEWatchTime: string;
                export const OrderProductsFranchiseeDiscountAmount: string;
                export const OrderProductsFranchiseeDiscountValue: string;
                export const OrderProductsGrossAmount: string;
                export const OrderProductsHasBooks: string;
                export const OrderProductsHasCourier: string;
                export const OrderProductsHasPendrive: string;
                export const OrderProductsId: string;
                export const OrderProductsInsertDate: string;
                export const OrderProductsInsertUserId: string;
                export const OrderProductsInvoiceCompanyId: string;
                export const OrderProductsIsActive: string;
                export const OrderProductsIsLive: string;
                export const OrderProductsIsTemplateSerialKey: string;
                export const OrderProductsNetAmount: string;
                export const OrderProductsNote: string;
                export const OrderProductsOrderId: string;
                export const OrderProductsProductId: string;
                export const OrderProductsQuantity: string;
                export const OrderProductsSerialKey: string;
                export const OrderProductsTaxableAmount: string;
                export const OrderProductsTotalAllowedDuration: string;
                export const OrderProductsUpdateDate: string;
                export const OrderProductsUpdateUserId: string;
                export const OrderProductsValidTill: string;
                export const OrderShippingAddress1: string;
                export const OrderShippingAddress2: string;
                export const OrderShippingCity: string;
                export const OrderShippingNote: string;
                export const OrderShippingPincode: string;
                export const OrderShippingStateId: string;
                export const OrderShippingToName: string;
                export const OrderSourceName: string;
                export const OrderSourceOrderNumber: string;
                export const OrderTaxableAmount: string;
                export const OrderUpdateDate: string;
                export const OrderUpdateUserId: string;
                export const OrderVendorId: string;
                export const ProductSpecificationAllowedDevices: string;
                export const ProductSpecificationEValidity: string;
                export const ProductSpecificationEValidityType: string;
                export const ProductSpecificationEWatchtime: string;
                export const ProductSpecificationEopens: string;
                export const ProductSpecificationHasBooks: string;
                export const ProductSpecificationHasCourier: string;
                export const ProductSpecificationHasPendrive: string;
                export const ProductSpecificationId: string;
                export const ProductSpecificationInsertDate: string;
                export const ProductSpecificationInsertUserId: string;
                export const ProductSpecificationIsLive: string;
                export const ProductSpecificationProcessOrderOnPaid: string;
                export const ProductSpecificationProductId: string;
                export const ProductSpecificationSpecificationCode: string;
                export const ProductSpecificationSpecificationName: string;
                export const ProductSpecificationUpdateDate: string;
                export const ProductSpecificationUpdateUserId: string;
                export const ProductSpecificationValidTill: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace OrderProducts {
                export const AllowedDevice: string;
                export const AllowedDevices: string;
                export const Cost: string;
                export const DiscountAmt: string;
                export const DownloadUrl1: string;
                export const DownloadUrl2: string;
                export const EAccessStatus: string;
                export const EFranchiseeDiscountType: string;
                export const EOpens: string;
                export const ERioplayVersion: string;
                export const ESerialkeyStatus: string;
                export const EValidity: string;
                export const EValidityType: string;
                export const EWatchTime: string;
                export const FranchiseeDiscountAmount: string;
                export const FranchiseeDiscountValue: string;
                export const FranchiseeId: string;
                export const GrossAmount: string;
                export const HasBooks: string;
                export const HasCourier: string;
                export const HasPendrive: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const InvoiceCompanyAddress: string;
                export const InvoiceCompanyFooterNote: string;
                export const InvoiceCompanyGstIn: string;
                export const InvoiceCompanyId: string;
                export const InvoiceCompanyInvoiceChangeDate: string;
                export const InvoiceCompanyInvoiceCode: string;
                export const InvoiceCompanyIsDefault: string;
                export const InvoiceCompanyIsTaxApplicable: string;
                export const InvoiceCompanyLogo1: string;
                export const InvoiceCompanyLogo2: string;
                export const InvoiceCompanyName: string;
                export const InvoiceCompanyStampImage: string;
                export const IsActive: string;
                export const IsLive: string;
                export const IsTemplateSerialKey: string;
                export const NetAmount: string;
                export const NetAmountAfterFrDiscount: string;
                export const Note: string;
                export const OrderBillingAddress1: string;
                export const OrderBillingAddress2: string;
                export const OrderBillingCity: string;
                export const OrderBillingPincode: string;
                export const OrderBillingStateId: string;
                export const OrderCustomerEmail1: string;
                export const OrderCustomerEmail2: string;
                export const OrderCustomerId: string;
                export const OrderCustomerMobile1: string;
                export const OrderCustomerMobile2: string;
                export const OrderCustomerName: string;
                export const OrderDiscountAmount: string;
                export const OrderDiscountCoupon: string;
                export const OrderDiscountPer: string;
                export const OrderEFranchiseeDiscount: string;
                export const OrderEFranchiseeDiscountType: string;
                export const OrderEInvoiceStatus: string;
                export const OrderEInvoiceTo: string;
                export const OrderEOrderProcessBy: string;
                export const OrderEOrderStatus: string;
                export const OrderEPaymentStatus: string;
                export const OrderEPaymentType: string;
                export const OrderEShippingStatus: string;
                export const OrderEShippingType: string;
                export const OrderESourceType: string;
                export const OrderEmailSendCount: string;
                export const OrderExpectedShippingDate: string;
                export const OrderFranchiseeDiscountAmount: string;
                export const OrderFranchiseeDiscountValue: string;
                export const OrderFranchiseeId: string;
                export const OrderGrossAmount: string;
                export const OrderGstin: string;
                export const OrderId: string;
                export const OrderInsertDate: string;
                export const OrderInsertUserId: string;
                export const OrderInvoiceCompanyId: string;
                export const OrderIsActive: string;
                export const OrderIsEmailSent: string;
                export const OrderLastEmailSentDate: string;
                export const OrderMailId: string;
                export const OrderNetAmount: string;
                export const OrderOrderDate: string;
                export const OrderOrderNumber: string;
                export const OrderProduct: string;
                export const OrderProductSpecificationId: string;
                export const OrderShippingAddress1: string;
                export const OrderShippingAddress2: string;
                export const OrderShippingCity: string;
                export const OrderShippingNote: string;
                export const OrderShippingPincode: string;
                export const OrderShippingStateId: string;
                export const OrderShippingToName: string;
                export const OrderSourceName: string;
                export const OrderSourceOrderNumber: string;
                export const OrderTaxableAmount: string;
                export const OrderUpdateDate: string;
                export const OrderUpdateUserId: string;
                export const OrderVendorId: string;
                export const ProductActivateSerialKey: string;
                export const ProductAllowSerialKeyGeneration: string;
                export const ProductAllowedDevices: string;
                export const ProductDescription: string;
                export const ProductDownloadUrl1: string;
                export const ProductDownloadUrl2: string;
                export const ProductEAccessStatus: string;
                export const ProductEOpens: string;
                export const ProductEPackingType: string;
                export const ProductEProductType: string;
                export const ProductERioplayVersion: string;
                export const ProductEShippedby: string;
                export const ProductEValidity: string;
                export const ProductEValidityType: string;
                export const ProductEWatchTime: string;
                export const ProductGrossAmount: string;
                export const ProductHasBooks: string;
                export const ProductHasCourier: string;
                export const ProductHasPenDrive: string;
                export const ProductHasVod: string;
                export const ProductHeight: string;
                export const ProductId: string;
                export const ProductInAppDownload: string;
                export const ProductInsertDate: string;
                export const ProductInsertUserId: string;
                export const ProductIsActive: string;
                export const ProductIsCombo: string;
                export const ProductIsLive: string;
                export const ProductLength: string;
                export const ProductNote: string;
                export const ProductProcesOrderOnPaid: string;
                export const ProductProductIds: string;
                export const ProductProductName: string;
                export const ProductProductQueryInfo: string;
                export const ProductRioplayProductCode: string;
                export const ProductSkuCode: string;
                export const ProductSupportInfo: string;
                export const ProductTeacherName: string;
                export const ProductTemplateSerialKeyId: string;
                export const ProductTotalAllowedDuration: string;
                export const ProductUpdateDate: string;
                export const ProductUpdateUserId: string;
                export const ProductValidTill: string;
                export const ProductVendorId: string;
                export const ProductWebsiteUrl: string;
                export const ProductWeight: string;
                export const ProductWidth: string;
                export const Quantity: string;
                export const Rioplay8AllowedDevices: string;
                export const Rioplay8DeviceCount: string;
                export const Rioplay8EDeviceRestrictionType: string;
                export const Rioplay8ESubscriptionType: string;
                export const Rioplay8EViewsType: string;
                export const Rioplay8EWatchTimetype: string;
                export const Rioplay8ProductCode: string;
                export const Rioplay8SwitchCount: string;
                export const Rioplay8TenantId: string;
                export const Rioplay8ValidDate: string;
                export const Rioplay8ValidityInDays: string;
                export const Rioplay8ViewsPerContent: string;
                export const Rioplay8WatchTime: string;
                export const SerialKey: string;
                export const TaxAmount: string;
                export const TaxableAmount: string;
                export const TotalAllowedDuration: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
                export const ValidTill: string;
            }

            namespace OrderShipping {
                export const CustomerName: string;
                export const EStatus: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const OrderBillingAddress1: string;
                export const OrderBillingAddress2: string;
                export const OrderBillingCity: string;
                export const OrderBillingPincode: string;
                export const OrderBillingStateId: string;
                export const OrderCustomerEmail1: string;
                export const OrderCustomerEmail2: string;
                export const OrderCustomerId: string;
                export const OrderCustomerMobile1: string;
                export const OrderCustomerMobile2: string;
                export const OrderCustomerName: string;
                export const OrderDiscountAmount: string;
                export const OrderDiscountCoupon: string;
                export const OrderDiscountPer: string;
                export const OrderEFranchiseeDiscount: string;
                export const OrderEFranchiseeDiscountType: string;
                export const OrderEInvoiceStatus: string;
                export const OrderEInvoiceTo: string;
                export const OrderEOrderProcessBy: string;
                export const OrderEOrderStatus: string;
                export const OrderEPaymentStatus: string;
                export const OrderEPaymentType: string;
                export const OrderEShippingStatus: string;
                export const OrderEShippingType: string;
                export const OrderESourceType: string;
                export const OrderEmailSendCount: string;
                export const OrderExpectedShippingDate: string;
                export const OrderFranchiseeDiscountAmount: string;
                export const OrderFranchiseeDiscountValue: string;
                export const OrderFranchiseeId: string;
                export const OrderGrossAmount: string;
                export const OrderGstin: string;
                export const OrderId: string;
                export const OrderInsertDate: string;
                export const OrderInsertUserId: string;
                export const OrderInvoiceCompanyId: string;
                export const OrderIsActive: string;
                export const OrderIsEmailSent: string;
                export const OrderLastEmailSentDate: string;
                export const OrderMailId: string;
                export const OrderNetAmount: string;
                export const OrderOrderDate: string;
                export const OrderOrderNumber: string;
                export const OrderShippingAddress1: string;
                export const OrderShippingAddress2: string;
                export const OrderShippingCity: string;
                export const OrderShippingNote: string;
                export const OrderShippingPincode: string;
                export const OrderShippingStateId: string;
                export const OrderShippingToName: string;
                export const OrderSourceName: string;
                export const OrderSourceOrderNumber: string;
                export const OrderTaxableAmount: string;
                export const OrderUpdateDate: string;
                export const OrderUpdateUserId: string;
                export const OrderVendorId: string;
                export const OrdershippingBooks: string;
                export const OrdershippingPendrives: string;
                export const ShippingCost: string;
                export const ShippingDate: string;
                export const ShippingProviderBankAccountNo: string;
                export const ShippingProviderBankIfscCode: string;
                export const ShippingProviderBankName: string;
                export const ShippingProviderDescription: string;
                export const ShippingProviderEApiStatus: string;
                export const ShippingProviderEShippingProviderType: string;
                export const ShippingProviderGstCertificate: string;
                export const ShippingProviderGstin: string;
                export const ShippingProviderId: string;
                export const ShippingProviderInsertDate: string;
                export const ShippingProviderInsertUserId: string;
                export const ShippingProviderIsActive: string;
                export const ShippingProviderIsDefault: string;
                export const ShippingProviderPan: string;
                export const ShippingProviderSecret: string;
                export const ShippingProviderShippingProviderName: string;
                export const ShippingProviderTrackingUrl: string;
                export const ShippingProviderUpdateDate: string;
                export const ShippingProviderUpdateUserId: string;
                export const ShippingProviderVendorId: string;
                export const TrackingId: string;
                export const TrackingUrl: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace OrderTeacherShareCalculation {
                export const ESettelementStatus: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const OrderBillingAddress1: string;
                export const OrderBillingAddress2: string;
                export const OrderBillingCity: string;
                export const OrderBillingPincode: string;
                export const OrderBillingStateId: string;
                export const OrderCustomerEmail1: string;
                export const OrderCustomerEmail2: string;
                export const OrderCustomerId: string;
                export const OrderCustomerMobile1: string;
                export const OrderCustomerMobile2: string;
                export const OrderCustomerName: string;
                export const OrderDiscountAmount: string;
                export const OrderDiscountCoupon: string;
                export const OrderDiscountPer: string;
                export const OrderEFranchiseeDiscount: string;
                export const OrderEFranchiseeDiscountType: string;
                export const OrderEInvoiceStatus: string;
                export const OrderEInvoiceTo: string;
                export const OrderEOrderProcessBy: string;
                export const OrderEOrderStatus: string;
                export const OrderEPaymentStatus: string;
                export const OrderEPaymentType: string;
                export const OrderEShippingStatus: string;
                export const OrderEShippingType: string;
                export const OrderESourceType: string;
                export const OrderEmailSendCount: string;
                export const OrderExpectedShippingDate: string;
                export const OrderFranchiseeDiscountAmount: string;
                export const OrderFranchiseeDiscountValue: string;
                export const OrderFranchiseeId: string;
                export const OrderGrossAmount: string;
                export const OrderGstin: string;
                export const OrderId: string;
                export const OrderInsertDate: string;
                export const OrderInsertUserId: string;
                export const OrderInvoiceCompanyId: string;
                export const OrderIsActive: string;
                export const OrderIsEmailSent: string;
                export const OrderLastEmailSentDate: string;
                export const OrderMailId: string;
                export const OrderNetAmount: string;
                export const OrderOrderDate: string;
                export const OrderOrderNumber: string;
                export const OrderProductsAllowedDevices: string;
                export const OrderProductsCost: string;
                export const OrderProductsDiscountAmt: string;
                export const OrderProductsDownloadUrl1: string;
                export const OrderProductsDownloadUrl2: string;
                export const OrderProductsEAccessStatus: string;
                export const OrderProductsEFranchiseeDiscountType: string;
                export const OrderProductsEOpens: string;
                export const OrderProductsESerialkeyStatus: string;
                export const OrderProductsEValidity: string;
                export const OrderProductsEValidityType: string;
                export const OrderProductsEWatchTime: string;
                export const OrderProductsFranchiseeDiscountAmount: string;
                export const OrderProductsFranchiseeDiscountValue: string;
                export const OrderProductsGrossAmount: string;
                export const OrderProductsHasBooks: string;
                export const OrderProductsHasCourier: string;
                export const OrderProductsHasPendrive: string;
                export const OrderProductsId: string;
                export const OrderProductsInsertDate: string;
                export const OrderProductsInsertUserId: string;
                export const OrderProductsInvoiceCompanyId: string;
                export const OrderProductsIsActive: string;
                export const OrderProductsIsLive: string;
                export const OrderProductsIsTemplateSerialKey: string;
                export const OrderProductsNetAmount: string;
                export const OrderProductsNote: string;
                export const OrderProductsOrderId: string;
                export const OrderProductsProductId: string;
                export const OrderProductsQuantity: string;
                export const OrderProductsSerialKey: string;
                export const OrderProductsTaxableAmount: string;
                export const OrderProductsTotalAllowedDuration: string;
                export const OrderProductsUpdateDate: string;
                export const OrderProductsUpdateUserId: string;
                export const OrderProductsValidTill: string;
                export const OrderProdutcsCost: string;
                export const OrderShippingAddress1: string;
                export const OrderShippingAddress2: string;
                export const OrderShippingCity: string;
                export const OrderShippingNote: string;
                export const OrderShippingPincode: string;
                export const OrderShippingStateId: string;
                export const OrderShippingToName: string;
                export const OrderSourceName: string;
                export const OrderSourceOrderNumber: string;
                export const OrderTaxableAmount: string;
                export const OrderUpdateDate: string;
                export const OrderUpdateUserId: string;
                export const OrderVendorId: string;
                export const Qty: string;
                export const SettelmentId: string;
                export const ShareAmount: string;
                export const SharePercentage: string;
                export const TeacherAddress: string;
                export const TeacherAlternateEmail: string;
                export const TeacherAlternateMobile: string;
                export const TeacherBankAccountName: string;
                export const TeacherBankAccountNo: string;
                export const TeacherBankAccountType: string;
                export const TeacherBankIfscCode: string;
                export const TeacherBankName: string;
                export const TeacherCity: string;
                export const TeacherDescription: string;
                export const TeacherEmail: string;
                export const TeacherGstCertificate: string;
                export const TeacherGstin: string;
                export const TeacherId: string;
                export const TeacherInsertDate: string;
                export const TeacherInsertUserId: string;
                export const TeacherIsActive: string;
                export const TeacherMobile: string;
                export const TeacherName: string;
                export const TeacherPan: string;
                export const TeacherPincode: string;
                export const TeacherStateId: string;
                export const TeacherUpdateDate: string;
                export const TeacherUpdateUserId: string;
                export const TeacherUserId: string;
                export const TotalShare: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace OrderWebhook {
                export const ErrorNote: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const IsSynced: string;
                export const OrderId: string;
                export const Orderguid: string;
                export const SiteName: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
                export const hasError: string;
            }

            namespace Orders {
                export const BillingAddress1: string;
                export const BillingAddress2: string;
                export const BillingCity: string;
                export const BillingCountry: string;
                export const BillingPincode: string;
                export const BillingStateId: string;
                export const BillingStateInsertDate: string;
                export const BillingStateInsertUserId: string;
                export const BillingStateIsActive: string;
                export const BillingStateIsHomeState: string;
                export const BillingStateName: string;
                export const BillingStateUpdateDate: string;
                export const BillingStateUpdateUserId: string;
                export const CalculationCurrency: string;
                export const CartId: string;
                export const CurrencyAmount: string;
                export const CurrencyId: string;
                export const CustomerCouponCode: string;
                export const CustomerDisplayName: string;
                export const CustomerECustomerType: string;
                export const CustomerEmail1: string;
                export const CustomerEmail2: string;
                export const CustomerGstin: string;
                export const CustomerId: string;
                export const CustomerInsertDate: string;
                export const CustomerInsertUserId: string;
                export const CustomerIsActive: string;
                export const CustomerMobile11: string;
                export const CustomerMobile21: string;
                export const CustomerName1: string;
                export const CustomerUpdateDate: string;
                export const CustomerUpdateUserId: string;
                export const DiscountAmount: string;
                export const DiscountCoupon: string;
                export const DiscountPer: string;
                export const EFranchiseeDiscount: string;
                export const EFranchiseeDiscountType: string;
                export const EInvoiceStatus: string;
                export const EInvoiceTo: string;
                export const EOrderProcessBy: string;
                export const EOrderStatus: string;
                export const EPaymentStatus: string;
                export const EPaymentType: string;
                export const EShippingStatus: string;
                export const EShippingType: string;
                export const ESourceType: string;
                export const EmailSendCount: string;
                export const ExpectedShippingDate: string;
                export const FranchiseeAddress: string;
                export const FranchiseeAlternateEmail: string;
                export const FranchiseeAlternateMobile: string;
                export const FranchiseeBankAccountName: string;
                export const FranchiseeBankAccountNo: string;
                export const FranchiseeBankAccountType: string;
                export const FranchiseeBankIfscCode: string;
                export const FranchiseeBankName: string;
                export const FranchiseeCity: string;
                export const FranchiseeCustomerId: string;
                export const FranchiseeDescription: string;
                export const FranchiseeDiscountAmount: string;
                export const FranchiseeDiscountCoupon: string;
                export const FranchiseeDiscountValue: string;
                export const FranchiseeEmail: string;
                export const FranchiseeGstCertificate: string;
                export const FranchiseeGstin: string;
                export const FranchiseeId: string;
                export const FranchiseeInsertDate: string;
                export const FranchiseeInsertUserId: string;
                export const FranchiseeIsActive: string;
                export const FranchiseeIsCustomer: string;
                export const FranchiseeIsPostPayAllowed: string;
                export const FranchiseeMobile: string;
                export const FranchiseeName: string;
                export const FranchiseePan: string;
                export const FranchiseePincode: string;
                export const FranchiseeStateId: string;
                export const FranchiseeUpdateDate: string;
                export const FranchiseeUpdateUserId: string;
                export const FranchiseeUserId: string;
                export const FreezeData: string;
                export const GrossAmount: string;
                export const Gstin: string;
                export const HasBooks: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const InvoiceCompanyAddress: string;
                export const InvoiceCompanyFooterNote: string;
                export const InvoiceCompanyGstIn: string;
                export const InvoiceCompanyId: string;
                export const InvoiceCompanyInvoiceChangeDate: string;
                export const InvoiceCompanyInvoiceCode: string;
                export const InvoiceCompanyIsDefault: string;
                export const InvoiceCompanyIsTaxApplicable: string;
                export const InvoiceCompanyLogo1: string;
                export const InvoiceCompanyLogo2: string;
                export const InvoiceCompanyName: string;
                export const InvoiceCompanyStampImage: string;
                export const IsActive: string;
                export const IsEmailSent: string;
                export const LastEmailSentDate: string;
                export const Level: string;
                export const MailId: string;
                export const Mode: string;
                export const NetAmount: string;
                export const NetAmountAfterFrDiscount: string;
                export const Note: string;
                export const OrderDate: string;
                export const OrderInstallments: string;
                export const OrderNumber: string;
                export const OrderProducts: string;
                export const ShippingAddress1: string;
                export const ShippingAddress2: string;
                export const ShippingCity: string;
                export const ShippingCountry: string;
                export const ShippingNote: string;
                export const ShippingPincode: string;
                export const ShippingProviderId: string;
                export const ShippingProviderName: string;
                export const ShippingStateId: string;
                export const ShippingStateInsertDate: string;
                export const ShippingStateInsertUserId: string;
                export const ShippingStateIsActive: string;
                export const ShippingStateIsHomeState: string;
                export const ShippingStateName: string;
                export const ShippingStateUpdateDate: string;
                export const ShippingStateUpdateUserId: string;
                export const ShippingToName: string;
                export const SourceName: string;
                export const SourceOrderNumber: string;
                export const TaxAmount: string;
                export const TaxableAmount: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
                export const VendorAddress: string;
                export const VendorBankAccountName: string;
                export const VendorBankAccountNo: string;
                export const VendorBankAccountType: string;
                export const VendorBankIfscCode: string;
                export const VendorBankName: string;
                export const VendorCity: string;
                export const VendorCountry: string;
                export const VendorDescription: string;
                export const VendorEmail: string;
                export const VendorGstCertificate: string;
                export const VendorGstin: string;
                export const VendorId: string;
                export const VendorInsertDate: string;
                export const VendorInsertUserId: string;
                export const VendorIsActive: string;
                export const VendorName: string;
                export const VendorPan: string;
                export const VendorPincode: string;
                export const VendorStateId: string;
                export const VendorUpdateDate: string;
                export const VendorUpdateUserId: string;
                export const VendorUserId: string;
                export const WebsiteOrderProducts: string;
                export const eBookStatus: string;
            }

            namespace OrdershippingBooks {
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const OrderBillingAddress1: string;
                export const OrderBillingAddress2: string;
                export const OrderBillingCity: string;
                export const OrderBillingPincode: string;
                export const OrderBillingStateId: string;
                export const OrderCustomerEmail1: string;
                export const OrderCustomerEmail2: string;
                export const OrderCustomerId: string;
                export const OrderCustomerMobile1: string;
                export const OrderCustomerMobile2: string;
                export const OrderCustomerName: string;
                export const OrderDiscountAmount: string;
                export const OrderDiscountCoupon: string;
                export const OrderDiscountPer: string;
                export const OrderEFranchiseeDiscount: string;
                export const OrderEFranchiseeDiscountType: string;
                export const OrderEInvoiceStatus: string;
                export const OrderEInvoiceTo: string;
                export const OrderEOrderProcessBy: string;
                export const OrderEOrderStatus: string;
                export const OrderEPaymentStatus: string;
                export const OrderEPaymentType: string;
                export const OrderEShippingStatus: string;
                export const OrderEShippingType: string;
                export const OrderESourceType: string;
                export const OrderEmailSendCount: string;
                export const OrderExpectedShippingDate: string;
                export const OrderFranchiseeDiscountAmount: string;
                export const OrderFranchiseeDiscountValue: string;
                export const OrderFranchiseeId: string;
                export const OrderGrossAmount: string;
                export const OrderGstin: string;
                export const OrderId: string;
                export const OrderInsertDate: string;
                export const OrderInsertUserId: string;
                export const OrderInvoiceCompanyId: string;
                export const OrderIsActive: string;
                export const OrderIsEmailSent: string;
                export const OrderLastEmailSentDate: string;
                export const OrderMailId: string;
                export const OrderNetAmount: string;
                export const OrderOrderDate: string;
                export const OrderOrderNumber: string;
                export const OrderShippingAddress1: string;
                export const OrderShippingAddress2: string;
                export const OrderShippingCity: string;
                export const OrderShippingId: string;
                export const OrderShippingNote: string;
                export const OrderShippingPincode: string;
                export const OrderShippingStateId: string;
                export const OrderShippingToName: string;
                export const OrderSourceName: string;
                export const OrderSourceOrderNumber: string;
                export const OrderTaxableAmount: string;
                export const OrderUpdateDate: string;
                export const OrderUpdateUserId: string;
                export const OrderVendorId: string;
                export const OrdershippingBooksId: string;
                export const ProductActivateSerialKey: string;
                export const ProductAllowSerialKeyGeneration: string;
                export const ProductAllowedDevices: string;
                export const ProductBookid: string;
                export const ProductDescription: string;
                export const ProductDownloadUrl1: string;
                export const ProductDownloadUrl2: string;
                export const ProductEAccessStatus: string;
                export const ProductEOpens: string;
                export const ProductEPackingType: string;
                export const ProductEProductType: string;
                export const ProductERioplayVersion: string;
                export const ProductEShippedby: string;
                export const ProductEValidity: string;
                export const ProductEValidityType: string;
                export const ProductEWatchTime: string;
                export const ProductGrossAmount: string;
                export const ProductHasBooks: string;
                export const ProductHasCourier: string;
                export const ProductHasPenDrive: string;
                export const ProductHasVod: string;
                export const ProductHeight: string;
                export const ProductId: string;
                export const ProductInAppDownload: string;
                export const ProductInsertDate: string;
                export const ProductInsertUserId: string;
                export const ProductIsActive: string;
                export const ProductIsCombo: string;
                export const ProductIsLive: string;
                export const ProductLength: string;
                export const ProductNote: string;
                export const ProductProcesOrderOnPaid: string;
                export const ProductProductIds: string;
                export const ProductProductName: string;
                export const ProductProductQueryInfo: string;
                export const ProductRioplayProductCode: string;
                export const ProductSkuCode: string;
                export const ProductSupportInfo: string;
                export const ProductTeacherName: string;
                export const ProductTemplateSerialKeyId: string;
                export const ProductTotalAllowedDuration: string;
                export const ProductUpdateDate: string;
                export const ProductUpdateUserId: string;
                export const ProductValidTill: string;
                export const ProductVendorId: string;
                export const ProductWebsiteUrl: string;
                export const ProductWeight: string;
                export const ProductWidth: string;
                export const Quantity: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace OrdershippingPendrives {
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const OrderBillingAddress1: string;
                export const OrderBillingAddress2: string;
                export const OrderBillingCity: string;
                export const OrderBillingPincode: string;
                export const OrderBillingStateId: string;
                export const OrderCustomerEmail1: string;
                export const OrderCustomerEmail2: string;
                export const OrderCustomerId: string;
                export const OrderCustomerMobile1: string;
                export const OrderCustomerMobile2: string;
                export const OrderCustomerName: string;
                export const OrderDiscountAmount: string;
                export const OrderDiscountCoupon: string;
                export const OrderDiscountPer: string;
                export const OrderEFranchiseeDiscount: string;
                export const OrderEFranchiseeDiscountType: string;
                export const OrderEInvoiceStatus: string;
                export const OrderEInvoiceTo: string;
                export const OrderEOrderProcessBy: string;
                export const OrderEOrderStatus: string;
                export const OrderEPaymentStatus: string;
                export const OrderEPaymentType: string;
                export const OrderEShippingStatus: string;
                export const OrderEShippingType: string;
                export const OrderESourceType: string;
                export const OrderEmailSendCount: string;
                export const OrderExpectedShippingDate: string;
                export const OrderFranchiseeDiscountAmount: string;
                export const OrderFranchiseeDiscountValue: string;
                export const OrderFranchiseeId: string;
                export const OrderGrossAmount: string;
                export const OrderGstin: string;
                export const OrderId: string;
                export const OrderInsertDate: string;
                export const OrderInsertUserId: string;
                export const OrderInvoiceCompanyId: string;
                export const OrderIsActive: string;
                export const OrderIsEmailSent: string;
                export const OrderLastEmailSentDate: string;
                export const OrderMailId: string;
                export const OrderNetAmount: string;
                export const OrderOrderDate: string;
                export const OrderOrderNumber: string;
                export const OrderShippingAddress1: string;
                export const OrderShippingAddress2: string;
                export const OrderShippingCity: string;
                export const OrderShippingId: string;
                export const OrderShippingNote: string;
                export const OrderShippingPincode: string;
                export const OrderShippingStateId: string;
                export const OrderShippingToName: string;
                export const OrderSourceName: string;
                export const OrderSourceOrderNumber: string;
                export const OrderTaxableAmount: string;
                export const OrderUpdateDate: string;
                export const OrderUpdateUserId: string;
                export const OrderVendorId: string;
                export const OrdershippingPendrivesId: string;
                export const PenDriveTypeId: string;
                export const PendriveType: string;
                export const ProductActivateSerialKey: string;
                export const ProductAllowSerialKeyGeneration: string;
                export const ProductAllowedDevices: string;
                export const ProductDescription: string;
                export const ProductDownloadUrl1: string;
                export const ProductDownloadUrl2: string;
                export const ProductEAccessStatus: string;
                export const ProductEOpens: string;
                export const ProductEPackingType: string;
                export const ProductEProductType: string;
                export const ProductERioplayVersion: string;
                export const ProductEShippedby: string;
                export const ProductEValidity: string;
                export const ProductEValidityType: string;
                export const ProductEWatchTime: string;
                export const ProductGrossAmount: string;
                export const ProductHasBooks: string;
                export const ProductHasCourier: string;
                export const ProductHasPenDrive: string;
                export const ProductHasVod: string;
                export const ProductHeight: string;
                export const ProductId: string;
                export const ProductInAppDownload: string;
                export const ProductInsertDate: string;
                export const ProductInsertUserId: string;
                export const ProductIsActive: string;
                export const ProductIsCombo: string;
                export const ProductIsLive: string;
                export const ProductLength: string;
                export const ProductNote: string;
                export const ProductProcesOrderOnPaid: string;
                export const ProductProductIds: string;
                export const ProductProductName: string;
                export const ProductProductQueryInfo: string;
                export const ProductRioplayProductCode: string;
                export const ProductSkuCode: string;
                export const ProductSupportInfo: string;
                export const ProductTeacherName: string;
                export const ProductTemplateSerialKeyId: string;
                export const ProductTotalAllowedDuration: string;
                export const ProductUpdateDate: string;
                export const ProductUpdateUserId: string;
                export const ProductValidTill: string;
                export const ProductVendorId: string;
                export const ProductWebsiteUrl: string;
                export const ProductWeight: string;
                export const ProductWidth: string;
                export const Quantity: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace TeacherPayments {
                export const BankName: string;
                export const Comment: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const PaidAmount: string;
                export const PaymentDate: string;
                export const PaymentMode: string;
                export const PaymentRefNo: string;
                export const ReceiptNo: string;
                export const Remark: string;
                export const RowIds: string;
                export const TeacherAddress: string;
                export const TeacherAlternateEmail: string;
                export const TeacherAlternateMobile: string;
                export const TeacherBankAccountName: string;
                export const TeacherBankAccountNo: string;
                export const TeacherBankAccountType: string;
                export const TeacherBankIfscCode: string;
                export const TeacherBankName: string;
                export const TeacherCity: string;
                export const TeacherDescription: string;
                export const TeacherEmail: string;
                export const TeacherGstCertificate: string;
                export const TeacherGstin: string;
                export const TeacherId: string;
                export const TeacherInsertDate: string;
                export const TeacherInsertUserId: string;
                export const TeacherIsActive: string;
                export const TeacherMobile: string;
                export const TeacherName: string;
                export const TeacherPan: string;
                export const TeacherPincode: string;
                export const TeacherStateId: string;
                export const TeacherUpdateDate: string;
                export const TeacherUpdateUserId: string;
                export const TeacherUserId: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace WebsiteOrderProducts {
                export const AccessStatus: string;
                export const AllowedDevices: string;
                export const EOpens: string;
                export const EValidity: string;
                export const EValidityType: string;
                export const EWatchTime: string;
                export const HasBooks: string;
                export const HasCourier: string;
                export const HasPendrive: string;
                export const Id: string;
                export const IsTemplateSerialKey: string;
                export const Islive: string;
                export const MappingStatus: string;
                export const OrderBillingAddress1: string;
                export const OrderBillingAddress2: string;
                export const OrderBillingCity: string;
                export const OrderBillingPincode: string;
                export const OrderBillingStateId: string;
                export const OrderCustomerEmail1: string;
                export const OrderCustomerEmail2: string;
                export const OrderCustomerId: string;
                export const OrderCustomerMobile1: string;
                export const OrderCustomerMobile2: string;
                export const OrderCustomerName: string;
                export const OrderDiscountAmount: string;
                export const OrderDiscountCoupon: string;
                export const OrderDiscountPer: string;
                export const OrderEFranchiseeDiscount: string;
                export const OrderEFranchiseeDiscountType: string;
                export const OrderEInvoiceStatus: string;
                export const OrderEInvoiceTo: string;
                export const OrderEOrderProcessBy: string;
                export const OrderEOrderStatus: string;
                export const OrderEPaymentStatus: string;
                export const OrderEPaymentType: string;
                export const OrderEShippingStatus: string;
                export const OrderEShippingType: string;
                export const OrderESourceType: string;
                export const OrderEmailSendCount: string;
                export const OrderExpectedShippingDate: string;
                export const OrderFranchiseeDiscountAmount: string;
                export const OrderFranchiseeDiscountValue: string;
                export const OrderFranchiseeId: string;
                export const OrderFreezeData: string;
                export const OrderGrossAmount: string;
                export const OrderGstin: string;
                export const OrderId: string;
                export const OrderInsertDate: string;
                export const OrderInsertUserId: string;
                export const OrderInvoiceCompanyId: string;
                export const OrderIsActive: string;
                export const OrderIsEmailSent: string;
                export const OrderLastEmailSentDate: string;
                export const OrderMailId: string;
                export const OrderNetAmount: string;
                export const OrderOrderDate: string;
                export const OrderOrderNumber: string;
                export const OrderShippingAddress1: string;
                export const OrderShippingAddress2: string;
                export const OrderShippingCity: string;
                export const OrderShippingNote: string;
                export const OrderShippingPincode: string;
                export const OrderShippingStateId: string;
                export const OrderShippingToName: string;
                export const OrderSourceName: string;
                export const OrderSourceOrderNumber: string;
                export const OrderTaxAmount: string;
                export const OrderTaxableAmount: string;
                export const OrderUpdateDate: string;
                export const OrderUpdateUserId: string;
                export const OrderVendorId: string;
                export const ProductId: string;
                export const Qty: string;
                export const SerialkeyStatus: string;
                export const SkuCode: string;
                export const SpecificationCode: string;
                export const TotalAllowedDuration: string;
                export const ValidTill: string;
            }
        }

        namespace Products {

            namespace Category {
                export const Description: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const IsWebsiteCategory: string;
                export const Name: string;
                export const ParentId: string;
                export const ParentName: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
                export const WebsiteCategoryId: string;
            }

            namespace ProductBillingItemSpecifications {
                export const EAdjustmentType: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const IsApplicable: string;
                export const PriceAdjustment: string;
                export const ProductBillingItemBillingItemName: string;
                export const ProductBillingItemEDiscountType: string;
                export const ProductBillingItemEndDate: string;
                export const ProductBillingItemGrossAmount: string;
                export const ProductBillingItemHsnMasterId: string;
                export const ProductBillingItemId: string;
                export const ProductBillingItemIncludingTax: string;
                export const ProductBillingItemInsertDate: string;
                export const ProductBillingItemInsertUserId: string;
                export const ProductBillingItemInvoiceCompanyId: string;
                export const ProductBillingItemIsActive: string;
                export const ProductBillingItemProductId: string;
                export const ProductBillingItemSpecialGrossAmount: string;
                export const ProductBillingItemStartDate: string;
                export const ProductBillingItemTaxCategoryId: string;
                export const ProductBillingItemUpdateDate: string;
                export const ProductBillingItemUpdateUserId: string;
                export const ProductId: string;
                export const ProductSpecificationAllowedDevices: string;
                export const ProductSpecificationEValidity: string;
                export const ProductSpecificationEValidityType: string;
                export const ProductSpecificationEWatchtime: string;
                export const ProductSpecificationEopens: string;
                export const ProductSpecificationHasBooks: string;
                export const ProductSpecificationHasCourier: string;
                export const ProductSpecificationHasPendrive: string;
                export const ProductSpecificationId: string;
                export const ProductSpecificationInsertDate: string;
                export const ProductSpecificationInsertUserId: string;
                export const ProductSpecificationIsLive: string;
                export const ProductSpecificationProcessOrderOnPaid: string;
                export const ProductSpecificationProductId: string;
                export const ProductSpecificationSpecificationCode: string;
                export const ProductSpecificationSpecificationName: string;
                export const ProductSpecificationUpdateDate: string;
                export const ProductSpecificationUpdateUserId: string;
                export const ProductSpecificationValidTill: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace ProductBillingItems {
                export const BillingItemName: string;
                export const EDiscountType: string;
                export const EndDate: string;
                export const GrossAmount: string;
                export const HsnMasterHsnCode: string;
                export const HsnMasterId: string;
                export const HsnMasterInsertDate: string;
                export const HsnMasterInsertUserId: string;
                export const HsnMasterIsActive: string;
                export const HsnMasterName: string;
                export const HsnMasterTaxCategoryId: string;
                export const HsnMasterUpdateDate: string;
                export const HsnMasterUpdateUserId: string;
                export const Id: string;
                export const IncludingTax: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const InvoiceCompanyAddress: string;
                export const InvoiceCompanyFooterNote: string;
                export const InvoiceCompanyGstIn: string;
                export const InvoiceCompanyId: string;
                export const InvoiceCompanyInvoiceChangeDate: string;
                export const InvoiceCompanyInvoiceCode: string;
                export const InvoiceCompanyIsDefault: string;
                export const InvoiceCompanyIsTaxApplicable: string;
                export const InvoiceCompanyLogo1: string;
                export const InvoiceCompanyLogo2: string;
                export const InvoiceCompanyName: string;
                export const InvoiceCompanyStampImage: string;
                export const IsActive: string;
                export const ProductActivateSerialKey: string;
                export const ProductAllowSerialKeyGeneration: string;
                export const ProductAllowedDevices: string;
                export const ProductDescription: string;
                export const ProductDownloadUrl1: string;
                export const ProductDownloadUrl2: string;
                export const ProductEAccessStatus: string;
                export const ProductEOpens: string;
                export const ProductEPackingType: string;
                export const ProductEProductType: string;
                export const ProductERioplayVersion: string;
                export const ProductEShippedby: string;
                export const ProductEValidity: string;
                export const ProductEValidityType: string;
                export const ProductEWatchTime: string;
                export const ProductGrossAmount: string;
                export const ProductHasBooks: string;
                export const ProductHasCourier: string;
                export const ProductHasPenDrive: string;
                export const ProductHasVod: string;
                export const ProductHeight: string;
                export const ProductId: string;
                export const ProductInAppDownload: string;
                export const ProductInsertDate: string;
                export const ProductInsertUserId: string;
                export const ProductIsActive: string;
                export const ProductIsCombo: string;
                export const ProductIsLive: string;
                export const ProductLength: string;
                export const ProductNote: string;
                export const ProductProcesOrderOnPaid: string;
                export const ProductProductIds: string;
                export const ProductProductName: string;
                export const ProductProductQueryInfo: string;
                export const ProductRioplayProductCode: string;
                export const ProductSkuCode: string;
                export const ProductSupportInfo: string;
                export const ProductTeacherName: string;
                export const ProductTemplateSerialKeyId: string;
                export const ProductTotalAllowedDuration: string;
                export const ProductUpdateDate: string;
                export const ProductUpdateUserId: string;
                export const ProductValidTill: string;
                export const ProductVendorId: string;
                export const ProductWebsiteUrl: string;
                export const ProductWeight: string;
                export const ProductWidth: string;
                export const SpecialGrossAmount: string;
                export const StartDate: string;
                export const TaxCategoryId: string;
                export const TaxCategoryInsertDate: string;
                export const TaxCategoryInsertUserId: string;
                export const TaxCategoryIsActive: string;
                export const TaxCategoryName: string;
                export const TaxCategoryUpdateDate: string;
                export const TaxCategoryUpdateUserId: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace ProductBooks {
                export const BookBookName: string;
                export const BookCost: string;
                export const BookEBookType: string;
                export const BookId: string;
                export const BookInsertDate: string;
                export const BookInsertUserId: string;
                export const BookIsActive: string;
                export const BookIsbn: string;
                export const BookNoOfPages: string;
                export const BookTaxCategoryId: string;
                export const BookUpdateDate: string;
                export const BookUpdateUserId: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const ProductActivateSerialKey: string;
                export const ProductAllowSerialKeyGeneration: string;
                export const ProductAllowedDevices: string;
                export const ProductDescription: string;
                export const ProductDownloadUrl1: string;
                export const ProductDownloadUrl2: string;
                export const ProductEAccessStatus: string;
                export const ProductEOpens: string;
                export const ProductEPackingType: string;
                export const ProductEProductType: string;
                export const ProductERioplayVersion: string;
                export const ProductEShippedby: string;
                export const ProductEValidity: string;
                export const ProductEValidityType: string;
                export const ProductEWatchTime: string;
                export const ProductGrossAmount: string;
                export const ProductHasBooks: string;
                export const ProductHasCourier: string;
                export const ProductHasPenDrive: string;
                export const ProductHasVod: string;
                export const ProductHeight: string;
                export const ProductId: string;
                export const ProductInAppDownload: string;
                export const ProductInsertDate: string;
                export const ProductInsertUserId: string;
                export const ProductIsActive: string;
                export const ProductIsCombo: string;
                export const ProductIsLive: string;
                export const ProductLength: string;
                export const ProductNote: string;
                export const ProductProcesOrderOnPaid: string;
                export const ProductProductIds: string;
                export const ProductProductName: string;
                export const ProductProductQueryInfo: string;
                export const ProductRioplayProductCode: string;
                export const ProductSkuCode: string;
                export const ProductSupportInfo: string;
                export const ProductTeacherName: string;
                export const ProductTemplateSerialKeyId: string;
                export const ProductTotalAllowedDuration: string;
                export const ProductUpdateDate: string;
                export const ProductUpdateUserId: string;
                export const ProductValidTill: string;
                export const ProductVendorId: string;
                export const ProductWebsiteUrl: string;
                export const ProductWeight: string;
                export const ProductWidth: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace ProductCategory {
                export const CategoryDescription: string;
                export const CategoryId: string;
                export const CategoryInsertDate: string;
                export const CategoryInsertUserId: string;
                export const CategoryIsActive: string;
                export const CategoryIsWebsiteCategory: string;
                export const CategoryName: string;
                export const CategoryParentId: string;
                export const CategoryUpdateDate: string;
                export const CategoryUpdateUserId: string;
                export const CategoryWebsiteCategoryId: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const ProductActivateSerialKey: string;
                export const ProductAllowSerialKeyGeneration: string;
                export const ProductAllowedDevices: string;
                export const ProductDescription: string;
                export const ProductDownloadUrl1: string;
                export const ProductDownloadUrl2: string;
                export const ProductEAccessStatus: string;
                export const ProductEOpens: string;
                export const ProductEPackingType: string;
                export const ProductEProductType: string;
                export const ProductERioplayVersion: string;
                export const ProductEShippedby: string;
                export const ProductEValidity: string;
                export const ProductEValidityType: string;
                export const ProductEWatchTime: string;
                export const ProductGrossAmount: string;
                export const ProductHasBooks: string;
                export const ProductHasCourier: string;
                export const ProductHasPenDrive: string;
                export const ProductHasVod: string;
                export const ProductHeight: string;
                export const ProductId: string;
                export const ProductInAppDownload: string;
                export const ProductInsertDate: string;
                export const ProductInsertUserId: string;
                export const ProductIsActive: string;
                export const ProductIsCombo: string;
                export const ProductIsLive: string;
                export const ProductLength: string;
                export const ProductNote: string;
                export const ProductProcesOrderOnPaid: string;
                export const ProductProductIds: string;
                export const ProductProductName: string;
                export const ProductProductQueryInfo: string;
                export const ProductRioplayProductCode: string;
                export const ProductSkuCode: string;
                export const ProductSupportInfo: string;
                export const ProductTeacherName: string;
                export const ProductTemplateSerialKeyId: string;
                export const ProductTotalAllowedDuration: string;
                export const ProductUpdateDate: string;
                export const ProductUpdateUserId: string;
                export const ProductValidTill: string;
                export const ProductVendorId: string;
                export const ProductWebsiteUrl: string;
                export const ProductWeight: string;
                export const ProductWidth: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace ProductFranchiseeShare {
                export const ESharingType: string;
                export const FranchiseeAddress: string;
                export const FranchiseeAlternateEmail: string;
                export const FranchiseeAlternateMobile: string;
                export const FranchiseeBankAccountName: string;
                export const FranchiseeBankAccountNo: string;
                export const FranchiseeBankAccountType: string;
                export const FranchiseeBankIfscCode: string;
                export const FranchiseeBankName: string;
                export const FranchiseeCity: string;
                export const FranchiseeCustomerId: string;
                export const FranchiseeDescription: string;
                export const FranchiseeDiscountCoupon: string;
                export const FranchiseeEmail: string;
                export const FranchiseeGstCertificate: string;
                export const FranchiseeGstin: string;
                export const FranchiseeId: string;
                export const FranchiseeInsertDate: string;
                export const FranchiseeInsertUserId: string;
                export const FranchiseeIsActive: string;
                export const FranchiseeIsCustomer: string;
                export const FranchiseeIsPostPayAllowed: string;
                export const FranchiseeMobile: string;
                export const FranchiseeName: string;
                export const FranchiseePan: string;
                export const FranchiseePincode: string;
                export const FranchiseeStateId: string;
                export const FranchiseeUpdateDate: string;
                export const FranchiseeUpdateUserId: string;
                export const FranchiseeUserId: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const ProductActivateSerialKey: string;
                export const ProductAllowSerialKeyGeneration: string;
                export const ProductAllowedDevices: string;
                export const ProductDescription: string;
                export const ProductDownloadUrl1: string;
                export const ProductDownloadUrl2: string;
                export const ProductEAccessStatus: string;
                export const ProductEOpens: string;
                export const ProductEPackingType: string;
                export const ProductEProductType: string;
                export const ProductERioplayVersion: string;
                export const ProductEShippedby: string;
                export const ProductEValidity: string;
                export const ProductEValidityType: string;
                export const ProductEWatchTime: string;
                export const ProductGrossAmount: string;
                export const ProductHasBooks: string;
                export const ProductHasCourier: string;
                export const ProductHasPenDrive: string;
                export const ProductHasVod: string;
                export const ProductHeight: string;
                export const ProductId: string;
                export const ProductInAppDownload: string;
                export const ProductInsertDate: string;
                export const ProductInsertUserId: string;
                export const ProductIsActive: string;
                export const ProductIsCombo: string;
                export const ProductIsLive: string;
                export const ProductLength: string;
                export const ProductNote: string;
                export const ProductProcesOrderOnPaid: string;
                export const ProductProductIds: string;
                export const ProductProductName: string;
                export const ProductProductQueryInfo: string;
                export const ProductRioplayProductCode: string;
                export const ProductSkuCode: string;
                export const ProductSupportInfo: string;
                export const ProductTeacherName: string;
                export const ProductTemplateSerialKeyId: string;
                export const ProductTotalAllowedDuration: string;
                export const ProductUpdateDate: string;
                export const ProductUpdateUserId: string;
                export const ProductValidTill: string;
                export const ProductVendorId: string;
                export const ProductWebsiteUrl: string;
                export const ProductWeight: string;
                export const ProductWidth: string;
                export const RowIds: string;
                export const SIds: string;
                export const SharingAmount: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace ProductPendrives {
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const PenDriveTypeId: string;
                export const PendriveType: string;
                export const ProductActivateSerialKey: string;
                export const ProductAllowSerialKeyGeneration: string;
                export const ProductAllowedDevices: string;
                export const ProductDescription: string;
                export const ProductDownloadUrl1: string;
                export const ProductDownloadUrl2: string;
                export const ProductEAccessStatus: string;
                export const ProductEOpens: string;
                export const ProductEPackingType: string;
                export const ProductEProductType: string;
                export const ProductERioplayVersion: string;
                export const ProductEShippedby: string;
                export const ProductEValidity: string;
                export const ProductEValidityType: string;
                export const ProductEWatchTime: string;
                export const ProductGrossAmount: string;
                export const ProductHasBooks: string;
                export const ProductHasCourier: string;
                export const ProductHasPenDrive: string;
                export const ProductHasVod: string;
                export const ProductHeight: string;
                export const ProductId: string;
                export const ProductInAppDownload: string;
                export const ProductInsertDate: string;
                export const ProductInsertUserId: string;
                export const ProductIsActive: string;
                export const ProductIsCombo: string;
                export const ProductIsLive: string;
                export const ProductLength: string;
                export const ProductNote: string;
                export const ProductProcesOrderOnPaid: string;
                export const ProductProductIds: string;
                export const ProductProductName: string;
                export const ProductProductQueryInfo: string;
                export const ProductRioplayProductCode: string;
                export const ProductSkuCode: string;
                export const ProductSupportInfo: string;
                export const ProductTeacherName: string;
                export const ProductTemplateSerialKeyId: string;
                export const ProductTotalAllowedDuration: string;
                export const ProductUpdateDate: string;
                export const ProductUpdateUserId: string;
                export const ProductValidTill: string;
                export const ProductVendorId: string;
                export const ProductWebsiteUrl: string;
                export const ProductWeight: string;
                export const ProductWidth: string;
                export const Quantity: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace ProductSpecifications {
                export const AllowedDevice: string;
                export const AllowedDevices: string;
                export const EValidity: string;
                export const EValidityType: string;
                export const EWatchtime: string;
                export const Eopens: string;
                export const HasBooks: string;
                export const HasCourier: string;
                export const HasPendrive: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsLive: string;
                export const ProcessOrderOnPaid: string;
                export const ProductActivateSerialKey: string;
                export const ProductAllowSerialKeyGeneration: string;
                export const ProductAllowedDevices: string;
                export const ProductDescription: string;
                export const ProductDownloadUrl1: string;
                export const ProductDownloadUrl2: string;
                export const ProductEAccessStatus: string;
                export const ProductEOpens: string;
                export const ProductEPackingType: string;
                export const ProductEProductType: string;
                export const ProductERioplayVersion: string;
                export const ProductEShippedby: string;
                export const ProductEValidity: string;
                export const ProductEValidityType: string;
                export const ProductEWatchTime: string;
                export const ProductGrossAmount: string;
                export const ProductHasBooks: string;
                export const ProductHasCourier: string;
                export const ProductHasPenDrive: string;
                export const ProductHasVod: string;
                export const ProductHeight: string;
                export const ProductId: string;
                export const ProductInAppDownload: string;
                export const ProductInsertDate: string;
                export const ProductInsertUserId: string;
                export const ProductIsActive: string;
                export const ProductIsCombo: string;
                export const ProductIsLive: string;
                export const ProductLength: string;
                export const ProductNote: string;
                export const ProductProcesOrderOnPaid: string;
                export const ProductProductIds: string;
                export const ProductProductName: string;
                export const ProductProductQueryInfo: string;
                export const ProductRioplayProductCode: string;
                export const ProductSkuCode: string;
                export const ProductSpecificationBookId: string;
                export const ProductSupportInfo: string;
                export const ProductTeacherName: string;
                export const ProductTemplateSerialKeyId: string;
                export const ProductTotalAllowedDuration: string;
                export const ProductUpdateDate: string;
                export const ProductUpdateUserId: string;
                export const ProductValidTill: string;
                export const ProductVendorId: string;
                export const ProductWebsiteUrl: string;
                export const ProductWeight: string;
                export const ProductWidth: string;
                export const Rioplay8AllowedDevices: string;
                export const Rioplay8ESubscriptionType: string;
                export const Rioplay8EViewsType: string;
                export const Rioplay8EWatchTimetype: string;
                export const Rioplay8ValidDate: string;
                export const Rioplay8ValidityInDays: string;
                export const Rioplay8ViewsPerContent: string;
                export const Rioplay8WatchTime: string;
                export const SpecificationCode: string;
                export const SpecificationName: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
                export const ValidTill: string;
            }

            namespace ProductSpecificationsBooks {
                export const BookId: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const ProductId: string;
                export const ProductSpecificationAllowedDevices: string;
                export const ProductSpecificationEValidity: string;
                export const ProductSpecificationEValidityType: string;
                export const ProductSpecificationEWatchtime: string;
                export const ProductSpecificationEopens: string;
                export const ProductSpecificationHasBooks: string;
                export const ProductSpecificationHasCourier: string;
                export const ProductSpecificationHasPendrive: string;
                export const ProductSpecificationId: string;
                export const ProductSpecificationInsertDate: string;
                export const ProductSpecificationInsertUserId: string;
                export const ProductSpecificationIsLive: string;
                export const ProductSpecificationProcessOrderOnPaid: string;
                export const ProductSpecificationProductId: string;
                export const ProductSpecificationSpecificationCode: string;
                export const ProductSpecificationSpecificationName: string;
                export const ProductSpecificationUpdateDate: string;
                export const ProductSpecificationUpdateUserId: string;
                export const ProductSpecificationValidTill: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace ProductTeacherShare {
                export const ESharingType: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const ProductActivateSerialKey: string;
                export const ProductAllowSerialKeyGeneration: string;
                export const ProductAllowedDevices: string;
                export const ProductDescription: string;
                export const ProductDownloadUrl1: string;
                export const ProductDownloadUrl2: string;
                export const ProductEAccessStatus: string;
                export const ProductEOpens: string;
                export const ProductEPackingType: string;
                export const ProductEProductType: string;
                export const ProductERioplayVersion: string;
                export const ProductEShippedby: string;
                export const ProductEValidity: string;
                export const ProductEValidityType: string;
                export const ProductEWatchTime: string;
                export const ProductGrossAmount: string;
                export const ProductHasBooks: string;
                export const ProductHasCourier: string;
                export const ProductHasPenDrive: string;
                export const ProductHasVod: string;
                export const ProductHeight: string;
                export const ProductId: string;
                export const ProductInAppDownload: string;
                export const ProductInsertDate: string;
                export const ProductInsertUserId: string;
                export const ProductIsActive: string;
                export const ProductIsCombo: string;
                export const ProductIsLive: string;
                export const ProductLength: string;
                export const ProductNote: string;
                export const ProductProcesOrderOnPaid: string;
                export const ProductProductIds: string;
                export const ProductProductName: string;
                export const ProductProductQueryInfo: string;
                export const ProductRioplayProductCode: string;
                export const ProductSkuCode: string;
                export const ProductSupportInfo: string;
                export const ProductTeacherName: string;
                export const ProductTemplateSerialKeyId: string;
                export const ProductTotalAllowedDuration: string;
                export const ProductUpdateDate: string;
                export const ProductUpdateUserId: string;
                export const ProductValidTill: string;
                export const ProductVendorId: string;
                export const ProductWebsiteUrl: string;
                export const ProductWeight: string;
                export const ProductWidth: string;
                export const RowIds: string;
                export const SharingAmount: string;
                export const TeacherAddress: string;
                export const TeacherAlternateEmail: string;
                export const TeacherAlternateMobile: string;
                export const TeacherBankAccountName: string;
                export const TeacherBankAccountNo: string;
                export const TeacherBankAccountType: string;
                export const TeacherBankIfscCode: string;
                export const TeacherBankName: string;
                export const TeacherCity: string;
                export const TeacherDescription: string;
                export const TeacherEmail: string;
                export const TeacherGstCertificate: string;
                export const TeacherGstin: string;
                export const TeacherId: string;
                export const TeacherInsertDate: string;
                export const TeacherInsertUserId: string;
                export const TeacherIsActive: string;
                export const TeacherMobile: string;
                export const TeacherName: string;
                export const TeacherPan: string;
                export const TeacherPincode: string;
                export const TeacherStateId: string;
                export const TeacherUpdateDate: string;
                export const TeacherUpdateUserId: string;
                export const TeacherUserId: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace Products {
                export const ActivateSerialKey: string;
                export const AllowSerialKeyGeneration: string;
                export const AllowedDevice: string;
                export const AllowedDevices: string;
                export const ComboProductId: string;
                export const Description: string;
                export const DownloadUrl1: string;
                export const DownloadUrl2: string;
                export const EAccessStatus: string;
                export const EOpens: string;
                export const EPackingType: string;
                export const EProductType: string;
                export const ERioplayVersion: string;
                export const EShippedby: string;
                export const EValidity: string;
                export const EValidityType: string;
                export const EWatchTime: string;
                export const GrossAmount: string;
                export const HasBooks: string;
                export const HasCourier: string;
                export const HasPenDrive: string;
                export const HasVod: string;
                export const Height: string;
                export const Id: string;
                export const InAppDownload: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const IsCombo: string;
                export const IsLive: string;
                export const Length: string;
                export const Note: string;
                export const ProcesOrderOnPaid: string;
                export const ProductCategList: string;
                export const ProductDisplayName: string;
                export const ProductIds: string;
                export const ProductName: string;
                export const ProductQueryInfo: string;
                export const RioPlayTenantId: string;
                export const Rioplay8AllowedDevice: string;
                export const Rioplay8AllowedDevices: string;
                export const Rioplay8DeviceCount: string;
                export const Rioplay8EDeviceRestrictionType: string;
                export const Rioplay8ESubscriptionType: string;
                export const Rioplay8EViewsType: string;
                export const Rioplay8EWatchTimetype: string;
                export const Rioplay8PlaylistIds: string;
                export const Rioplay8ProductCode: string;
                export const Rioplay8SwitchCount: string;
                export const Rioplay8TenantId: string;
                export const Rioplay8ValidDate: string;
                export const Rioplay8ValidityInDays: string;
                export const Rioplay8ViewsPerContent: string;
                export const Rioplay8WatchTime: string;
                export const RioplayProductCode: string;
                export const RowIds: string;
                export const Secretkey: string;
                export const SkuCode: string;
                export const SupportInfo: string;
                export const TeacherName: string;
                export const TemplateSerialKeyId: string;
                export const Thumbnail: string;
                export const TotalAllowedDuration: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
                export const UserName: string;
                export const ValidTill: string;
                export const VendorId: string;
                export const VendorUserId: string;
                export const WebsiteUrl: string;
                export const Weight: string;
                export const Width: string;
            }
        }

        namespace Reports {

            namespace FranchiseeOutstanding {
                export const ESettelementStatus: string;
                export const FranchiseeAddress: string;
                export const FranchiseeAlternateEmail: string;
                export const FranchiseeAlternateMobile: string;
                export const FranchiseeBankAccountName: string;
                export const FranchiseeBankAccountNo: string;
                export const FranchiseeBankAccountType: string;
                export const FranchiseeBankIfscCode: string;
                export const FranchiseeBankName: string;
                export const FranchiseeCity: string;
                export const FranchiseeCustomerId: string;
                export const FranchiseeDescription: string;
                export const FranchiseeDiscountCoupon: string;
                export const FranchiseeEmail: string;
                export const FranchiseeGstCertificate: string;
                export const FranchiseeGstin: string;
                export const FranchiseeId: string;
                export const FranchiseeInsertDate: string;
                export const FranchiseeInsertUserId: string;
                export const FranchiseeIsActive: string;
                export const FranchiseeIsCustomer: string;
                export const FranchiseeIsPostPayAllowed: string;
                export const FranchiseeMobile: string;
                export const FranchiseeName: string;
                export const FranchiseePan: string;
                export const FranchiseePincode: string;
                export const FranchiseeStateId: string;
                export const FranchiseeUpdateDate: string;
                export const FranchiseeUpdateUserId: string;
                export const FranchiseeUserId: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const OrderBillingAddress1: string;
                export const OrderBillingAddress2: string;
                export const OrderBillingCity: string;
                export const OrderBillingPincode: string;
                export const OrderBillingStateId: string;
                export const OrderCustomerEmail1: string;
                export const OrderCustomerEmail2: string;
                export const OrderCustomerId: string;
                export const OrderCustomerMobile1: string;
                export const OrderCustomerMobile2: string;
                export const OrderCustomerName: string;
                export const OrderDiscountAmount: string;
                export const OrderDiscountCoupon: string;
                export const OrderDiscountPer: string;
                export const OrderEFranchiseeDiscount: string;
                export const OrderEFranchiseeDiscountType: string;
                export const OrderEInvoiceStatus: string;
                export const OrderEInvoiceTo: string;
                export const OrderEOrderProcessBy: string;
                export const OrderEOrderStatus: string;
                export const OrderEPaymentStatus: string;
                export const OrderEPaymentType: string;
                export const OrderEShippingStatus: string;
                export const OrderEShippingType: string;
                export const OrderESourceType: string;
                export const OrderEmailSendCount: string;
                export const OrderExpectedShippingDate: string;
                export const OrderFranchiseeDiscountAmount: string;
                export const OrderFranchiseeDiscountValue: string;
                export const OrderFranchiseeId: string;
                export const OrderGrossAmount: string;
                export const OrderGstin: string;
                export const OrderId: string;
                export const OrderInsertDate: string;
                export const OrderInsertUserId: string;
                export const OrderInvoiceCompanyId: string;
                export const OrderIsActive: string;
                export const OrderIsEmailSent: string;
                export const OrderLastEmailSentDate: string;
                export const OrderMailId: string;
                export const OrderNetAmount: string;
                export const OrderOrderDate: string;
                export const OrderOrderNumber: string;
                export const OrderProductsAllowedDevices: string;
                export const OrderProductsCost: string;
                export const OrderProductsDiscountAmt: string;
                export const OrderProductsDownloadUrl1: string;
                export const OrderProductsDownloadUrl2: string;
                export const OrderProductsEAccessStatus: string;
                export const OrderProductsEFranchiseeDiscountType: string;
                export const OrderProductsEOpens: string;
                export const OrderProductsESerialkeyStatus: string;
                export const OrderProductsEValidity: string;
                export const OrderProductsEValidityType: string;
                export const OrderProductsEWatchTime: string;
                export const OrderProductsFranchiseeDiscountAmount: string;
                export const OrderProductsFranchiseeDiscountValue: string;
                export const OrderProductsGrossAmount: string;
                export const OrderProductsHasBooks: string;
                export const OrderProductsHasCourier: string;
                export const OrderProductsHasPendrive: string;
                export const OrderProductsId: string;
                export const OrderProductsInsertDate: string;
                export const OrderProductsInsertUserId: string;
                export const OrderProductsInvoiceCompanyId: string;
                export const OrderProductsIsActive: string;
                export const OrderProductsIsLive: string;
                export const OrderProductsIsTemplateSerialKey: string;
                export const OrderProductsNetAmount: string;
                export const OrderProductsNote: string;
                export const OrderProductsOrderId: string;
                export const OrderProductsProductId: string;
                export const OrderProductsQuantity: string;
                export const OrderProductsSerialKey: string;
                export const OrderProductsTaxableAmount: string;
                export const OrderProductsTotalAllowedDuration: string;
                export const OrderProductsUpdateDate: string;
                export const OrderProductsUpdateUserId: string;
                export const OrderProductsValidTill: string;
                export const OrderProdutcsGrossAmount: string;
                export const OrderShippingAddress1: string;
                export const OrderShippingAddress2: string;
                export const OrderShippingCity: string;
                export const OrderShippingNote: string;
                export const OrderShippingPincode: string;
                export const OrderShippingStateId: string;
                export const OrderShippingToName: string;
                export const OrderSourceName: string;
                export const OrderSourceOrderNumber: string;
                export const OrderTaxableAmount: string;
                export const OrderUpdateDate: string;
                export const OrderUpdateUserId: string;
                export const OrderVendorId: string;
                export const Quantity: string;
                export const SettelmentId: string;
                export const ShareAmount: string;
                export const SharePercentage: string;
                export const TotalShare: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace FranchiseeSalesReport {
                export const CgstAmount: string;
                export const CgstRate: string;
                export const City: string;
                export const CustomerId: string;
                export const CustomerName: string;
                export const DiscountAmount: string;
                export const EInvoiceTo: string;
                export const EPaymentStatus: string;
                export const EPaymentType: string;
                export const FranchiseeDiscountAmount: string;
                export const FranchiseeGstin: string;
                export const FranchiseeId: string;
                export const FranchiseeName: string;
                export const Id: string;
                export const IgstAmount: string;
                export const IgstRate: string;
                export const InvoiceCompanyId: string;
                export const InvoiceDate: string;
                export const InvoiceId: string;
                export const Invoicenumber: string;
                export const NetAmount: string;
                export const OrderDate: string;
                export const OrderDiscount: string;
                export const OrderNumber: string;
                export const ProductDiscount: string;
                export const ProductId: string;
                export const ProductName: string;
                export const SgstAmount: string;
                export const SgstRate: string;
                export const StateName: string;
                export const TaxCategoryName: string;
                export const TaxableAmount: string;
                export const Total: string;
                export const TotalTax: string;
            }

            namespace InvoiceBillingItemsReport {
                export const BillingItemName: string;
                export const CgstAmount: string;
                export const CgstRate: string;
                export const City: string;
                export const CustomerId: string;
                export const CustomerName: string;
                export const DiscountAmount: string;
                export const EInvoiceTo: string;
                export const EPaymentStatus: string;
                export const EPaymentType: string;
                export const FranchiseeDiscountAmount: string;
                export const FranchiseeId: string;
                export const FranchiseeName: string;
                export const HsnName: string;
                export const Id: string;
                export const IgstAmount: string;
                export const IgstRate: string;
                export const InvoiceCompanyId: string;
                export const InvoiceDate: string;
                export const InvoiceId: string;
                export const Invoicenumber: string;
                export const NetAmount: string;
                export const OrderDate: string;
                export const OrderDiscount: string;
                export const OrderNumber: string;
                export const OrderProductBillingItemId: string;
                export const ProductBillingItemId: string;
                export const ProductDiscount: string;
                export const ProductId: string;
                export const ProductName: string;
                export const Quantity: string;
                export const Rate: string;
                export const SgstAmount: string;
                export const SgstRate: string;
                export const TaxCategoryName: string;
                export const TaxableAmount: string;
                export const Total: string;
                export const TotalTax: string;
            }

            namespace InvoiceDetailedReport {
                export const CgstAmount: string;
                export const CgstRate: string;
                export const City: string;
                export const CustomerId: string;
                export const CustomerName: string;
                export const DiscountAmount: string;
                export const EInvoiceTo: string;
                export const EPaymentStatus: string;
                export const EPaymentType: string;
                export const FranchiseeDiscountAmount: string;
                export const FranchiseeGstin: string;
                export const FranchiseeId: string;
                export const FranchiseeName: string;
                export const Id: string;
                export const IgstAmount: string;
                export const IgstRate: string;
                export const InvoiceCompanyId: string;
                export const InvoiceDate: string;
                export const InvoiceId: string;
                export const Invoicenumber: string;
                export const NetAmount: string;
                export const OrderDate: string;
                export const OrderDiscount: string;
                export const OrderNumber: string;
                export const ProductDiscount: string;
                export const ProductId: string;
                export const ProductName: string;
                export const SgstAmount: string;
                export const SgstRate: string;
                export const StateName: string;
                export const TaxCategoryName: string;
                export const TaxableAmount: string;
                export const Total: string;
                export const TotalTax: string;
            }

            namespace LevelReport {
                export const CustomerEmail1: string;
                export const CustomerMobile1: string;
                export const CustomerName: string;
                export const Id: string;
                export const Level: string;
                export const Mode: string;
                export const OrderDate: string;
                export const OrderId: string;
                export const OrderNumber: string;
                export const ProductName: string;
                export const ProductSpecificationName: string;
                export const TotalAmount: string;
            }

            namespace OrderCombinedReport {
                export const Address1: string;
                export const Address2: string;
                export const CgstAmount: string;
                export const CgstRate: string;
                export const City: string;
                export const CustomerEmail1: string;
                export const CustomerMobile1: string;
                export const CustomerName: string;
                export const DiscountAmount: string;
                export const DiscountCoupen: string;
                export const EOrderStatus: string;
                export const EPaymentType: string;
                export const FranchiseeName: string;
                export const Id: string;
                export const IgstAmount: string;
                export const IgstRate: string;
                export const NetAmount: string;
                export const OrderDate: string;
                export const OrderId: string;
                export const PaymentStatus: string;
                export const PinCode: string;
                export const ProductName: string;
                export const ProductSpecificationName: string;
                export const SgstAmount: string;
                export const SgstRate: string;
                export const ShippingAddress1: string;
                export const ShippingAddress2: string;
                export const ShippingCity: string;
                export const ShippingPincode: string;
                export const SourceOrderNumber: string;
                export const SourceType: string;
                export const StateName: string;
                export const TaxableAmount: string;
                export const TaxableAmountNet: string;
                export const Total: string;
                export const TotalTax: string;
            }

            namespace OrderDetailedReport {
                export const BillingAddress1: string;
                export const BillingAddress2: string;
                export const BillingCity: string;
                export const BillingPincode: string;
                export const BillingStateId: string;
                export const BillingStateInsertDate: string;
                export const BillingStateInsertUserId: string;
                export const BillingStateIsActive: string;
                export const BillingStateIsHomeState: string;
                export const BillingStateName: string;
                export const BillingStateUpdateDate: string;
                export const BillingStateUpdateUserId: string;
                export const CustomerAttemptId: string;
                export const CustomerCouponCode: string;
                export const CustomerCourseId: string;
                export const CustomerDisplayName: string;
                export const CustomerECustomerType: string;
                export const CustomerEmail1: string;
                export const CustomerEmail2: string;
                export const CustomerGstin: string;
                export const CustomerId: string;
                export const CustomerInsertDate: string;
                export const CustomerInsertUserId: string;
                export const CustomerIsActive: string;
                export const CustomerLevelId: string;
                export const CustomerMobile11: string;
                export const CustomerMobile21: string;
                export const CustomerName1: string;
                export const CustomerUpdateDate: string;
                export const CustomerUpdateUserId: string;
                export const DiscountAmount: string;
                export const DiscountCoupon: string;
                export const DiscountPer: string;
                export const EFranchiseeDiscount: string;
                export const EFranchiseeDiscountType: string;
                export const EInvoiceStatus: string;
                export const EInvoiceTo: string;
                export const EOrderProcessBy: string;
                export const EOrderStatus: string;
                export const EPaymentStatus: string;
                export const EPaymentType: string;
                export const EShippingStatus: string;
                export const EShippingType: string;
                export const ESourceType: string;
                export const EmailSendCount: string;
                export const ExpectedShippingDate: string;
                export const FranchiseeAddress: string;
                export const FranchiseeAffiliateId: string;
                export const FranchiseeAlternateEmail: string;
                export const FranchiseeAlternateMobile: string;
                export const FranchiseeAvailableCreditBalance: string;
                export const FranchiseeBankAccountName: string;
                export const FranchiseeBankAccountNo: string;
                export const FranchiseeBankAccountType: string;
                export const FranchiseeBankIfscCode: string;
                export const FranchiseeBankName: string;
                export const FranchiseeCity: string;
                export const FranchiseeCustomerId: string;
                export const FranchiseeDescription: string;
                export const FranchiseeDiscountAmount: string;
                export const FranchiseeDiscountCoupon: string;
                export const FranchiseeDiscountValue: string;
                export const FranchiseeEmail: string;
                export const FranchiseeGstCertificate: string;
                export const FranchiseeGstin: string;
                export const FranchiseeId: string;
                export const FranchiseeInsertDate: string;
                export const FranchiseeInsertUserId: string;
                export const FranchiseeIsActive: string;
                export const FranchiseeIsCustomer: string;
                export const FranchiseeIsPostPayAllowed: string;
                export const FranchiseeMobile: string;
                export const FranchiseeName: string;
                export const FranchiseePan: string;
                export const FranchiseePincode: string;
                export const FranchiseeStateId: string;
                export const FranchiseeUpdateDate: string;
                export const FranchiseeUpdateUserId: string;
                export const FranchiseeUserId: string;
                export const FreezeData: string;
                export const GrossAmount: string;
                export const Gstin: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const InvoiceCompanyAddress: string;
                export const InvoiceCompanyAppstoreUrl: string;
                export const InvoiceCompanyFacebookUrl: string;
                export const InvoiceCompanyFooterNote: string;
                export const InvoiceCompanyGstIn: string;
                export const InvoiceCompanyId: string;
                export const InvoiceCompanyInstagramUrl: string;
                export const InvoiceCompanyInvoiceChangeDate: string;
                export const InvoiceCompanyInvoiceCode: string;
                export const InvoiceCompanyIsDefault: string;
                export const InvoiceCompanyIsTaxApplicable: string;
                export const InvoiceCompanyLogo1: string;
                export const InvoiceCompanyLogo2: string;
                export const InvoiceCompanyName: string;
                export const InvoiceCompanyPlayStoreUrl: string;
                export const InvoiceCompanyStampImage: string;
                export const InvoiceCompanyTwitterUrl: string;
                export const InvoiceCompanyYouTubeUrl: string;
                export const IsActive: string;
                export const IsEmailSent: string;
                export const LastEmailSentDate: string;
                export const MailId: string;
                export const NetAmount: string;
                export const OrderDate: string;
                export const OrderNumber: string;
                export const ShippingAddress1: string;
                export const ShippingAddress2: string;
                export const ShippingCity: string;
                export const ShippingNote: string;
                export const ShippingPincode: string;
                export const ShippingProviderBankAccountNo: string;
                export const ShippingProviderBankIfscCode: string;
                export const ShippingProviderBankName: string;
                export const ShippingProviderDescription: string;
                export const ShippingProviderEApiStatus: string;
                export const ShippingProviderEShippingProviderType: string;
                export const ShippingProviderGstCertificate: string;
                export const ShippingProviderGstin: string;
                export const ShippingProviderId: string;
                export const ShippingProviderInsertDate: string;
                export const ShippingProviderInsertUserId: string;
                export const ShippingProviderIsActive: string;
                export const ShippingProviderIsDefault: string;
                export const ShippingProviderPan: string;
                export const ShippingProviderSecret: string;
                export const ShippingProviderShippingProviderName: string;
                export const ShippingProviderTrackingUrl: string;
                export const ShippingProviderUpdateDate: string;
                export const ShippingProviderUpdateUserId: string;
                export const ShippingProviderVendorId: string;
                export const ShippingStateId: string;
                export const ShippingStateInsertDate: string;
                export const ShippingStateInsertUserId: string;
                export const ShippingStateIsActive: string;
                export const ShippingStateIsHomeState: string;
                export const ShippingStateName: string;
                export const ShippingStateUpdateDate: string;
                export const ShippingStateUpdateUserId: string;
                export const ShippingToName: string;
                export const SourceName: string;
                export const SourceOrderNumber: string;
                export const TaxAmount: string;
                export const TaxableAmount: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
                export const VendorAddress: string;
                export const VendorBankAccountName: string;
                export const VendorBankAccountNo: string;
                export const VendorBankAccountType: string;
                export const VendorBankIfscCode: string;
                export const VendorBankName: string;
                export const VendorCity: string;
                export const VendorCountry: string;
                export const VendorDescription: string;
                export const VendorEmail: string;
                export const VendorGstCertificate: string;
                export const VendorGstin: string;
                export const VendorId: string;
                export const VendorInsertDate: string;
                export const VendorInsertUserId: string;
                export const VendorIsActive: string;
                export const VendorName: string;
                export const VendorPan: string;
                export const VendorPincode: string;
                export const VendorStateId: string;
                export const VendorUpdateDate: string;
                export const VendorUpdateUserId: string;
                export const VendorUserId: string;
            }

            namespace OrderInstallmentReport {
                export const CustomerEmail1: string;
                export const CustomerMobile1: string;
                export const CustomerName: string;
                export const GrossAmount: string;
                export const Id: string;
                export const InstallmentAmount: string;
                export const InstallmentDate: string;
                export const OrderDate: string;
                export const OrderId: string;
                export const OrderNumber: string;
                export const ProductName: string;
                export const ProductSpecificationName: string;
            }

            namespace OrderOutstandingReport {
                export const CustomerEmail1: string;
                export const CustomerMobile1: string;
                export const CustomerName: string;
                export const Id: string;
                export const NetAmount: string;
                export const OrderDate: string;
                export const OrderId: string;
                export const OrderNumber: string;
                export const OutstandingAmt: string;
                export const Recdamount: string;
                export const SourceType: string;
                export const Status: string;
            }

            namespace OrderPayment {
                export const Amount: string;
                export const BankName: string;
                export const ChequeNumber: string;
                export const EPaymentMode: string;
                export const EStatus: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const Note: string;
                export const OrderBillingAddress1: string;
                export const OrderBillingAddress2: string;
                export const OrderBillingCity: string;
                export const OrderBillingPincode: string;
                export const OrderBillingStateId: string;
                export const OrderCustomerEmail1: string;
                export const OrderCustomerEmail2: string;
                export const OrderCustomerId: string;
                export const OrderCustomerMobile1: string;
                export const OrderCustomerMobile2: string;
                export const OrderCustomerName: string;
                export const OrderDiscountAmount: string;
                export const OrderDiscountCoupon: string;
                export const OrderDiscountPer: string;
                export const OrderEFranchiseeDiscount: string;
                export const OrderEFranchiseeDiscountType: string;
                export const OrderEInvoiceStatus: string;
                export const OrderEInvoiceTo: string;
                export const OrderEOrderProcessBy: string;
                export const OrderEOrderStatus: string;
                export const OrderEPaymentStatus: string;
                export const OrderEPaymentType: string;
                export const OrderEShippingStatus: string;
                export const OrderEShippingType: string;
                export const OrderESourceType: string;
                export const OrderEmailSendCount: string;
                export const OrderExpectedShippingDate: string;
                export const OrderFranchiseeDiscountAmount: string;
                export const OrderFranchiseeDiscountValue: string;
                export const OrderFranchiseeId: string;
                export const OrderFreezeData: string;
                export const OrderGrossAmount: string;
                export const OrderGstin: string;
                export const OrderId: string;
                export const OrderInsertDate: string;
                export const OrderInsertUserId: string;
                export const OrderInvoiceCompanyId: string;
                export const OrderIsActive: string;
                export const OrderIsEmailSent: string;
                export const OrderLastEmailSentDate: string;
                export const OrderMailId: string;
                export const OrderNetAmount: string;
                export const OrderOrderDate: string;
                export const OrderOrderNumber: string;
                export const OrderShippingAddress1: string;
                export const OrderShippingAddress2: string;
                export const OrderShippingCity: string;
                export const OrderShippingNote: string;
                export const OrderShippingPincode: string;
                export const OrderShippingProviderId: string;
                export const OrderShippingStateId: string;
                export const OrderShippingToName: string;
                export const OrderSourceName: string;
                export const OrderSourceOrderNumber: string;
                export const OrderTaxAmount: string;
                export const OrderTaxableAmount: string;
                export const OrderUpdateDate: string;
                export const OrderUpdateUserId: string;
                export const OrderVendorId: string;
                export const PaymentDate: string;
                export const TransactionId: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace OrderProducts {
                export const AllowedDevices: string;
                export const Cost: string;
                export const DiscountAmt: string;
                export const DownloadUrl1: string;
                export const DownloadUrl2: string;
                export const EAccessStatus: string;
                export const EFranchiseeDiscountType: string;
                export const EOpens: string;
                export const ESerialkeyStatus: string;
                export const EValidity: string;
                export const EValidityType: string;
                export const EWatchTime: string;
                export const FranchiseeDiscountAmount: string;
                export const FranchiseeDiscountValue: string;
                export const FranchiseeId: string;
                export const FranchiseeName: string;
                export const GrossAmount: string;
                export const HasBooks: string;
                export const HasCourier: string;
                export const HasPendrive: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const InvoiceCompanyAddress: string;
                export const InvoiceCompanyFooterNote: string;
                export const InvoiceCompanyGstIn: string;
                export const InvoiceCompanyId: string;
                export const InvoiceCompanyInvoiceChangeDate: string;
                export const InvoiceCompanyInvoiceCode: string;
                export const InvoiceCompanyIsDefault: string;
                export const InvoiceCompanyIsTaxApplicable: string;
                export const InvoiceCompanyLogo1: string;
                export const InvoiceCompanyLogo2: string;
                export const InvoiceCompanyName: string;
                export const InvoiceCompanyStampImage: string;
                export const IsActive: string;
                export const IsLive: string;
                export const IsTemplateSerialKey: string;
                export const NetAmount: string;
                export const Note: string;
                export const OrderBillingAddress1: string;
                export const OrderBillingAddress2: string;
                export const OrderBillingCity: string;
                export const OrderBillingPincode: string;
                export const OrderBillingStateId: string;
                export const OrderCustomerEmail1: string;
                export const OrderCustomerEmail2: string;
                export const OrderCustomerId: string;
                export const OrderCustomerMobile1: string;
                export const OrderCustomerMobile2: string;
                export const OrderCustomerName: string;
                export const OrderDiscountAmount: string;
                export const OrderDiscountCoupon: string;
                export const OrderDiscountPer: string;
                export const OrderEFranchiseeDiscount: string;
                export const OrderEFranchiseeDiscountType: string;
                export const OrderEInvoiceStatus: string;
                export const OrderEInvoiceTo: string;
                export const OrderEOrderProcessBy: string;
                export const OrderEOrderStatus: string;
                export const OrderEPaymentStatus: string;
                export const OrderEPaymentType: string;
                export const OrderEShippingStatus: string;
                export const OrderEShippingType: string;
                export const OrderESourceType: string;
                export const OrderEmailSendCount: string;
                export const OrderExpectedShippingDate: string;
                export const OrderFranchiseeDiscountAmount: string;
                export const OrderFranchiseeDiscountValue: string;
                export const OrderFranchiseeId: string;
                export const OrderFreezeData: string;
                export const OrderGrossAmount: string;
                export const OrderGstin: string;
                export const OrderId: string;
                export const OrderInsertDate: string;
                export const OrderInsertUserId: string;
                export const OrderInvoiceCompanyId: string;
                export const OrderIsActive: string;
                export const OrderIsEmailSent: string;
                export const OrderLastEmailSentDate: string;
                export const OrderMailId: string;
                export const OrderNetAmount: string;
                export const OrderOrderDate: string;
                export const OrderOrderNumber: string;
                export const OrderShippingAddress1: string;
                export const OrderShippingAddress2: string;
                export const OrderShippingCity: string;
                export const OrderShippingNote: string;
                export const OrderShippingPincode: string;
                export const OrderShippingProviderId: string;
                export const OrderShippingStateId: string;
                export const OrderShippingStateName: string;
                export const OrderShippingToName: string;
                export const OrderSourceName: string;
                export const OrderSourceOrderNumber: string;
                export const OrderTaxAmount: string;
                export const OrderTaxableAmount: string;
                export const OrderUpdateDate: string;
                export const OrderUpdateUserId: string;
                export const OrderVendorId: string;
                export const ProductActivateSerialKey: string;
                export const ProductAllowSerialKeyGeneration: string;
                export const ProductAllowedDevices: string;
                export const ProductDescription: string;
                export const ProductDownloadUrl1: string;
                export const ProductDownloadUrl2: string;
                export const ProductEAccessStatus: string;
                export const ProductEOpens: string;
                export const ProductEPackingType: string;
                export const ProductEProductType: string;
                export const ProductERioplayVersion: string;
                export const ProductEShippedby: string;
                export const ProductEValidity: string;
                export const ProductEValidityType: string;
                export const ProductEWatchTime: string;
                export const ProductGrossAmount: string;
                export const ProductHasBooks: string;
                export const ProductHasCourier: string;
                export const ProductHasPenDrive: string;
                export const ProductHasVod: string;
                export const ProductHeight: string;
                export const ProductId: string;
                export const ProductInAppDownload: string;
                export const ProductInsertDate: string;
                export const ProductInsertUserId: string;
                export const ProductIsActive: string;
                export const ProductIsCombo: string;
                export const ProductIsLive: string;
                export const ProductLength: string;
                export const ProductNote: string;
                export const ProductProcesOrderOnPaid: string;
                export const ProductProductIds: string;
                export const ProductProductName: string;
                export const ProductProductQueryInfo: string;
                export const ProductRioPlayTenantId: string;
                export const ProductRioplayProductCode: string;
                export const ProductSecretkey: string;
                export const ProductSkuCode: string;
                export const ProductSupportInfo: string;
                export const ProductTeacherName: string;
                export const ProductTemplateSerialKeyId: string;
                export const ProductTotalAllowedDuration: string;
                export const ProductUpdateDate: string;
                export const ProductUpdateUserId: string;
                export const ProductValidTill: string;
                export const ProductVendorId: string;
                export const ProductWebsiteUrl: string;
                export const ProductWeight: string;
                export const ProductWidth: string;
                export const Quantity: string;
                export const SerialKey: string;
                export const TaxAmount: string;
                export const TaxableAmount: string;
                export const TotalAllowedDuration: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
                export const ValidTill: string;
            }

            namespace OrderSaleReport {
                export const Address1: string;
                export const Address2: string;
                export const AffiliateId: string;
                export const CgstAmount: string;
                export const CgstRate: string;
                export const City: string;
                export const Currencies: string;
                export const CustomerEmail1: string;
                export const CustomerMobile1: string;
                export const CustomerName: string;
                export const DiscountAmount: string;
                export const DiscountCode: string;
                export const Gstin: string;
                export const Id: string;
                export const IgstAmount: string;
                export const IgstRate: string;
                export const InvoiceNumber: string;
                export const NetAmount: string;
                export const OrderDate: string;
                export const OrderId: string;
                export const PaymentDate: string;
                export const PaymentMode: string;
                export const PaymentStatus: string;
                export const PinCode: string;
                export const ProductName: string;
                export const ProductSpecificationName: string;
                export const SgstAmount: string;
                export const SgstRate: string;
                export const SourceType: string;
                export const StateName: string;
                export const TaxableAmount: string;
                export const TaxableAmountNet: string;
                export const Total: string;
                export const TotalTax: string;
                export const TransactionId: string;
            }

            namespace OrderShipping {
                export const EStatus: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const OrderBillingAddress1: string;
                export const OrderBillingAddress2: string;
                export const OrderBillingCity: string;
                export const OrderBillingPincode: string;
                export const OrderBillingStateId: string;
                export const OrderCustomerEmail1: string;
                export const OrderCustomerEmail2: string;
                export const OrderCustomerId: string;
                export const OrderCustomerMobile1: string;
                export const OrderCustomerMobile2: string;
                export const OrderCustomerName: string;
                export const OrderDiscountAmount: string;
                export const OrderDiscountCoupon: string;
                export const OrderDiscountPer: string;
                export const OrderEFranchiseeDiscount: string;
                export const OrderEFranchiseeDiscountType: string;
                export const OrderEInvoiceStatus: string;
                export const OrderEInvoiceTo: string;
                export const OrderEOrderProcessBy: string;
                export const OrderEOrderStatus: string;
                export const OrderEPaymentStatus: string;
                export const OrderEPaymentType: string;
                export const OrderEShippingStatus: string;
                export const OrderEShippingType: string;
                export const OrderESourceType: string;
                export const OrderEmailSendCount: string;
                export const OrderExpectedShippingDate: string;
                export const OrderFranchiseeDiscountAmount: string;
                export const OrderFranchiseeDiscountValue: string;
                export const OrderFranchiseeId: string;
                export const OrderGrossAmount: string;
                export const OrderGstin: string;
                export const OrderId: string;
                export const OrderInsertDate: string;
                export const OrderInsertUserId: string;
                export const OrderInvoiceCompanyId: string;
                export const OrderIsActive: string;
                export const OrderIsEmailSent: string;
                export const OrderLastEmailSentDate: string;
                export const OrderMailId: string;
                export const OrderNetAmount: string;
                export const OrderOrderDate: string;
                export const OrderOrderNumber: string;
                export const OrderShippingAddress1: string;
                export const OrderShippingAddress2: string;
                export const OrderShippingCity: string;
                export const OrderShippingNote: string;
                export const OrderShippingPincode: string;
                export const OrderShippingStateId: string;
                export const OrderShippingStateName: string;
                export const OrderShippingToName: string;
                export const OrderSourceName: string;
                export const OrderSourceOrderNumber: string;
                export const OrderTaxableAmount: string;
                export const OrderUpdateDate: string;
                export const OrderUpdateUserId: string;
                export const OrderVendorId: string;
                export const ShippingCost: string;
                export const ShippingDate: string;
                export const ShippingProviderBankAccountNo: string;
                export const ShippingProviderBankIfscCode: string;
                export const ShippingProviderBankName: string;
                export const ShippingProviderDescription: string;
                export const ShippingProviderEApiStatus: string;
                export const ShippingProviderEShippingProviderType: string;
                export const ShippingProviderGstCertificate: string;
                export const ShippingProviderGstin: string;
                export const ShippingProviderId: string;
                export const ShippingProviderInsertDate: string;
                export const ShippingProviderInsertUserId: string;
                export const ShippingProviderIsActive: string;
                export const ShippingProviderIsDefault: string;
                export const ShippingProviderPan: string;
                export const ShippingProviderSecret: string;
                export const ShippingProviderShippingProviderName: string;
                export const ShippingProviderTrackingUrl: string;
                export const ShippingProviderUpdateDate: string;
                export const ShippingProviderUpdateUserId: string;
                export const ShippingProviderVendorId: string;
                export const TrackingId: string;
                export const TrackingUrl: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace OrderShippingItemsReport {
                export const BookName: string;
                export const Id: string;
                export const OrderId: string;
                export const OrderNumber: string;
                export const OrdershippingBooksId: string;
                export const PenDriveTypeId: string;
                export const PendriveType: string;
                export const ProductBookid: string;
                export const ProductId: string;
                export const ProductName: string;
                export const Quantity: string;
                export const ShippingProviderId: string;
                export const ShippingProviderName: string;
                export const SourceType: string;
                export const TrackingId: string;
                export const TrackingUrl: string;
            }

            namespace OrderShippingReport {
                export const BookStatus: string;
                export const CustomerName: string;
                export const HasBooks: string;
                export const Id: string;
                export const OrderDate: string;
                export const OrderId: string;
                export const OrderNumber: string;
                export const ProductName: string;
                export const ProductSpecificationName: string;
                export const SourceType: string;
            }

            namespace OrderTransactionReport {
                export const BillingAddress1: string;
                export const BillingAddress2: string;
                export const BillingCity: string;
                export const BillingCountry: string;
                export const BillingPincode: string;
                export const BillingStateId: string;
                export const CurrencyAmount: string;
                export const CurrencyId: string;
                export const CustomerEmail1: string;
                export const CustomerEmail2: string;
                export const CustomerId: string;
                export const CustomerMobile1: string;
                export const CustomerMobile2: string;
                export const CustomerName: string;
                export const DiscountAmount: string;
                export const DiscountCoupon: string;
                export const DiscountPer: string;
                export const EFranchiseeDiscount: string;
                export const EFranchiseeDiscountType: string;
                export const EInvoiceStatus: string;
                export const EInvoiceTo: string;
                export const EOrderProcessBy: string;
                export const EOrderStatus: string;
                export const EPaymentStatus: string;
                export const EPaymentType: string;
                export const EShippingStatus: string;
                export const EShippingType: string;
                export const ESourceType: string;
                export const EmailSendCount: string;
                export const ExpectedShippingDate: string;
                export const FranchiseeDiscountAmount: string;
                export const FranchiseeDiscountValue: string;
                export const FranchiseeId: string;
                export const FreezeData: string;
                export const GrossAmount: string;
                export const Gstin: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const InvoiceCompanyId: string;
                export const IsActive: string;
                export const IsEmailSent: string;
                export const LastEmailSentDate: string;
                export const MailId: string;
                export const Mode: string;
                export const NetAmount: string;
                export const NetAmountAfterFrDiscount: string;
                export const OrderDate: string;
                export const OrderNumber: string;
                export const PaymentMode: string;
                export const ShippingAddress1: string;
                export const ShippingAddress2: string;
                export const ShippingCity: string;
                export const ShippingCountry: string;
                export const ShippingNote: string;
                export const ShippingPincode: string;
                export const ShippingProviderId: string;
                export const ShippingStateId: string;
                export const ShippingToName: string;
                export const SourceName: string;
                export const SourceOrderNumber: string;
                export const SrId: string;
                export const TaxAmount: string;
                export const TaxableAmount: string;
                export const TransactionId: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
                export const VendorId: string;
            }

            namespace ShippingReport {
                export const CustomerEmail1: string;
                export const CustomerEmail2: string;
                export const CustomerMobile1: string;
                export const CustomerMobile2: string;
                export const CustomerName: string;
                export const Id: string;
                export const OrderDate: string;
                export const OrderId: string;
                export const OrderNumber: string;
                export const ShippingAddress1: string;
                export const ShippingAddress2: string;
                export const ShippingCity: string;
                export const ShippingDate: string;
                export const ShippingPincode: string;
                export const ShippingProviderId: string;
                export const ShippingProviderName: string;
                export const SourceType: string;
                export const Status: string;
                export const TrackingId: string;
                export const TrackingUrl: string;
            }

            namespace TeacherOutstanding {
                export const ESettelementStatus: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const OrderBillingAddress1: string;
                export const OrderBillingAddress2: string;
                export const OrderBillingCity: string;
                export const OrderBillingPincode: string;
                export const OrderBillingStateId: string;
                export const OrderCurrencyAmount: string;
                export const OrderCurrencyId: string;
                export const OrderCustomerEmail1: string;
                export const OrderCustomerEmail2: string;
                export const OrderCustomerId: string;
                export const OrderCustomerMobile1: string;
                export const OrderCustomerMobile2: string;
                export const OrderCustomerName: string;
                export const OrderDiscountAmount: string;
                export const OrderDiscountCoupon: string;
                export const OrderDiscountPer: string;
                export const OrderEFranchiseeDiscount: string;
                export const OrderEFranchiseeDiscountType: string;
                export const OrderEInvoiceStatus: string;
                export const OrderEInvoiceTo: string;
                export const OrderEOrderProcessBy: string;
                export const OrderEOrderStatus: string;
                export const OrderEPaymentStatus: string;
                export const OrderEPaymentType: string;
                export const OrderEShippingStatus: string;
                export const OrderEShippingType: string;
                export const OrderESourceType: string;
                export const OrderEmailSendCount: string;
                export const OrderExpectedShippingDate: string;
                export const OrderFranchiseeDiscountAmount: string;
                export const OrderFranchiseeDiscountValue: string;
                export const OrderFranchiseeId: string;
                export const OrderFreezeData: string;
                export const OrderGrossAmount: string;
                export const OrderGstin: string;
                export const OrderId: string;
                export const OrderInsertDate: string;
                export const OrderInsertUserId: string;
                export const OrderInvoiceCompanyId: string;
                export const OrderIsActive: string;
                export const OrderIsEmailSent: string;
                export const OrderLastEmailSentDate: string;
                export const OrderMailId: string;
                export const OrderNetAmount: string;
                export const OrderOrderDate: string;
                export const OrderOrderNumber: string;
                export const OrderProductsAllowedDevices: string;
                export const OrderProductsCost: string;
                export const OrderProductsDiscountAmt: string;
                export const OrderProductsDownloadUrl1: string;
                export const OrderProductsDownloadUrl2: string;
                export const OrderProductsEAccessStatus: string;
                export const OrderProductsEFranchiseeDiscountType: string;
                export const OrderProductsEOpens: string;
                export const OrderProductsESerialkeyStatus: string;
                export const OrderProductsEValidity: string;
                export const OrderProductsEValidityType: string;
                export const OrderProductsEWatchTime: string;
                export const OrderProductsFranchiseeDiscountAmount: string;
                export const OrderProductsFranchiseeDiscountValue: string;
                export const OrderProductsGrossAmount: string;
                export const OrderProductsHasBooks: string;
                export const OrderProductsHasCourier: string;
                export const OrderProductsHasPendrive: string;
                export const OrderProductsId: string;
                export const OrderProductsInsertDate: string;
                export const OrderProductsInsertUserId: string;
                export const OrderProductsInvoiceCompanyId: string;
                export const OrderProductsIsActive: string;
                export const OrderProductsIsLive: string;
                export const OrderProductsIsTemplateSerialKey: string;
                export const OrderProductsNetAmount: string;
                export const OrderProductsNote: string;
                export const OrderProductsOrderId: string;
                export const OrderProductsProductId: string;
                export const OrderProductsQuantity: string;
                export const OrderProductsSerialKey: string;
                export const OrderProductsTaxAmount: string;
                export const OrderProductsTaxableAmount: string;
                export const OrderProductsTotalAllowedDuration: string;
                export const OrderProductsUpdateDate: string;
                export const OrderProductsUpdateUserId: string;
                export const OrderProductsValidTill: string;
                export const OrderProdutcsCost: string;
                export const OrderShippingAddress1: string;
                export const OrderShippingAddress2: string;
                export const OrderShippingCity: string;
                export const OrderShippingNote: string;
                export const OrderShippingPincode: string;
                export const OrderShippingProviderId: string;
                export const OrderShippingStateId: string;
                export const OrderShippingToName: string;
                export const OrderSourceName: string;
                export const OrderSourceOrderNumber: string;
                export const OrderTaxAmount: string;
                export const OrderTaxableAmount: string;
                export const OrderUpdateDate: string;
                export const OrderUpdateUserId: string;
                export const OrderVendorId: string;
                export const Qty: string;
                export const SettelmentId: string;
                export const ShareAmount: string;
                export const SharePercentage: string;
                export const TeacherAddress: string;
                export const TeacherAlternateEmail: string;
                export const TeacherAlternateMobile: string;
                export const TeacherBankAccountName: string;
                export const TeacherBankAccountNo: string;
                export const TeacherBankAccountType: string;
                export const TeacherBankIfscCode: string;
                export const TeacherBankName: string;
                export const TeacherCity: string;
                export const TeacherDescription: string;
                export const TeacherEmail: string;
                export const TeacherGstCertificate: string;
                export const TeacherGstin: string;
                export const TeacherId: string;
                export const TeacherInsertDate: string;
                export const TeacherInsertUserId: string;
                export const TeacherIsActive: string;
                export const TeacherMobile: string;
                export const TeacherName: string;
                export const TeacherPan: string;
                export const TeacherPincode: string;
                export const TeacherStateId: string;
                export const TeacherUpdateDate: string;
                export const TeacherUpdateUserId: string;
                export const TeacherUserId: string;
                export const TotalShare: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }
        }

        namespace Shipping {

            namespace ShippingProviders {
                export const BankAccountNo: string;
                export const BankIfscCode: string;
                export const BankName: string;
                export const Description: string;
                export const EApiStatus: string;
                export const EShippingProviderType: string;
                export const GstCertificate: string;
                export const Gstin: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const IsDefault: string;
                export const Pan: string;
                export const Secret: string;
                export const ShippingProviderName: string;
                export const TrackingId: string;
                export const TrackingUrl: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
                export const VendorAddress: string;
                export const VendorBankAccountName: string;
                export const VendorBankAccountNo: string;
                export const VendorBankAccountType: string;
                export const VendorBankIfscCode: string;
                export const VendorBankName: string;
                export const VendorCity: string;
                export const VendorCountry: string;
                export const VendorDescription: string;
                export const VendorEmail: string;
                export const VendorGstCertificate: string;
                export const VendorGstin: string;
                export const VendorId: string;
                export const VendorInsertDate: string;
                export const VendorInsertUserId: string;
                export const VendorIsActive: string;
                export const VendorName: string;
                export const VendorPan: string;
                export const VendorPincode: string;
                export const VendorStateId: string;
                export const VendorUpdateDate: string;
                export const VendorUpdateUserId: string;
                export const VendorUserId: string;
            }

            namespace ShippingRules {
                export const EPaymentMode: string;
                export const EPriority: string;
                export const Id: string;
                export const ShippingProviderBankAccountNo: string;
                export const ShippingProviderBankIfscCode: string;
                export const ShippingProviderBankName: string;
                export const ShippingProviderDescription: string;
                export const ShippingProviderEApiStatus: string;
                export const ShippingProviderEShippingProviderType: string;
                export const ShippingProviderGstCertificate: string;
                export const ShippingProviderGstin: string;
                export const ShippingProviderId: string;
                export const ShippingProviderInsertDate: string;
                export const ShippingProviderInsertUserId: string;
                export const ShippingProviderIsActive: string;
                export const ShippingProviderIsDefault: string;
                export const ShippingProviderPan: string;
                export const ShippingProviderSecret: string;
                export const ShippingProviderShippingProviderName: string;
                export const ShippingProviderTrackingUrl: string;
                export const ShippingProviderUpdateDate: string;
                export const ShippingProviderUpdateUserId: string;
                export const ShippingProviderVendorId: string;
            }

            namespace ShippingTrackingNumbers {
                export const BarcodeImage: string;
                export const BarcodeType: string;
                export const ESource: string;
                export const EStatus: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const IssueDate: string;
                export const OrderBillingAddress1: string;
                export const OrderBillingAddress2: string;
                export const OrderBillingCity: string;
                export const OrderBillingPincode: string;
                export const OrderBillingStateId: string;
                export const OrderCustomerEmail1: string;
                export const OrderCustomerEmail2: string;
                export const OrderCustomerId: string;
                export const OrderCustomerMobile1: string;
                export const OrderCustomerMobile2: string;
                export const OrderCustomerName: string;
                export const OrderDiscountAmount: string;
                export const OrderDiscountCoupon: string;
                export const OrderDiscountPer: string;
                export const OrderEFranchiseeDiscount: string;
                export const OrderEFranchiseeDiscountType: string;
                export const OrderEInvoiceStatus: string;
                export const OrderEInvoiceTo: string;
                export const OrderEOrderProcessBy: string;
                export const OrderEOrderStatus: string;
                export const OrderEPaymentStatus: string;
                export const OrderEPaymentType: string;
                export const OrderEShippingStatus: string;
                export const OrderEShippingType: string;
                export const OrderESourceType: string;
                export const OrderEmailSendCount: string;
                export const OrderExpectedShippingDate: string;
                export const OrderFranchiseeDiscountAmount: string;
                export const OrderFranchiseeDiscountValue: string;
                export const OrderFranchiseeId: string;
                export const OrderFreezeData: string;
                export const OrderGrossAmount: string;
                export const OrderGstin: string;
                export const OrderId: string;
                export const OrderInsertDate: string;
                export const OrderInsertUserId: string;
                export const OrderInvoiceCompanyId: string;
                export const OrderIsActive: string;
                export const OrderIsEmailSent: string;
                export const OrderLastEmailSentDate: string;
                export const OrderMailId: string;
                export const OrderNetAmount: string;
                export const OrderOrderDate: string;
                export const OrderOrderNumber: string;
                export const OrderShippingAddress1: string;
                export const OrderShippingAddress2: string;
                export const OrderShippingCity: string;
                export const OrderShippingNote: string;
                export const OrderShippingPincode: string;
                export const OrderShippingStateId: string;
                export const OrderShippingToName: string;
                export const OrderSourceName: string;
                export const OrderSourceOrderNumber: string;
                export const OrderTaxAmount: string;
                export const OrderTaxableAmount: string;
                export const OrderUpdateDate: string;
                export const OrderUpdateUserId: string;
                export const OrderVendorId: string;
                export const ShippingProviderBankAccountNo: string;
                export const ShippingProviderBankIfscCode: string;
                export const ShippingProviderBankName: string;
                export const ShippingProviderDescription: string;
                export const ShippingProviderEApiStatus: string;
                export const ShippingProviderEShippingProviderType: string;
                export const ShippingProviderGstCertificate: string;
                export const ShippingProviderGstin: string;
                export const ShippingProviderId: string;
                export const ShippingProviderInsertDate: string;
                export const ShippingProviderInsertUserId: string;
                export const ShippingProviderIsActive: string;
                export const ShippingProviderIsDefault: string;
                export const ShippingProviderPan: string;
                export const ShippingProviderSecret: string;
                export const ShippingProviderShippingProviderName: string;
                export const ShippingProviderTrackingUrl: string;
                export const ShippingProviderUpdateDate: string;
                export const ShippingProviderUpdateUserId: string;
                export const ShippingProviderVendorId: string;
                export const TrackingNumber: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }
        }

        namespace Users {

            namespace BrandAmbassador {
                export const Address: string;
                export const AlternateEmail: string;
                export const AlternateMobile: string;
                export const BankAccountName: string;
                export const BankAccountNo: string;
                export const BankAccountType: string;
                export const BankIfscCode: string;
                export const BankName: string;
                export const City: string;
                export const CustomerAttemptId: string;
                export const CustomerCouponCode: string;
                export const CustomerCourseId: string;
                export const CustomerECustomerType: string;
                export const CustomerEmailId1: string;
                export const CustomerEmailId2: string;
                export const CustomerGstin: string;
                export const CustomerId: string;
                export const CustomerInsertDate: string;
                export const CustomerInsertUserId: string;
                export const CustomerIsActive: string;
                export const CustomerLevelId: string;
                export const CustomerMobile1: string;
                export const CustomerMobile2: string;
                export const CustomerName: string;
                export const CustomerUpdateDate: string;
                export const CustomerUpdateUserId: string;
                export const Description: string;
                export const DiscountCoupon: string;
                export const Email: string;
                export const GstCertificate: string;
                export const Gstin: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const Mobile: string;
                export const Name: string;
                export const Pan: string;
                export const Pincode: string;
                export const StateId: string;
                export const StateInsertDate: string;
                export const StateInsertUserId: string;
                export const StateIsActive: string;
                export const StateIsHomeState: string;
                export const StateName: string;
                export const StateUpdateDate: string;
                export const StateUpdateUserId: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
                export const UserAllowedIps: string;
                export const UserCcEmails: string;
                export const UserDisplayName: string;
                export const UserEmail: string;
                export const UserId: string;
                export const UserInsertDate: string;
                export const UserInsertUserId: string;
                export const UserIsActive: string;
                export const UserLastDirectoryUpdate: string;
                export const UserMobilePhoneNumber: string;
                export const UserMobilePhoneVerified: string;
                export const UserSecretkey: string;
                export const UserSource: string;
                export const UserTwoFactorAuth: string;
                export const UserUpdateDate: string;
                export const UserUpdateUserId: string;
                export const UserUserImage: string;
                export const UserUsername: string;
                export const UserXapikey: string;
                export const UserXapisecret: string;
            }

            namespace CustomerAddress {
                export const Address1: string;
                export const Address2: string;
                export const City: string;
                export const Country: string;
                export const CustomerCouponCode: string;
                export const CustomerECustomerType: string;
                export const CustomerEmailId1: string;
                export const CustomerEmailId2: string;
                export const CustomerGstin: string;
                export const CustomerId: string;
                export const CustomerInsertDate: string;
                export const CustomerInsertUserId: string;
                export const CustomerIsActive: string;
                export const CustomerMobile1: string;
                export const CustomerMobile2: string;
                export const CustomerName: string;
                export const CustomerUpdateDate: string;
                export const CustomerUpdateUserId: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const PinCode: string;
                export const StateId: string;
                export const StateName: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace Customers {
                export const AttemptId: string;
                export const AttemptName: string;
                export const CouponCode: string;
                export const CourseId: string;
                export const CourseName: string;
                export const CustomerDisplayName: string;
                export const ECustomerType: string;
                export const EmailId1: string;
                export const EmailId2: string;
                export const Gstin: string;
                export const HasPurchased: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const LevelId: string;
                export const LevelName: string;
                export const Mobile1: string;
                export const Mobile2: string;
                export const Name: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace Franchisee {
                export const Address: string;
                export const AffiliateId: string;
                export const AlternateEmail: string;
                export const AlternateMobile: string;
                export const AvailableCreditBalance: string;
                export const BankAccountName: string;
                export const BankAccountNo: string;
                export const BankAccountType: string;
                export const BankIfscCode: string;
                export const BankName: string;
                export const City: string;
                export const CustomerCouponCode: string;
                export const CustomerECustomerType: string;
                export const CustomerEmailId1: string;
                export const CustomerEmailId2: string;
                export const CustomerGstin: string;
                export const CustomerId: string;
                export const CustomerInsertDate: string;
                export const CustomerInsertUserId: string;
                export const CustomerIsActive: string;
                export const CustomerMobile1: string;
                export const CustomerMobile2: string;
                export const CustomerName: string;
                export const CustomerUpdateDate: string;
                export const CustomerUpdateUserId: string;
                export const Description: string;
                export const DiscountCoupon: string;
                export const Email: string;
                export const GstCertificate: string;
                export const Gstin: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const IsCustomer: string;
                export const IsGstInApplied: string;
                export const IsPostPayAllowed: string;
                export const Mobile: string;
                export const Name: string;
                export const Pan: string;
                export const Pincode: string;
                export const StateId: string;
                export const StateInsertDate: string;
                export const StateInsertUserId: string;
                export const StateIsActive: string;
                export const StateIsHomeState: string;
                export const StateName: string;
                export const StateUpdateDate: string;
                export const StateUpdateUserId: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
                export const UserDisplayName: string;
                export const UserEmail: string;
                export const UserId: string;
                export const UserInsertDate: string;
                export const UserInsertUserId: string;
                export const UserIsActive: string;
                export const UserLastDirectoryUpdate: string;
                export const UserMobilePhoneNumber: string;
                export const UserMobilePhoneVerified: string;
                export const UserSource: string;
                export const UserTwoFactorAuth: string;
                export const UserUpdateDate: string;
                export const UserUpdateUserId: string;
                export const UserUserImage: string;
                export const UserUsername: string;
            }

            namespace Support {
                export const AllowedIps: string;
                export const DisplayName: string;
                export const Email: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const LastDirectoryUpdate: string;
                export const MobilePhoneNumber: string;
                export const MobilePhoneVerified: string;
                export const PasswordHash: string;
                export const PasswordSalt: string;
                export const Secretkey: string;
                export const Source: string;
                export const TwoFactorAuth: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
                export const UserId: string;
                export const UserImage: string;
                export const UserRole: string;
                export const Username: string;
            }

            namespace Teachers {
                export const Address: string;
                export const AlternateEmail: string;
                export const AlternateMobile: string;
                export const BankAccountName: string;
                export const BankAccountNo: string;
                export const BankAccountType: string;
                export const BankIfscCode: string;
                export const BankName: string;
                export const City: string;
                export const Description: string;
                export const Email: string;
                export const GstCertificate: string;
                export const Gstin: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const IsGstApplicable: string;
                export const Mobile: string;
                export const Name: string;
                export const Pan: string;
                export const Pincode: string;
                export const StateId: string;
                export const StateInsertDate: string;
                export const StateInsertUserId: string;
                export const StateIsActive: string;
                export const StateIsHomeState: string;
                export const StateName: string;
                export const StateUpdateDate: string;
                export const StateUpdateUserId: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
                export const UserDisplayName: string;
                export const UserEmail: string;
                export const UserId: string;
                export const UserInsertDate: string;
                export const UserInsertUserId: string;
                export const UserIsActive: string;
                export const UserLastDirectoryUpdate: string;
                export const UserMobilePhoneNumber: string;
                export const UserMobilePhoneVerified: string;
                export const UserSource: string;
                export const UserTwoFactorAuth: string;
                export const UserUpdateDate: string;
                export const UserUpdateUserId: string;
                export const UserUserImage: string;
                export const UserUsername: string;
            }

            namespace Vendors {
                export const Address: string;
                export const BankAccountName: string;
                export const BankAccountNo: string;
                export const BankAccountType: string;
                export const BankIfscCode: string;
                export const BankName: string;
                export const City: string;
                export const Country: string;
                export const Description: string;
                export const Email: string;
                export const GstCertificate: string;
                export const Gstin: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const Name: string;
                export const Pan: string;
                export const Pincode: string;
                export const StateId: string;
                export const StateInsertDate: string;
                export const StateInsertUserId: string;
                export const StateIsActive: string;
                export const StateIsHomeState: string;
                export const StateName: string;
                export const StateUpdateDate: string;
                export const StateUpdateUserId: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
                export const UserDisplayName: string;
                export const UserEmail: string;
                export const UserId: string;
                export const UserInsertDate: string;
                export const UserInsertUserId: string;
                export const UserIsActive: string;
                export const UserLastDirectoryUpdate: string;
                export const UserMobilePhoneNumber: string;
                export const UserMobilePhoneVerified: string;
                export const UserSource: string;
                export const UserTwoFactorAuth: string;
                export const UserUpdateDate: string;
                export const UserUpdateUserId: string;
                export const UserUserImage: string;
                export const UserUsername: string;
            }
        }

        namespace Wallet {

            namespace CreditJournal {
                export const Description: string;
                export const Id: string;
                export const Kind: string;
                export const Name: string;
            }

            namespace CreditWallet {
                export const AssetTypeId: string;
                export const CreditBalance: string;
                export const Credits: string;
                export const FranchiseeAddress: string;
                export const FranchiseeAffiliateId: string;
                export const FranchiseeAlternateEmail: string;
                export const FranchiseeAlternateMobile: string;
                export const FranchiseeBankAccountName: string;
                export const FranchiseeBankAccountNo: string;
                export const FranchiseeBankAccountType: string;
                export const FranchiseeBankIfscCode: string;
                export const FranchiseeBankName: string;
                export const FranchiseeCity: string;
                export const FranchiseeCustomerId: string;
                export const FranchiseeDescription: string;
                export const FranchiseeDiscountCoupon: string;
                export const FranchiseeEmail: string;
                export const FranchiseeGstCertificate: string;
                export const FranchiseeGstin: string;
                export const FranchiseeId: string;
                export const FranchiseeInsertDate: string;
                export const FranchiseeInsertUserId: string;
                export const FranchiseeIsActive: string;
                export const FranchiseeIsCustomer: string;
                export const FranchiseeIsPostPayAllowed: string;
                export const FranchiseeMobile: string;
                export const FranchiseeName: string;
                export const FranchiseePan: string;
                export const FranchiseePincode: string;
                export const FranchiseeStateId: string;
                export const FranchiseeUpdateDate: string;
                export const FranchiseeUpdateUserId: string;
                export const FranchiseeUserId: string;
                export const Id: string;
                export const JournalDescription: string;
                export const JournalId: string;
                export const JournalKind: string;
                export const JournalName: string;
                export const TransactionDate: string;
                export const TransactionDetails: string;
                export const TransactionId: string;
                export const TransactionNo: string;
            }
        }
    }

    declare namespace Forms {

        namespace Membership {

            namespace ChangePassword {
                export const FormTitle: string;
                export const SubmitButton: string;
                export const Success: string;
            }

            namespace ForgotPassword {
                export const BackToLogin: string;
                export const FormInfo: string;
                export const FormTitle: string;
                export const SubmitButton: string;
                export const Success: string;
            }

            namespace Login {
                export const FacebookButton: string;
                export const ForgotPassword: string;
                export const GoogleButton: string;
                export const LoginToYourAccount: string;
                export const OR: string;
                export const RememberMe: string;
                export const SignInButton: string;
                export const SignUpButton: string;
            }

            namespace ResetPassword {
                export const BackToLogin: string;
                export const EmailSubject: string;
                export const FormTitle: string;
                export const SubmitButton: string;
                export const Success: string;
            }

            namespace SignUp {
                export const AcceptTerms: string;
                export const ActivateEmailSubject: string;
                export const ActivationCompleteMessage: string;
                export const BackToLogin: string;
                export const ConfirmEmail: string;
                export const ConfirmPassword: string;
                export const DisplayName: string;
                export const Email: string;
                export const FormInfo: string;
                export const FormTitle: string;
                export const Password: string;
                export const SubmitButton: string;
                export const Success: string;
            }
        }
    }

    declare namespace Navigation {
        export const LogoutLink: string;
        export const SiteTitle: string;
    }

    declare namespace Site {

        namespace AccessDenied {
            export const ClickToChangeUser: string;
            export const ClickToLogin: string;
            export const LackPermissions: string;
            export const NotLoggedIn: string;
            export const PageTitle: string;
        }

        namespace BasicProgressDialog {
            export const CancelTitle: string;
            export const PleaseWait: string;
        }

        namespace BulkServiceAction {
            export const AllHadErrorsFormat: string;
            export const AllSuccessFormat: string;
            export const ConfirmationFormat: string;
            export const ErrorCount: string;
            export const NothingToProcess: string;
            export const SomeHadErrorsFormat: string;
            export const SuccessCount: string;
        }

        namespace Dashboard {
            export const ContentDescription: string;
        }

        namespace Dialogs {
            export const PendingChangesConfirmation: string;
        }

        namespace Layout {
            export const FooterCopyright: string;
            export const FooterInfo: string;
            export const FooterRights: string;
            export const GeneralSettings: string;
            export const Language: string;
            export const Theme: string;
            export const ThemeAzure: string;
            export const ThemeAzureLight: string;
            export const ThemeBlack: string;
            export const ThemeBlackLight: string;
            export const ThemeBlue: string;
            export const ThemeBlueLight: string;
            export const ThemeCosmos: string;
            export const ThemeCosmosLight: string;
            export const ThemeGlassy: string;
            export const ThemeGlassyLight: string;
            export const ThemeGreen: string;
            export const ThemeGreenLight: string;
            export const ThemePurple: string;
            export const ThemePurpleLight: string;
            export const ThemeRed: string;
            export const ThemeRedLight: string;
            export const ThemeYellow: string;
            export const ThemeYellowLight: string;
        }

        namespace RolePermissionDialog {
            export const DialogTitle: string;
            export const EditButton: string;
            export const SaveSuccess: string;
        }

        namespace UserDialog {
            export const EditPermissionsButton: string;
            export const EditRolesButton: string;
        }

        namespace UserPermissionDialog {
            export const DialogTitle: string;
            export const Grant: string;
            export const Permission: string;
            export const Revoke: string;
            export const SaveSuccess: string;
        }

        namespace UserRoleDialog {
            export const DialogTitle: string;
            export const SaveSuccess: string;
        }

        namespace ValidationError {
            export const Title: string;
        }
    }

    declare namespace Validation {
        export const AuthenticationError: string;
        export const CantFindUserWithEmail: string;
        export const CurrentPasswordMismatch: string;
        export const DeleteForeignKeyError: string;
        export const EmailConfirm: string;
        export const EmailInUse: string;
        export const InvalidActivateToken: string;
        export const InvalidResetToken: string;
        export const MinRequiredPasswordLength: string;
        export const SavePrimaryKeyError: string;
    }

    RioERP['Texts'] = Q.proxyTexts(Texts, '', {Db:{Administration:{Language:{Id:1,LanguageId:1,LanguageName:1},Role:{RoleId:1,RoleKey:1,RoleName:1},RolePermission:{PermissionKey:1,RoleId:1,RolePermissionId:1,RoleRoleName:1},Translation:{CustomText:1,EntityPlural:1,Key:1,OverrideConfirmation:1,SaveChangesButton:1,SourceLanguage:1,SourceText:1,TargetLanguage:1,TargetText:1},User:{AllowedIps:1,CCEmails:1,DisplayName:1,Email:1,ImpersonationToken:1,InsertDate:1,InsertUserId:1,IsActive:1,LastDirectoryUpdate:1,MobilePhoneNumber:1,MobilePhoneVerified:1,Password:1,PasswordConfirm:1,PasswordHash:1,PasswordSalt:1,Roles:1,SecretKey:1,Source:1,TwoFactorAuth:1,UpdateDate:1,UpdateUserId:1,UserId:1,UserImage:1,Username:1,xapikey:1,xapisecret:1},UserPermission:{Granted:1,PermissionKey:1,User:1,UserId:1,UserPermissionId:1,Username:1},UserRole:{RoleId:1,User:1,UserId:1,UserRoleId:1,Username:1}},Carts:{Cart:{CartProducts:1,CustomerEmail1:1,CustomerEmail2:1,CustomerId:1,CustomerMobile1:1,CustomerMobile2:1,CustomerName:1,DiscountAmount:1,DiscountCoupon:1,EFranchiseeDiscount:1,EFranchiseeDiscountType:1,EInvoiceTo:1,FranchiseeDiscountAmount:1,FranchiseeDiscountValue:1,FranchiseeId:1,FranchiseeName:1,GrossAmount:1,Id:1,InsertDate:1,InsertUserId:1,InvoiceCompanyId:1,IsActive:1,Name:1,NetAmount:1,ShippingAddress1:1,ShippingAddress2:1,ShippingCity:1,ShippingPincode:1,ShippingStateId:1,SourceOrderNumber:1,TaxAmount:1,TaxableAmount:1,UpdateDate:1,UpdateUserId:1},CartProductBillingItems:{CartCustomerEmail1:1,CartCustomerEmail2:1,CartCustomerId:1,CartCustomerMobile1:1,CartCustomerMobile2:1,CartCustomerName:1,CartDiscountAmount:1,CartDiscountCoupon:1,CartEFranchiseeDiscount:1,CartEFranchiseeDiscountType:1,CartEInvoiceTo:1,CartFranchiseeDiscountAmount:1,CartFranchiseeDiscountValue:1,CartFranchiseeId:1,CartGrossAmount:1,CartId:1,CartInsertDate:1,CartInsertUserId:1,CartInvoiceCompanyId:1,CartIsActive:1,CartName:1,CartNetAmount:1,CartProductsAllowedDevices:1,CartProductsCartId:1,CartProductsCost:1,CartProductsDiscountAmt:1,CartProductsDownloadUrl1:1,CartProductsDownloadUrl2:1,CartProductsEAccessStatus:1,CartProductsEFranchiseeDiscountType:1,CartProductsEOpens:1,CartProductsESerialkeyStatus:1,CartProductsEValidity:1,CartProductsEValidityType:1,CartProductsEWatchTime:1,CartProductsFranchiseeDiscountAmount:1,CartProductsFranchiseeDiscountValue:1,CartProductsGrossAmount:1,CartProductsHasBooks:1,CartProductsHasCourier:1,CartProductsHasPendrive:1,CartProductsId:1,CartProductsInsertDate:1,CartProductsInsertUserId:1,CartProductsInvoiceCompanyId:1,CartProductsIsActive:1,CartProductsIsLive:1,CartProductsIsTemplateSerialKey:1,CartProductsNetAmount:1,CartProductsNote:1,CartProductsProductId:1,CartProductsQuantity:1,CartProductsSerialKey:1,CartProductsTaxableAmount:1,CartProductsTotalAllowedDuration:1,CartProductsUpdateDate:1,CartProductsUpdateUserId:1,CartProductsValidTill:1,CartShippingAddress1:1,CartShippingAddress2:1,CartShippingCity:1,CartShippingPincode:1,CartShippingStateId:1,CartTaxableAmount:1,CartUpdateDate:1,CartUpdateUserId:1,DiscountAmount:1,GrossAmount:1,Id:1,InsertDate:1,InsertUserId:1,InvoiceCompanyAddress:1,InvoiceCompanyDisableInvoiceGenration:1,InvoiceCompanyFooterNote:1,InvoiceCompanyGstIn:1,InvoiceCompanyId:1,InvoiceCompanyInvoiceChangeDate:1,InvoiceCompanyInvoiceCode:1,InvoiceCompanyIsDefault:1,InvoiceCompanyIsTaxApplicable:1,InvoiceCompanyLogo1:1,InvoiceCompanyLogo2:1,InvoiceCompanyName:1,InvoiceCompanyStampImage:1,InvoiceCompanyTaxApplicable:1,IsActive:1,NetAmount:1,ProductBillingItemBillingItemName:1,ProductBillingItemEDiscountType:1,ProductBillingItemEndDate:1,ProductBillingItemGrossAmount:1,ProductBillingItemHsnMasterId:1,ProductBillingItemId:1,ProductBillingItemIncludingTax:1,ProductBillingItemInsertDate:1,ProductBillingItemInsertUserId:1,ProductBillingItemInvoiceCompanyId:1,ProductBillingItemIsActive:1,ProductBillingItemProductId:1,ProductBillingItemSpecialGrossAmount:1,ProductBillingItemStartDate:1,ProductBillingItemTaxCategoryId:1,ProductBillingItemUpdateDate:1,ProductBillingItemUpdateUserId:1,TaxCategoryId:1,TaxCategoryInsertDate:1,TaxCategoryInsertUserId:1,TaxCategoryIsActive:1,TaxCategoryName:1,TaxCategoryUpdateDate:1,TaxCategoryUpdateUserId:1,TaxableAmount:1,UpdateDate:1,UpdateUserId:1},CartProductBillingItemsTax:{CartCustomerEmail1:1,CartCustomerEmail2:1,CartCustomerId:1,CartCustomerMobile1:1,CartCustomerMobile2:1,CartCustomerName:1,CartDiscountAmount:1,CartDiscountCoupon:1,CartEFranchiseeDiscount:1,CartEFranchiseeDiscountType:1,CartEInvoiceTo:1,CartFranchiseeDiscountAmount:1,CartFranchiseeDiscountValue:1,CartFranchiseeId:1,CartGrossAmount:1,CartId:1,CartInsertDate:1,CartInsertUserId:1,CartInvoiceCompanyId:1,CartIsActive:1,CartName:1,CartNetAmount:1,CartProductBillingItemsCartId:1,CartProductBillingItemsCartProductsId:1,CartProductBillingItemsDiscountAmount:1,CartProductBillingItemsGrossAmount:1,CartProductBillingItemsId:1,CartProductBillingItemsInsertDate:1,CartProductBillingItemsInsertUserId:1,CartProductBillingItemsInvoiceCompanyId:1,CartProductBillingItemsIsActive:1,CartProductBillingItemsNetAmount:1,CartProductBillingItemsProductBillingItemId:1,CartProductBillingItemsTaxCategoryId:1,CartProductBillingItemsUpdateDate:1,CartProductBillingItemsUpdateUserId:1,CartProductsAllowedDevices:1,CartProductsCartId:1,CartProductsCost:1,CartProductsDiscountAmt:1,CartProductsDownloadUrl1:1,CartProductsDownloadUrl2:1,CartProductsEAccessStatus:1,CartProductsEFranchiseeDiscountType:1,CartProductsEOpens:1,CartProductsESerialkeyStatus:1,CartProductsEValidity:1,CartProductsEValidityType:1,CartProductsEWatchTime:1,CartProductsFranchiseeDiscountAmount:1,CartProductsFranchiseeDiscountValue:1,CartProductsGrossAmount:1,CartProductsHasBooks:1,CartProductsHasCourier:1,CartProductsHasPendrive:1,CartProductsId:1,CartProductsInsertDate:1,CartProductsInsertUserId:1,CartProductsInvoiceCompanyId:1,CartProductsIsActive:1,CartProductsIsLive:1,CartProductsIsTemplateSerialKey:1,CartProductsNetAmount:1,CartProductsNote:1,CartProductsProductId:1,CartProductsQuantity:1,CartProductsSerialKey:1,CartProductsTaxableAmount:1,CartProductsTotalAllowedDuration:1,CartProductsUpdateDate:1,CartProductsUpdateUserId:1,CartProductsValidTill:1,CartShippingAddress1:1,CartShippingAddress2:1,CartShippingCity:1,CartShippingPincode:1,CartShippingStateId:1,CartTaxableAmount:1,CartUpdateDate:1,CartUpdateUserId:1,Id:1,InsertDate:1,InsertUserId:1,IsActive:1,Rate:1,TaxAmount:1,TaxTypeId:1,TaxTypeName:1,UpdateDate:1,UpdateUserId:1},CartProductSpecifications:{CartCustomerEmail1:1,CartCustomerEmail2:1,CartCustomerId:1,CartCustomerMobile1:1,CartCustomerMobile2:1,CartCustomerName:1,CartDiscountAmount:1,CartDiscountCoupon:1,CartEFranchiseeDiscount:1,CartEFranchiseeDiscountType:1,CartEInvoiceTo:1,CartFranchiseeDiscountAmount:1,CartFranchiseeDiscountValue:1,CartFranchiseeId:1,CartGrossAmount:1,CartId:1,CartInsertDate:1,CartInsertUserId:1,CartInvoiceCompanyId:1,CartIsActive:1,CartName:1,CartNetAmount:1,CartProductsAllowedDevices:1,CartProductsCartId:1,CartProductsCost:1,CartProductsDiscountAmt:1,CartProductsDownloadUrl1:1,CartProductsDownloadUrl2:1,CartProductsEAccessStatus:1,CartProductsEFranchiseeDiscountType:1,CartProductsEOpens:1,CartProductsESerialkeyStatus:1,CartProductsEValidity:1,CartProductsEValidityType:1,CartProductsEWatchTime:1,CartProductsFranchiseeDiscountAmount:1,CartProductsFranchiseeDiscountValue:1,CartProductsGrossAmount:1,CartProductsHasBooks:1,CartProductsHasCourier:1,CartProductsHasPendrive:1,CartProductsId:1,CartProductsInsertDate:1,CartProductsInsertUserId:1,CartProductsInvoiceCompanyId:1,CartProductsIsActive:1,CartProductsIsLive:1,CartProductsIsTemplateSerialKey:1,CartProductsNetAmount:1,CartProductsNote:1,CartProductsProductId:1,CartProductsQuantity:1,CartProductsSerialKey:1,CartProductsTaxableAmount:1,CartProductsTotalAllowedDuration:1,CartProductsUpdateDate:1,CartProductsUpdateUserId:1,CartProductsValidTill:1,CartShippingAddress1:1,CartShippingAddress2:1,CartShippingCity:1,CartShippingPincode:1,CartShippingStateId:1,CartTaxableAmount:1,CartUpdateDate:1,CartUpdateUserId:1,Id:1,InsertDate:1,InsertUserId:1,IsActive:1,ProductSpecificationAllowedDevices:1,ProductSpecificationEValidity:1,ProductSpecificationEValidityType:1,ProductSpecificationEWatchtime:1,ProductSpecificationEopens:1,ProductSpecificationHasBooks:1,ProductSpecificationHasCourier:1,ProductSpecificationHasPendrive:1,ProductSpecificationId:1,ProductSpecificationInsertDate:1,ProductSpecificationInsertUserId:1,ProductSpecificationIsLive:1,ProductSpecificationProcessOrderOnPaid:1,ProductSpecificationProductId:1,ProductSpecificationSpecificationCode:1,ProductSpecificationSpecificationName:1,ProductSpecificationUpdateDate:1,ProductSpecificationUpdateUserId:1,ProductSpecificationValidTill:1,UpdateDate:1,UpdateUserId:1},CartProducts:{AllowedDevice:1,AllowedDevices:1,CartCustomerEmail1:1,CartCustomerEmail2:1,CartCustomerId:1,CartCustomerMobile1:1,CartCustomerMobile2:1,CartCustomerName:1,CartDiscountAmount:1,CartDiscountCoupon:1,CartEFranchiseeDiscount:1,CartEFranchiseeDiscountType:1,CartEInvoiceTo:1,CartFranchiseeDiscountAmount:1,CartFranchiseeDiscountValue:1,CartFranchiseeId:1,CartGrossAmount:1,CartId:1,CartInsertDate:1,CartInsertUserId:1,CartInvoiceCompanyId:1,CartIsActive:1,CartName:1,CartNetAmount:1,CartProductSpecificationId:1,CartShippingAddress1:1,CartShippingAddress2:1,CartShippingCity:1,CartShippingPincode:1,CartShippingStateId:1,CartTaxableAmount:1,CartUpdateDate:1,CartUpdateUserId:1,Cost:1,DiscountAmt:1,DownloadUrl1:1,DownloadUrl2:1,EAccessStatus:1,EFranchiseeDiscountType:1,EOpens:1,ESerialkeyStatus:1,EValidity:1,EValidityType:1,EWatchTime:1,FranchiseeDiscountAmount:1,FranchiseeDiscountValue:1,GrossAmount:1,HasBooks:1,HasCourier:1,HasPendrive:1,Id:1,InsertDate:1,InsertUserId:1,InvoiceCompanyAddress:1,InvoiceCompanyDisableInvoiceGenration:1,InvoiceCompanyFooterNote:1,InvoiceCompanyGstIn:1,InvoiceCompanyId:1,InvoiceCompanyInvoiceChangeDate:1,InvoiceCompanyInvoiceCode:1,InvoiceCompanyIsDefault:1,InvoiceCompanyIsTaxApplicable:1,InvoiceCompanyLogo1:1,InvoiceCompanyLogo2:1,InvoiceCompanyName:1,InvoiceCompanyStampImage:1,InvoiceCompanyTaxApplicable:1,IsActive:1,IsLive:1,IsTemplateSerialKey:1,NetAmount:1,NetAmountAfterFrDiscount:1,Note:1,ProductActivateSerialKey:1,ProductAllowSerialKeyGeneration:1,ProductAllowedDevices:1,ProductDescription:1,ProductDownloadUrl1:1,ProductDownloadUrl2:1,ProductEAccessStatus:1,ProductEOpens:1,ProductEPackingType:1,ProductEProductType:1,ProductERioplayVersion:1,ProductEShippedby:1,ProductEValidity:1,ProductEValidityType:1,ProductEWatchTime:1,ProductGrossAmount:1,ProductHasBooks:1,ProductHasCourier:1,ProductHasPenDrive:1,ProductHasVod:1,ProductHeight:1,ProductId:1,ProductInAppDownload:1,ProductInsertDate:1,ProductInsertUserId:1,ProductIsActive:1,ProductIsCombo:1,ProductIsLive:1,ProductLength:1,ProductNote:1,ProductProcesOrderOnPaid:1,ProductProductIds:1,ProductProductName:1,ProductProductQueryInfo:1,ProductRioPlayTenantId:1,ProductRioplayProductCode:1,ProductSecretkey:1,ProductSkuCode:1,ProductSupportInfo:1,ProductTeacherName:1,ProductTemplateSerialKeyId:1,ProductThumbnail:1,ProductTotalAllowedDuration:1,ProductUpdateDate:1,ProductUpdateUserId:1,ProductValidTill:1,ProductVendorId:1,ProductWebsiteUrl:1,ProductWeight:1,ProductWidth:1,Quantity:1,SerialKey:1,TaxAmount:1,TaxableAmount:1,TotalAllowedDuration:1,UpdateDate:1,UpdateUserId:1,ValidTill:1},FranchiseeProductCategory:{CategoryDescription:1,CategoryId:1,CategoryInsertDate:1,CategoryInsertUserId:1,CategoryIsActive:1,CategoryIsWebsiteCategory:1,CategoryName:1,CategoryParentId:1,CategoryUpdateDate:1,CategoryUpdateUserId:1,CategoryWebsiteCategoryId:1,Id:1,InsertDate:1,InsertUserId:1,IsActive:1,ProductActivateSerialKey:1,ProductAllowSerialKeyGeneration:1,ProductAllowedDevices:1,ProductDescription:1,ProductDownloadUrl1:1,ProductDownloadUrl2:1,ProductEAccessStatus:1,ProductEOpens:1,ProductEPackingType:1,ProductEProductType:1,ProductERioplayVersion:1,ProductEShippedby:1,ProductEValidity:1,ProductEValidityType:1,ProductEWatchTime:1,ProductGrossAmount:1,ProductHasBooks:1,ProductHasCourier:1,ProductHasPenDrive:1,ProductHasVod:1,ProductHeight:1,ProductId:1,ProductInAppDownload:1,ProductInsertDate:1,ProductInsertUserId:1,ProductIsActive:1,ProductIsCombo:1,ProductIsLive:1,ProductLength:1,ProductNote:1,ProductProcesOrderOnPaid:1,ProductProductIds:1,ProductProductName:1,ProductProductQueryInfo:1,ProductRioPlayTenantId:1,ProductRioplayProductCode:1,ProductSecretkey:1,ProductSkuCode:1,ProductSupportInfo:1,ProductTeacherName:1,ProductTemplateSerialKeyId:1,ProductThumbnail:1,ProductTotalAllowedDuration:1,ProductUpdateDate:1,ProductUpdateUserId:1,ProductValidTill:1,ProductVendorId:1,ProductWebsiteUrl:1,ProductWeight:1,ProductWidth:1,UpdateDate:1,UpdateUserId:1},FranchiseeProducts:{ActivateSerialKey:1,AllowSerialKeyGeneration:1,AllowedDevices:1,Description:1,DownloadUrl1:1,DownloadUrl2:1,EAccessStatus:1,EOpens:1,EPackingType:1,EProductType:1,ERioplayVersion:1,EShippedby:1,EValidity:1,EValidityType:1,EWatchTime:1,GrossAmount:1,HasBooks:1,HasCourier:1,HasPenDrive:1,HasVod:1,Height:1,Id:1,InAppDownload:1,InsertDate:1,InsertUserId:1,IsActive:1,IsCombo:1,IsLive:1,Length:1,Note:1,ProcesOrderOnPaid:1,ProductCategList:1,ProductIds:1,ProductName:1,ProductQueryInfo:1,RioPlayTenantId:1,RioplayProductCode:1,Secretkey:1,SkuCode:1,SupportInfo:1,TeacherName:1,TemplateSerialKeyId:1,Thumbnail:1,TotalAllowedDuration:1,UpdateDate:1,UpdateUserId:1,ValidTill:1,VendorAddress:1,VendorBankAccountName:1,VendorBankAccountNo:1,VendorBankAccountType:1,VendorBankIfscCode:1,VendorBankName:1,VendorCity:1,VendorCountry:1,VendorDescription:1,VendorEmail:1,VendorGstCertificate:1,VendorGstin:1,VendorId:1,VendorInsertDate:1,VendorInsertUserId:1,VendorIsActive:1,VendorName:1,VendorPan:1,VendorPincode:1,VendorStateId:1,VendorUpdateDate:1,VendorUpdateUserId:1,VendorUserId:1,WebsiteUrl:1,Weight:1,Width:1}},Common:{Mail:{AwsPassword:1,AwsUserId:1,Bcc:1,Body:1,Cc:1,ErrorMessage:1,InsertDate:1,InsertUserId:1,LockExpiration:1,MailFrom:1,MailId:1,MailTo:1,Priority:1,ReplyTo:1,RetryCount:1,SentDate:1,SerializedMessage:1,Status:1,Subject:1,Uid:1},SMS:{ApiKey:1,AwsPassword:1,AwsUserId:1,Bcc:1,Body:1,Cc:1,EntityId:1,ErrorMessage:1,InsertDate:1,InsertUserId:1,LockExpiration:1,Priority:1,ReplyTo:1,RetryCount:1,Sender:1,SentDate:1,SmsFrom:1,SmsId:1,SmsTo:1,Status:1,Subject:1,TemplateId:1,Uid:1}},Enquiry:{Enquiry:{Address1:1,Address2:1,City:1,Country:1,CustomerCouponCode:1,CustomerECustomerType:1,CustomerEmailId1:1,CustomerEmailId2:1,CustomerGstin:1,CustomerId:1,CustomerInsertDate:1,CustomerInsertUserId:1,CustomerIsActive:1,CustomerMobile1:1,CustomerMobile2:1,CustomerName:1,CustomerUpdateDate:1,CustomerUpdateUserId:1,EEnquiryMode:1,EStatus:1,EmailId1:1,EmailId2:1,EnquiryDate:1,EnquiryFollowUp:1,EnquiryName:1,EnquiryProduct:1,EnquiryProducts:1,EnquiryType:1,FollowUpTime:1,FollowupDate:1,HandledBy:1,Id:1,InsertDate:1,InsertUserId:1,IsActive:1,Mobile1:1,Mobile2:1,Note:1,OrderIds:1,Pincode:1,RowIds:1,StateId:1,StateName:1,UpdateDate:1,UpdateUserId:1,UserUsername:1},EnquiryFollowup:{EnquiryAddress1:1,EnquiryAddress2:1,EnquiryCity:1,EnquiryCountry:1,EnquiryCustomerId:1,EnquiryEEnquiryMode:1,EnquiryEStatus:1,EnquiryEmailId1:1,EnquiryEmailId2:1,EnquiryEnquiryDate:1,EnquiryEnquiryName:1,EnquiryFollowupDate:1,EnquiryHandledBy:1,EnquiryId:1,EnquiryInsertDate:1,EnquiryInsertUserId:1,EnquiryIsActive:1,EnquiryMobile1:1,EnquiryMobile2:1,EnquiryPincode:1,EnquiryStateId:1,EnquiryUpdateDate:1,EnquiryUpdateUserId:1,FollowUpDate:1,FollowUpMode:1,FollowedBy:1,Id:1,Note:1,UserUsername:1},EnquiryProducts:{EnquiryAddress1:1,EnquiryAddress2:1,EnquiryCity:1,EnquiryCountry:1,EnquiryCustomerId:1,EnquiryEEnquiryMode:1,EnquiryEStatus:1,EnquiryEmailId1:1,EnquiryEmailId2:1,EnquiryEnquiryDate:1,EnquiryEnquiryName:1,EnquiryFollowupDate:1,EnquiryHandledBy:1,EnquiryId:1,EnquiryInsertDate:1,EnquiryInsertUserId:1,EnquiryIsActive:1,EnquiryMobile1:1,EnquiryMobile2:1,EnquiryPincode:1,EnquiryStateId:1,EnquiryUpdateDate:1,EnquiryUpdateUserId:1,Id:1,InsertDate:1,InsertUserId:1,IsActive:1,ProductActivateSerialKey:1,ProductAllowSerialKeyGeneration:1,ProductAllowedDevices:1,ProductDescription:1,ProductDownloadUrl1:1,ProductDownloadUrl2:1,ProductEAccessStatus:1,ProductEOpens:1,ProductEPackingType:1,ProductEProductType:1,ProductERioplayVersion:1,ProductEShippedby:1,ProductEValidity:1,ProductEValidityType:1,ProductEWatchTime:1,ProductGrossAmount:1,ProductHasBooks:1,ProductHasCourier:1,ProductHasPenDrive:1,ProductHasVod:1,ProductHeight:1,ProductId:1,ProductInAppDownload:1,ProductInsertDate:1,ProductInsertUserId:1,ProductIsActive:1,ProductIsCombo:1,ProductIsLive:1,ProductLength:1,ProductNote:1,ProductProcesOrderOnPaid:1,ProductProductIds:1,ProductProductName:1,ProductProductQueryInfo:1,ProductRioplayProductCode:1,ProductSkuCode:1,ProductSupportInfo:1,ProductTeacherName:1,ProductTemplateSerialKeyId:1,ProductTotalAllowedDuration:1,ProductUpdateDate:1,ProductUpdateUserId:1,ProductValidTill:1,ProductVendorId:1,ProductWebsiteUrl:1,ProductWeight:1,ProductWidth:1,UpdateDate:1,UpdateUserId:1},PendingOrderProducts:{Id:1,InsertDate:1,InsertUserId:1,IsActive:1,Name:1,PendingOrderAddress:1,PendingOrderCity:1,PendingOrderCustomerName:1,PendingOrderEmail:1,PendingOrderId:1,PendingOrderInsertDate:1,PendingOrderInsertUserId:1,PendingOrderIsActive:1,PendingOrderMobile:1,PendingOrderNopOrderId:1,PendingOrderPincode:1,PendingOrderStateId:1,PendingOrderUpdateDate:1,PendingOrderUpdateUserId:1,ProductId:1,Sku:1,UpdateDate:1,UpdateUserId:1},PendingOrders:{Address:1,City:1,CustomerId:1,CustomerName:1,Email:1,HandledBy:1,Id:1,InsertDate:1,InsertUserId:1,IsActive:1,Mobile:1,NopOrderId:1,OrderDate:1,OrderProducts:1,OrderStatus:1,Pincode:1,StateId:1,StateInsertDate:1,StateInsertUserId:1,StateIsActive:1,StateIsHomeState:1,StateName:1,StateUpdateDate:1,StateUpdateUserId:1,UpdateDate:1,UpdateUserId:1,UserUsername:1}},Inventory:{BookInward:{Amount:1,BillDocument:1,BookBookName:1,BookCost:1,BookEBookType:1,BookId:1,BookInsertDate:1,BookInsertUserId:1,BookIsActive:1,BookIsbn:1,BookNoOfPages:1,BookTaxCategoryId:1,BookUpdateDate:1,BookUpdateUserId:1,Id:1,InsertDate:1,InsertUserId:1,InwardDate:1,IsActive:1,Notes:1,Qty:1,Rate:1,UpdateDate:1,UpdateUserId:1,VendorAddress:1,VendorBankAccountName:1,VendorBankAccountNo:1,VendorBankAccountType:1,VendorBankIfscCode:1,VendorBankName:1,VendorCity:1,VendorCountry:1,VendorDescription:1,VendorEmail:1,VendorGstCertificate:1,VendorGstin:1,VendorId:1,VendorInsertDate:1,VendorInsertUserId:1,VendorIsActive:1,VendorName:1,VendorPan:1,VendorPincode:1,VendorStateId:1,VendorUpdateDate:1,VendorUpdateUserId:1,VendorUserId:1},BookOutward:{BalanceQuantity:1,BookBookName:1,BookCost:1,BookEBookType:1,BookId:1,BookInsertDate:1,BookInsertUserId:1,BookIsActive:1,BookIsbn:1,BookNoOfPages:1,BookTaxCategoryId:1,BookUpdateDate:1,BookUpdateUserId:1,Id:1,InsertDate:1,InsertUserId:1,IsActive:1,Notes:1,OpeningBalance:1,OutwardMonth:1,TotalInward:1,TotalOutward:1,UpdateDate:1,UpdateUserId:1},PendriveInward:{BillDocument:1,Id:1,InsertDate:1,InsertUserId:1,InwardDate:1,IsActive:1,Notes:1,PenDriveTypeId:1,PendriveType:1,Qty:1,Rate:1,UpdateDate:1,UpdateUserId:1,VendorAddress:1,VendorBankAccountName:1,VendorBankAccountNo:1,VendorBankAccountType:1,VendorBankIfscCode:1,VendorBankName:1,VendorCity:1,VendorCountry:1,VendorDescription:1,VendorEmail:1,VendorGstCertificate:1,VendorGstin:1,VendorId:1,VendorInsertDate:1,VendorInsertUserId:1,VendorIsActive:1,VendorName:1,VendorPan:1,VendorPincode:1,VendorStateId:1,VendorUpdateDate:1,VendorUpdateUserId:1,VendorUserId:1},PendriveOutward:{BalanceQuantity:1,Id:1,InsertDate:1,InsertUserId:1,IsActive:1,Notes:1,OpeningBalance:1,OutwardMonth:1,PenDriveTypeId:1,PendriveType:1,TotalInward:1,TotalOutward:1,UpdateDate:1,UpdateUserId:1}},Invoices:{FinancialYear:{FromDate:1,Id:1,InsertDate:1,InsertUserId:1,IsActive:1,ToDate:1,UpdateDate:1,UpdateUserId:1,YearCode:1},InvoiceHsn:{HsnMasterBillingAddress1:1,HsnMasterBillingAddress2:1,HsnMasterBillingCity:1,HsnMasterBillingPincode:1,HsnMasterBillingStateId:1,HsnMasterCustomerId:1,HsnMasterDiscountAmount:1,HsnMasterEInvoiceStatus:1,HsnMasterEInvoiceTo:1,HsnMasterEInvoiceType:1,HsnMasterFranchiseeId:1,HsnMasterGrossAmount:1,HsnMasterId:1,HsnMasterInsertDate:1,HsnMasterInsertUserId:1,HsnMasterInvoiceCompanyId:1,HsnMasterInvoiceDate:1,HsnMasterInvoicenumber:1,HsnMasterIsActive:1,HsnMasterIsRecalculated:1,HsnMasterNetAmount:1,HsnMasterTaxableAmount:1,HsnMasterUpdateDate:1,HsnMasterUpdateUserId:1,Id:1,OrderBillingAddress1:1,OrderBillingAddress2:1,OrderBillingCity:1,OrderBillingPincode:1,OrderBillingStateId:1,OrderCustomerEmail1:1,OrderCustomerEmail2:1,OrderCustomerId:1,OrderCustomerMobile1:1,OrderCustomerMobile2:1,OrderCustomerName:1,OrderDiscountAmount:1,OrderDiscountCoupon:1,OrderDiscountPer:1,OrderEFranchiseeDiscount:1,OrderEFranchiseeDiscountType:1,OrderEInvoiceStatus:1,OrderEInvoiceTo:1,OrderEOrderProcessBy:1,OrderEOrderStatus:1,OrderEPaymentStatus:1,OrderEPaymentType:1,OrderEShippingStatus:1,OrderEShippingType:1,OrderESourceType:1,OrderEmailSendCount:1,OrderExpectedShippingDate:1,OrderFranchiseeDiscountAmount:1,OrderFranchiseeDiscountValue:1,OrderFranchiseeId:1,OrderGrossAmount:1,OrderGstin:1,OrderId:1,OrderInsertDate:1,OrderInsertUserId:1,OrderInvoiceCompanyId:1,OrderIsActive:1,OrderIsEmailSent:1,OrderLastEmailSentDate:1,OrderMailId:1,OrderNetAmount:1,OrderOrderDate:1,OrderOrderNumber:1,OrderShippingAddress1:1,OrderShippingAddress2:1,OrderShippingCity:1,OrderShippingNote:1,OrderShippingPincode:1,OrderShippingStateId:1,OrderShippingToName:1,OrderSourceName:1,OrderSourceOrderNumber:1,OrderTaxableAmount:1,OrderUpdateDate:1,OrderUpdateUserId:1,OrderVendorId:1,TaxAmount:1,TaxCategoryId:1,TaxCategoryInsertDate:1,TaxCategoryInsertUserId:1,TaxCategoryIsActive:1,TaxCategoryName:1,TaxCategoryUpdateDate:1,TaxCategoryUpdateUserId:1,TaxTypeId:1,TaxTypeName:1,TaxableAmount:1},InvoiceNumberFormat:{AutoIncrementLimit:1,CalculationCurrency:1,CurrencyId:1,Id:1,InsertDate:1,InsertUserId:1,InvoiceCompanyAddress:1,InvoiceCompanyFooterNote:1,InvoiceCompanyGstIn:1,InvoiceCompanyId:1,InvoiceCompanyInvoiceChangeDate:1,InvoiceCompanyInvoiceCode:1,InvoiceCompanyIsDefault:1,InvoiceCompanyIsTaxApplicable:1,InvoiceCompanyLogo1:1,InvoiceCompanyLogo2:1,InvoiceCompanyName:1,InvoiceCompanyStampImage:1,InvoicePrefix:1,IsActive:1,MonthlyReset:1,Part1:1,Part2:1,Part3:1,Part4:1,ResetDate:1,SourceType:1,SourceTypeId:1,SourceTypes:1,UpdateDate:1,UpdateUserId:1},InvoiceOrders:{Id:1,InvoiceBillingAddress1:1,InvoiceBillingAddress2:1,InvoiceBillingCity:1,InvoiceBillingPincode:1,InvoiceBillingStateId:1,InvoiceCustomerId:1,InvoiceDiscountAmount:1,InvoiceEInvoiceStatus:1,InvoiceEInvoiceTo:1,InvoiceEInvoiceType:1,InvoiceFranchiseeId:1,InvoiceGrossAmount:1,InvoiceId:1,InvoiceInsertDate:1,InvoiceInsertUserId:1,InvoiceInvoiceCompanyId:1,InvoiceInvoiceDate:1,InvoiceInvoicenumber:1,InvoiceIsActive:1,InvoiceIsRecalculated:1,InvoiceNetAmount:1,InvoiceTaxableAmount:1,InvoiceUpdateDate:1,InvoiceUpdateUserId:1,OrderBillingAddress1:1,OrderBillingAddress2:1,OrderBillingCity:1,OrderBillingPincode:1,OrderBillingStateId:1,OrderCustomerEmail1:1,OrderCustomerEmail2:1,OrderCustomerId:1,OrderCustomerMobile1:1,OrderCustomerMobile2:1,OrderCustomerName:1,OrderDiscountAmount:1,OrderDiscountCoupon:1,OrderDiscountPer:1,OrderEFranchiseeDiscount:1,OrderEFranchiseeDiscountType:1,OrderEInvoiceStatus:1,OrderEInvoiceTo:1,OrderEOrderProcessBy:1,OrderEOrderStatus:1,OrderEPaymentStatus:1,OrderEPaymentType:1,OrderEShippingStatus:1,OrderEShippingType:1,OrderESourceType:1,OrderEmailSendCount:1,OrderExpectedShippingDate:1,OrderFranchiseeDiscountAmount:1,OrderFranchiseeDiscountValue:1,OrderFranchiseeId:1,OrderGrossAmount:1,OrderGstin:1,OrderId:1,OrderInsertDate:1,OrderInsertUserId:1,OrderInvoiceCompanyId:1,OrderIsActive:1,OrderIsEmailSent:1,OrderLastEmailSentDate:1,OrderMailId:1,OrderNetAmount:1,OrderOrderDate:1,OrderOrderNumber:1,OrderShippingAddress1:1,OrderShippingAddress2:1,OrderShippingCity:1,OrderShippingNote:1,OrderShippingPincode:1,OrderShippingStateId:1,OrderShippingToName:1,OrderSourceName:1,OrderSourceOrderNumber:1,OrderTaxableAmount:1,OrderUpdateDate:1,OrderUpdateUserId:1,OrderVendorId:1},InvoicePayment:{Amount:1,BankName:1,ChequeNumber:1,EPaymentMode:1,EStatus:1,Id:1,InsertDate:1,InsertUserId:1,InvoiceBillingAddress1:1,InvoiceBillingAddress2:1,InvoiceBillingCity:1,InvoiceBillingPincode:1,InvoiceBillingStateId:1,InvoiceCustomerId:1,InvoiceDiscountAmount:1,InvoiceEInvoiceStatus:1,InvoiceEInvoiceTo:1,InvoiceEInvoiceType:1,InvoiceFranchiseeId:1,InvoiceGrossAmount:1,InvoiceId:1,InvoiceInsertDate:1,InvoiceInsertUserId:1,InvoiceInvoiceCompanyId:1,InvoiceInvoiceDate:1,InvoiceInvoicenumber:1,InvoiceIsActive:1,InvoiceIsRecalculated:1,InvoiceNetAmount:1,InvoiceTaxableAmount:1,InvoiceUpdateDate:1,InvoiceUpdateUserId:1,IsActive:1,Note:1,PaymentDate:1,TransactionId:1,UpdateDate:1,UpdateUserId:1},Invoices:{BillingAddress1:1,BillingAddress2:1,BillingCity:1,BillingPincode:1,BillingStateId:1,BillingStateInsertDate:1,BillingStateInsertUserId:1,BillingStateIsActive:1,BillingStateIsHomeState:1,BillingStateName:1,BillingStateUpdateDate:1,BillingStateUpdateUserId:1,CalculationCurrency:1,CurrencyId:1,CustomerCouponCode:1,CustomerECustomerType:1,CustomerEmailId1:1,CustomerEmailId2:1,CustomerGstin:1,CustomerId:1,CustomerInsertDate:1,CustomerInsertUserId:1,CustomerIsActive:1,CustomerMobile1:1,CustomerMobile2:1,CustomerName:1,CustomerUpdateDate:1,CustomerUpdateUserId:1,DiscountAmount:1,EInvoiceStatus:1,EInvoiceTo:1,EInvoiceType:1,ESourceType:1,FranchiseeAddress:1,FranchiseeAlternateEmail:1,FranchiseeAlternateMobile:1,FranchiseeBankAccountName:1,FranchiseeBankAccountNo:1,FranchiseeBankAccountType:1,FranchiseeBankIfscCode:1,FranchiseeBankName:1,FranchiseeCity:1,FranchiseeCustomerId:1,FranchiseeDescription:1,FranchiseeDiscountCoupon:1,FranchiseeEmail:1,FranchiseeGstCertificate:1,FranchiseeGstin:1,FranchiseeId:1,FranchiseeInsertDate:1,FranchiseeInsertUserId:1,FranchiseeIsActive:1,FranchiseeIsCustomer:1,FranchiseeIsPostPayAllowed:1,FranchiseeMobile:1,FranchiseeName:1,FranchiseePan:1,FranchiseePincode:1,FranchiseeStateId:1,FranchiseeUpdateDate:1,FranchiseeUpdateUserId:1,FranchiseeUserId:1,FreezeData:1,GrossAmount:1,Id:1,InsertDate:1,InsertUserId:1,InvoiceCompanyAddress:1,InvoiceCompanyFooterNote:1,InvoiceCompanyGstIn:1,InvoiceCompanyId:1,InvoiceCompanyInvoiceChangeDate:1,InvoiceCompanyInvoiceCode:1,InvoiceCompanyIsDefault:1,InvoiceCompanyIsTaxApplicable:1,InvoiceCompanyLogo1:1,InvoiceCompanyLogo2:1,InvoiceCompanyName:1,InvoiceCompanyStampImage:1,InvoiceDate:1,Invoicenumber:1,IsActive:1,IsRecalculated:1,NetAmount:1,TaxAmount:1,TaxableAmount:1,UpdateDate:1,UpdateUserId:1},OrderSources:{Id:1,SourceType:1}},Masters:{AllowedDevices:{Device:1,Id:1},Attempts:{AttemptDate:1,CourseId:1,CourseInsertDate:1,CourseInsertUserId:1,CourseIsActive:1,CourseName:1,CourseUpdateDate:1,CourseUpdateUserId:1,Id:1,InsertDate:1,InsertUserId:1,IsActive:1,LevelCourseId:1,LevelId:1,LevelInsertDate:1,LevelInsertUserId:1,LevelIsActive:1,LevelName:1,LevelUpdateDate:1,LevelUpdateUserId:1,Name:1,UpdateDate:1,UpdateUserId:1},Books:{BookName:1,Cost:1,EBookType:1,Id:1,InsertDate:1,InsertUserId:1,IsActive:1,Isbn:1,NoOfPages:1,TaxCategoryId:1,UpdateDate:1,UpdateUserId:1},BrandAmbassadorSettings:{BrandAmbassadorSharePercentage:1,CouponCodePrefix:1,CreateGiftCard:1,CreateGiftCardUrl:1,CreateNopTokenUrl:1,DiscountCategoryId:1,DiscountCategoryMappingNopUrl:1,DiscountCreateNopUrl:1,DiscountPercentage:1,Id:1,NopEmail:1,NopPassword:1,NopUserName:1,OnOrOff:1,RunProgram:1,SendEmails:1,SiteUrl:1},Courses:{Id:1,InsertDate:1,InsertUserId:1,IsActive:1,Name:1,UpdateDate:1,UpdateUserId:1},Currencies:{CurrencyCode:1,Id:1,InrRate:1,InsertDate:1,InsertUserId:1,IsActive:1,IsDefault:1,Name:1,UpdateDate:1,UpdateUserId:1},DelhiveryApiDetails:{Address:1,City:1,Id:1,InsertDate:1,InsertUserId:1,IsActive:1,Name:1,Phone:1,Pincode:1,ShippingMode:1,Token:1,UpdateDate:1,UpdateUserId:1},DtdcApiDetails:{AccessToken:1,Address1:1,Address2:1,ApiKey:1,City:1,Cookie:1,CustomerCode:1,Id:1,InsertDate:1,InsertUserId:1,IsActive:1,Name:1,Phone:1,Pincode:1,ServiceTypeId:1,State:1,UpdateDate:1,UpdateUserId:1},EmailTemplateVariables:{Id:1,VariableCode:1,VariableName:1},EmailTemplates:{EmailTemplate:1,Id:1,IsActive:1,Status:1,Variable:1,VariableCodes:1,Variables:1},HsnMaster:{HsnCode:1,Id:1,InsertDate:1,InsertUserId:1,IsActive:1,Name:1,TaxCategoryId:1,TaxCategoryInsertDate:1,TaxCategoryInsertUserId:1,TaxCategoryIsActive:1,TaxCategoryName:1,TaxCategoryUpdateDate:1,TaxCategoryUpdateUserId:1,UpdateDate:1,UpdateUserId:1},InvoiceCompany:{Address:1,DisableInvoiceGenration:1,FooterNote:1,GstIn:1,Id:1,InvoiceChangeDate:1,InvoiceCode:1,IsDefault:1,IsTaxApplicable:1,Logo1:1,Logo2:1,Name:1,StampImage:1,TaxApplicable:1},Levels:{CourseId:1,CourseInsertDate:1,CourseInsertUserId:1,CourseIsActive:1,CourseName:1,CourseUpdateDate:1,CourseUpdateUserId:1,Id:1,InsertDate:1,InsertUserId:1,IsActive:1,Name:1,SortOrder:1,UpdateDate:1,UpdateUserId:1},Mode:{Id:1,InsertDate:1,InsertUserId:1,IsActive:1,Name:1,UpdateDate:1,UpdateUserId:1},PendingOrderJobSettings:{Id:1,NopUrl:1,RunJob:1},PendriveTypes:{Id:1,PendriveType:1},Rioplay8AllowedDevices:{Device:1,Id:1},SmsGatewaySettings:{ApiKey:1,EntityId:1,Id:1,IsActive:1,Sender:1,TemplateId:1},SmsTemplateVariables:{Id:1,VariableCode:1,VariableName:1},SmsTemplates:{ApiKey:1,EntityId:1,Id:1,IsActive:1,Sender:1,SmsTemplate:1,Status:1,TemplateId:1,VariableCodes:1,Variables:1},SmtpSettings:{FromEmail:1,FromName:1,Id:1,IsActive:1,IsAws:1,Password:1,Port:1,SendEmailOnWebsiteSync:1,ServerAddress:1,UserName:1},States:{Id:1,InsertDate:1,InsertUserId:1,IsActive:1,IsHomeState:1,Name:1,UpdateDate:1,UpdateUserId:1},TawkToChat:{ChatId:1,ChatLog:1,CustomerId:1,Department:1,Email:1,EndTime:1,HandledBy:1,Id:1,InsertDate:1,InsertUserId:1,IsActive:1,Mobile:1,Name:1,Note:1,SerialKey:1,StartTime:1,Subject:1,TawkToEvent:1,UpdateDate:1,UpdateUserId:1},TaxCategory:{Id:1,InsertDate:1,InsertUserId:1,IsActive:1,Name:1,UpdateDate:1,UpdateUserId:1},TaxRate:{FromDate:1,Id:1,Rate:1,StateId:1,StateInsertDate:1,StateInsertUserId:1,StateIsActive:1,StateIsHomeState:1,StateName:1,StateUpdateDate:1,StateUpdateUserId:1,TaxCategoryId:1,TaxCategoryInsertDate:1,TaxCategoryInsertUserId:1,TaxCategoryIsActive:1,TaxCategoryName:1,TaxCategoryUpdateDate:1,TaxCategoryUpdateUserId:1,TaxTypeId:1,TaxTypeName:1,ToDate:1},TaxTypes:{Id:1,Name:1},WhatsAppGatewaySettings:{ApiKey:1,ApiUrl:1,Id:1,IsActive:1,Sender:1},WhatsAppMessages:{CustomerId:1,ErrorMessage:1,Id:1,InsertDate:1,InsertUserId:1,IsActive:1,SentDate:1,Status:1,Type:1,Wid:1},WhatsAppTemplateVariableMap:{Id:1,WhatsAppTemplateId:1,WhatsAppTemplateVariableId:1},WhatsAppTemplateVariables:{Id:1,VariableCode:1,VariableName:1},WhatsAppTemplates:{Id:1,IsActive:1,LanguageCode:1,MessagingProduct:1,Status:1,TemplateName:1,Type:1,Variable:1,VariableCodes:1,Variables:1,Wid:1}},Orders:{BrandAmbassadorPayments:{BankName:1,BrandAmbassadorAddress:1,BrandAmbassadorAlternateEmail:1,BrandAmbassadorAlternateMobile:1,BrandAmbassadorBankAccountName:1,BrandAmbassadorBankAccountNo:1,BrandAmbassadorBankAccountType:1,BrandAmbassadorBankIfscCode:1,BrandAmbassadorBankName:1,BrandAmbassadorCity:1,BrandAmbassadorCustomerId:1,BrandAmbassadorDescription:1,BrandAmbassadorDiscountCoupon:1,BrandAmbassadorEmail:1,BrandAmbassadorGstCertificate:1,BrandAmbassadorGstin:1,BrandAmbassadorId:1,BrandAmbassadorInsertDate:1,BrandAmbassadorInsertUserId:1,BrandAmbassadorIsActive:1,BrandAmbassadorMobile:1,BrandAmbassadorName:1,BrandAmbassadorPan:1,BrandAmbassadorPincode:1,BrandAmbassadorStateId:1,BrandAmbassadorUpdateDate:1,BrandAmbassadorUpdateUserId:1,BrandAmbassadorUserId:1,Comment:1,Id:1,InsertDate:1,InsertUserId:1,IsActive:1,PaidAmount:1,PaymentDate:1,PaymentMode:1,PaymentRefNo:1,ReceiptNo:1,Remark:1,RowIds:1,UpdateDate:1,UpdateUserId:1},CustomerGiftCards:{Amount:1,CustomerAttemptId:1,CustomerCouponCode:1,CustomerCourseId:1,CustomerECustomerType:1,CustomerEmailId1:1,CustomerEmailId2:1,CustomerGstin:1,CustomerId:1,CustomerInsertDate:1,CustomerInsertUserId:1,CustomerIsActive:1,CustomerLevelId:1,CustomerMobile1:1,CustomerMobile2:1,CustomerName:1,CustomerUpdateDate:1,CustomerUpdateUserId:1,GiftCardCode:1,Id:1,InsertDate:1,InsertUserId:1,IsActive:1,NopOrderId:1,OrderBillingAddress1:1,OrderBillingAddress2:1,OrderBillingCity:1,OrderBillingPincode:1,OrderBillingStateId:1,OrderCurrencyAmount:1,OrderCurrencyId:1,OrderCustomerEmail1:1,OrderCustomerEmail2:1,OrderCustomerId:1,OrderCustomerMobile1:1,OrderCustomerMobile2:1,OrderCustomerName:1,OrderDiscountAmount:1,OrderDiscountCoupon:1,OrderDiscountPer:1,OrderEFranchiseeDiscount:1,OrderEFranchiseeDiscountType:1,OrderEInvoiceStatus:1,OrderEInvoiceTo:1,OrderEOrderProcessBy:1,OrderEOrderStatus:1,OrderEPaymentStatus:1,OrderEPaymentType:1,OrderEShippingStatus:1,OrderEShippingType:1,OrderESourceType:1,OrderEmailSendCount:1,OrderExpectedShippingDate:1,OrderFranchiseeDiscountAmount:1,OrderFranchiseeDiscountValue:1,OrderFranchiseeId:1,OrderFreezeData:1,OrderGrossAmount:1,OrderGstin:1,OrderId:1,OrderInsertDate:1,OrderInsertUserId:1,OrderInvoiceCompanyId:1,OrderIsActive:1,OrderIsEmailSent:1,OrderLastEmailSentDate:1,OrderMailId:1,OrderNetAmount:1,OrderNetAmountAfterFrDiscount:1,OrderOrderDate:1,OrderOrderNumber:1,OrderShippingAddress1:1,OrderShippingAddress2:1,OrderShippingCity:1,OrderShippingNote:1,OrderShippingPincode:1,OrderShippingProviderId:1,OrderShippingStateId:1,OrderShippingToName:1,OrderSourceName:1,OrderSourceOrderNumber:1,OrderTaxAmount:1,OrderTaxableAmount:1,OrderUpdateDate:1,OrderUpdateUserId:1,OrderVendorId:1,Percentage:1,UpdateDate:1,UpdateUserId:1},EaseBuzzSettings:{Id:1,InsertDate:1,InsertUserId:1,IsActive:1,Key:1,RedirectUrl:1,Salt:1,UpdateDate:1,UpdateUserId:1,WebhookUrl:1},FranchiseeOrders:{BillingAddress1:1,BillingAddress2:1,BillingCity:1,BillingPincode:1,BillingStateId:1,BillingStateInsertDate:1,BillingStateInsertUserId:1,BillingStateIsActive:1,BillingStateIsHomeState:1,BillingStateName:1,BillingStateUpdateDate:1,BillingStateUpdateUserId:1,CustomerAttemptId:1,CustomerCouponCode:1,CustomerCourseId:1,CustomerECustomerType:1,CustomerEmail1:1,CustomerEmail2:1,CustomerGstin:1,CustomerId:1,CustomerInsertDate:1,CustomerInsertUserId:1,CustomerIsActive:1,CustomerLevelId:1,CustomerMobile11:1,CustomerMobile21:1,CustomerName1:1,CustomerUpdateDate:1,CustomerUpdateUserId:1,DiscountAmount:1,DiscountCoupon:1,DiscountPer:1,EFranchiseeDiscount:1,EFranchiseeDiscountType:1,EInvoiceStatus:1,EInvoiceTo:1,EOrderProcessBy:1,EOrderStatus:1,EPaymentStatus:1,EPaymentType:1,EShippingStatus:1,EShippingType:1,ESourceType:1,EmailSendCount:1,ExpectedShippingDate:1,FranchiseeAddress:1,FranchiseeAffiliateId:1,FranchiseeAlternateEmail:1,FranchiseeAlternateMobile:1,FranchiseeBankAccountName:1,FranchiseeBankAccountNo:1,FranchiseeBankAccountType:1,FranchiseeBankIfscCode:1,FranchiseeBankName:1,FranchiseeCity:1,FranchiseeCustomerId:1,FranchiseeDescription:1,FranchiseeDiscountAmount:1,FranchiseeDiscountCoupon:1,FranchiseeDiscountValue:1,FranchiseeEmail:1,FranchiseeGstCertificate:1,FranchiseeGstin:1,FranchiseeId:1,FranchiseeInsertDate:1,FranchiseeInsertUserId:1,FranchiseeIsActive:1,FranchiseeIsCustomer:1,FranchiseeIsPostPayAllowed:1,FranchiseeMobile:1,FranchiseeName:1,FranchiseePan:1,FranchiseePincode:1,FranchiseeStateId:1,FranchiseeUpdateDate:1,FranchiseeUpdateUserId:1,FranchiseeUserId:1,FreezeData:1,GenerateSerialKey:1,GrossAmount:1,Gstin:1,Id:1,InsertDate:1,InsertUserId:1,InvoiceCompanyAddress:1,InvoiceCompanyFooterNote:1,InvoiceCompanyGstIn:1,InvoiceCompanyId:1,InvoiceCompanyInvoiceChangeDate:1,InvoiceCompanyInvoiceCode:1,InvoiceCompanyIsDefault:1,InvoiceCompanyIsTaxApplicable:1,InvoiceCompanyLogo1:1,InvoiceCompanyLogo2:1,InvoiceCompanyName:1,InvoiceCompanyStampImage:1,IsActive:1,IsEmailSent:1,LastEmailSentDate:1,MailId:1,MarkAsPaid:1,NetAmount:1,OrderDate:1,OrderNumber:1,OrderProduct:1,OrderProducts:1,ShippingAddress1:1,ShippingAddress2:1,ShippingCity:1,ShippingNote:1,ShippingPincode:1,ShippingProviderBankAccountNo:1,ShippingProviderBankIfscCode:1,ShippingProviderBankName:1,ShippingProviderDescription:1,ShippingProviderEApiStatus:1,ShippingProviderEShippingProviderType:1,ShippingProviderGstCertificate:1,ShippingProviderGstin:1,ShippingProviderId:1,ShippingProviderInsertDate:1,ShippingProviderInsertUserId:1,ShippingProviderIsActive:1,ShippingProviderIsDefault:1,ShippingProviderPan:1,ShippingProviderSecret:1,ShippingProviderShippingProviderName:1,ShippingProviderTrackingUrl:1,ShippingProviderUpdateDate:1,ShippingProviderUpdateUserId:1,ShippingProviderVendorId:1,ShippingStateId:1,ShippingStateInsertDate:1,ShippingStateInsertUserId:1,ShippingStateIsActive:1,ShippingStateIsHomeState:1,ShippingStateName:1,ShippingStateUpdateDate:1,ShippingStateUpdateUserId:1,ShippingToName:1,SourceName:1,SourceOrderNumber:1,TaxAmount:1,TaxableAmount:1,UpdateDate:1,UpdateUserId:1,VendorAddress:1,VendorBankAccountName:1,VendorBankAccountNo:1,VendorBankAccountType:1,VendorBankIfscCode:1,VendorBankName:1,VendorCity:1,VendorCountry:1,VendorDescription:1,VendorEmail:1,VendorGstCertificate:1,VendorGstin:1,VendorId:1,VendorInsertDate:1,VendorInsertUserId:1,VendorIsActive:1,VendorName:1,VendorPan:1,VendorPincode:1,VendorStateId:1,VendorUpdateDate:1,VendorUpdateUserId:1,VendorUserId:1},FranchiseePayments:{BankName:1,Comment:1,FranchiseeAddress:1,FranchiseeAffiliateId:1,FranchiseeAlternateEmail:1,FranchiseeAlternateMobile:1,FranchiseeAvailableCreditBalance:1,FranchiseeBankAccountName:1,FranchiseeBankAccountNo:1,FranchiseeBankAccountType:1,FranchiseeBankIfscCode:1,FranchiseeBankName:1,FranchiseeCity:1,FranchiseeCustomerId:1,FranchiseeDescription:1,FranchiseeDiscountCoupon:1,FranchiseeEmail:1,FranchiseeGstCertificate:1,FranchiseeGstin:1,FranchiseeId:1,FranchiseeInsertDate:1,FranchiseeInsertUserId:1,FranchiseeIsActive:1,FranchiseeIsCustomer:1,FranchiseeIsPostPayAllowed:1,FranchiseeMobile:1,FranchiseeName:1,FranchiseePan:1,FranchiseePincode:1,FranchiseeStateId:1,FranchiseeUpdateDate:1,FranchiseeUpdateUserId:1,FranchiseeUserId:1,Id:1,InsertDate:1,InsertUserId:1,IsActive:1,PaidAmount:1,PaymentDate:1,PaymentMode:1,PaymentRefNo:1,ReceiptNo:1,Remark:1,RowIds:1,UpdateDate:1,UpdateUserId:1},InstamojoSettings:{ClientId:1,ClientSecret:1,Currency:1,Id:1,InsertDate:1,InsertUserId:1,IsActive:1,RedirectUrl:1,TransactionIdPrefix:1,UpdateDate:1,UpdateUserId:1,WebhookUrl:1},OrderBook:{BookBookName:1,BookCost:1,BookEBookType:1,BookId:1,BookInsertDate:1,BookInsertUserId:1,BookIsActive:1,BookIsbn:1,BookNoOfPages:1,BookTaxCategoryId:1,BookUpdateDate:1,BookUpdateUserId:1,Id:1,InsertDate:1,InsertUserId:1,IsActive:1,OrderBillingAddress1:1,OrderBillingAddress2:1,OrderBillingCity:1,OrderBillingCountry:1,OrderBillingPincode:1,OrderBillingStateId:1,OrderCalculationCurrency:1,OrderCurrencyAmount:1,OrderCurrencyId:1,OrderCustomerEmail1:1,OrderCustomerEmail2:1,OrderCustomerId:1,OrderCustomerMobile1:1,OrderCustomerMobile2:1,OrderCustomerName:1,OrderDiscountAmount:1,OrderDiscountCoupon:1,OrderDiscountPer:1,OrderEFranchiseeDiscount:1,OrderEFranchiseeDiscountType:1,OrderEInvoiceStatus:1,OrderEInvoiceTo:1,OrderEOrderProcessBy:1,OrderEOrderStatus:1,OrderEPaymentStatus:1,OrderEPaymentType:1,OrderEShippingStatus:1,OrderEShippingType:1,OrderESourceType:1,OrderEmailSendCount:1,OrderExpectedShippingDate:1,OrderFranchiseeDiscountAmount:1,OrderFranchiseeDiscountValue:1,OrderFranchiseeId:1,OrderFreezeData:1,OrderGrossAmount:1,OrderGstin:1,OrderId:1,OrderInsertDate:1,OrderInsertUserId:1,OrderInvoiceCompanyId:1,OrderIsActive:1,OrderIsEmailSent:1,OrderLastEmailSentDate:1,OrderLevel:1,OrderMailId:1,OrderMode:1,OrderNetAmount:1,OrderNetAmountAfterFrDiscount:1,OrderNote:1,OrderOrderDate:1,OrderOrderNumber:1,OrderShippingAddress1:1,OrderShippingAddress2:1,OrderShippingCity:1,OrderShippingCountry:1,OrderShippingNote:1,OrderShippingPincode:1,OrderShippingProviderId:1,OrderShippingStateId:1,OrderShippingToName:1,OrderSourceName:1,OrderSourceOrderNumber:1,OrderTaxAmount:1,OrderTaxableAmount:1,OrderUpdateDate:1,OrderUpdateUserId:1,OrderVendorId:1,ProductActivateSerialKey:1,ProductAllowSerialKeyGeneration:1,ProductAllowedDevices:1,ProductDescription:1,ProductDownloadUrl1:1,ProductDownloadUrl2:1,ProductEAccessStatus:1,ProductEOpens:1,ProductEPackingType:1,ProductEProductType:1,ProductERioplayVersion:1,ProductEShippedby:1,ProductEValidity:1,ProductEValidityType:1,ProductEWatchTime:1,ProductGrossAmount:1,ProductHasBooks:1,ProductHasCourier:1,ProductHasPenDrive:1,ProductHasVod:1,ProductHeight:1,ProductId:1,ProductInAppDownload:1,ProductInsertDate:1,ProductInsertUserId:1,ProductIsActive:1,ProductIsCombo:1,ProductIsLive:1,ProductLength:1,ProductNote:1,ProductProcesOrderOnPaid:1,ProductProductIds:1,ProductProductName:1,ProductProductQueryInfo:1,ProductRioPlayTenantId:1,ProductRioplayProductCode:1,ProductSecretkey:1,ProductSkuCode:1,ProductSupportInfo:1,ProductTeacherName:1,ProductTemplateSerialKeyId:1,ProductTotalAllowedDuration:1,ProductUpdateDate:1,ProductUpdateUserId:1,ProductValidTill:1,ProductVendorId:1,ProductWebsiteUrl:1,ProductWeight:1,ProductWidth:1,UpdateDate:1,UpdateUserId:1},OrderBrandAmbassadorShare:{BrandAmbassadorAddress:1,BrandAmbassadorAlternateEmail:1,BrandAmbassadorAlternateMobile:1,BrandAmbassadorBankAccountName:1,BrandAmbassadorBankAccountNo:1,BrandAmbassadorBankAccountType:1,BrandAmbassadorBankIfscCode:1,BrandAmbassadorBankName:1,BrandAmbassadorCity:1,BrandAmbassadorCustomerId:1,BrandAmbassadorDescription:1,BrandAmbassadorDiscountCoupon:1,BrandAmbassadorEmail:1,BrandAmbassadorGstCertificate:1,BrandAmbassadorGstin:1,BrandAmbassadorId:1,BrandAmbassadorInsertDate:1,BrandAmbassadorInsertUserId:1,BrandAmbassadorIsActive:1,BrandAmbassadorMobile:1,BrandAmbassadorName:1,BrandAmbassadorPan:1,BrandAmbassadorPincode:1,BrandAmbassadorStateId:1,BrandAmbassadorUpdateDate:1,BrandAmbassadorUpdateUserId:1,BrandAmbassadorUserId:1,ESettelementStatus:1,Id:1,InsertDate:1,InsertUserId:1,IsActive:1,OrderBillingAddress1:1,OrderBillingAddress2:1,OrderBillingCity:1,OrderBillingPincode:1,OrderBillingStateId:1,OrderCustomerEmail1:1,OrderCustomerEmail2:1,OrderCustomerId:1,OrderCustomerMobile1:1,OrderCustomerMobile2:1,OrderCustomerName:1,OrderDiscountAmount:1,OrderDiscountCoupon:1,OrderDiscountPer:1,OrderEFranchiseeDiscount:1,OrderEFranchiseeDiscountType:1,OrderEInvoiceStatus:1,OrderEInvoiceTo:1,OrderEOrderProcessBy:1,OrderEOrderStatus:1,OrderEPaymentStatus:1,OrderEPaymentType:1,OrderEShippingStatus:1,OrderEShippingType:1,OrderESourceType:1,OrderEmailSendCount:1,OrderExpectedShippingDate:1,OrderFranchiseeDiscountAmount:1,OrderFranchiseeDiscountValue:1,OrderFranchiseeId:1,OrderFreezeData:1,OrderGrossAmount:1,OrderGstin:1,OrderId:1,OrderInsertDate:1,OrderInsertUserId:1,OrderInvoiceCompanyId:1,OrderIsActive:1,OrderIsEmailSent:1,OrderLastEmailSentDate:1,OrderMailId:1,OrderNetAmount:1,OrderOrderDate:1,OrderOrderNumber:1,OrderShippingAddress1:1,OrderShippingAddress2:1,OrderShippingCity:1,OrderShippingNote:1,OrderShippingPincode:1,OrderShippingProviderId:1,OrderShippingStateId:1,OrderShippingToName:1,OrderSourceName:1,OrderSourceOrderNumber:1,OrderTaxAmount:1,OrderTaxableAmount:1,OrderUpdateDate:1,OrderUpdateUserId:1,OrderVendorId:1,SettelmentId:1,ShareAmount:1,SharePercentage:1,UpdateDate:1,UpdateUserId:1},OrderFranchiseeShareCalculation:{ESettelementStatus:1,FranchiseeAddress:1,FranchiseeAlternateEmail:1,FranchiseeAlternateMobile:1,FranchiseeBankAccountName:1,FranchiseeBankAccountNo:1,FranchiseeBankAccountType:1,FranchiseeBankIfscCode:1,FranchiseeBankName:1,FranchiseeCity:1,FranchiseeCustomerId:1,FranchiseeDescription:1,FranchiseeDiscountCoupon:1,FranchiseeEmail:1,FranchiseeGstCertificate:1,FranchiseeGstin:1,FranchiseeId:1,FranchiseeInsertDate:1,FranchiseeInsertUserId:1,FranchiseeIsActive:1,FranchiseeIsCustomer:1,FranchiseeIsPostPayAllowed:1,FranchiseeMobile:1,FranchiseeName:1,FranchiseePan:1,FranchiseePincode:1,FranchiseeStateId:1,FranchiseeUpdateDate:1,FranchiseeUpdateUserId:1,FranchiseeUserId:1,Id:1,InsertDate:1,InsertUserId:1,IsActive:1,OrderBillingAddress1:1,OrderBillingAddress2:1,OrderBillingCity:1,OrderBillingPincode:1,OrderBillingStateId:1,OrderCustomerEmail1:1,OrderCustomerEmail2:1,OrderCustomerId:1,OrderCustomerMobile1:1,OrderCustomerMobile2:1,OrderCustomerName:1,OrderDiscountAmount:1,OrderDiscountCoupon:1,OrderDiscountPer:1,OrderEFranchiseeDiscount:1,OrderEFranchiseeDiscountType:1,OrderEInvoiceStatus:1,OrderEInvoiceTo:1,OrderEOrderProcessBy:1,OrderEOrderStatus:1,OrderEPaymentStatus:1,OrderEPaymentType:1,OrderEShippingStatus:1,OrderEShippingType:1,OrderESourceType:1,OrderEmailSendCount:1,OrderExpectedShippingDate:1,OrderFranchiseeDiscountAmount:1,OrderFranchiseeDiscountValue:1,OrderFranchiseeId:1,OrderGrossAmount:1,OrderGstin:1,OrderId:1,OrderInsertDate:1,OrderInsertUserId:1,OrderInvoiceCompanyId:1,OrderIsActive:1,OrderIsEmailSent:1,OrderLastEmailSentDate:1,OrderMailId:1,OrderNetAmount:1,OrderOrderDate:1,OrderOrderNumber:1,OrderProductsAllowedDevices:1,OrderProductsCost:1,OrderProductsDiscountAmt:1,OrderProductsDownloadUrl1:1,OrderProductsDownloadUrl2:1,OrderProductsEAccessStatus:1,OrderProductsEFranchiseeDiscountType:1,OrderProductsEOpens:1,OrderProductsESerialkeyStatus:1,OrderProductsEValidity:1,OrderProductsEValidityType:1,OrderProductsEWatchTime:1,OrderProductsFranchiseeDiscountAmount:1,OrderProductsFranchiseeDiscountValue:1,OrderProductsHasBooks:1,OrderProductsHasCourier:1,OrderProductsHasPendrive:1,OrderProductsId:1,OrderProductsInsertDate:1,OrderProductsInsertUserId:1,OrderProductsInvoiceCompanyId:1,OrderProductsIsActive:1,OrderProductsIsLive:1,OrderProductsIsTemplateSerialKey:1,OrderProductsNetAmount:1,OrderProductsNote:1,OrderProductsOrderId:1,OrderProductsProductId:1,OrderProductsQuantity:1,OrderProductsSerialKey:1,OrderProductsTaxableAmount:1,OrderProductsTotalAllowedDuration:1,OrderProductsUpdateDate:1,OrderProductsUpdateUserId:1,OrderProductsValidTill:1,OrderProdutcsGrossAmount:1,OrderShippingAddress1:1,OrderShippingAddress2:1,OrderShippingCity:1,OrderShippingNote:1,OrderShippingPincode:1,OrderShippingStateId:1,OrderShippingToName:1,OrderSourceName:1,OrderSourceOrderNumber:1,OrderTaxableAmount:1,OrderUpdateDate:1,OrderUpdateUserId:1,OrderVendorId:1,Quantity:1,SettelmentId:1,ShareAmount:1,SharePercentage:1,TotalShare:1,UpdateDate:1,UpdateUserId:1},OrderGiftCards:{Amount:1,BalanceAmount:1,GiftCardCouponCode:1,GiftCardId:1,Id:1,InsertDate:1,InsertUserId:1,IsActive:1,OrderBillingAddress1:1,OrderBillingAddress2:1,OrderBillingCity:1,OrderBillingCountry:1,OrderBillingPincode:1,OrderBillingStateId:1,OrderCurrencyAmount:1,OrderCurrencyId:1,OrderCustomerEmail1:1,OrderCustomerEmail2:1,OrderCustomerId:1,OrderCustomerMobile1:1,OrderCustomerMobile2:1,OrderCustomerName:1,OrderDiscountAmount:1,OrderDiscountCoupon:1,OrderDiscountPer:1,OrderEFranchiseeDiscount:1,OrderEFranchiseeDiscountType:1,OrderEInvoiceStatus:1,OrderEInvoiceTo:1,OrderEOrderProcessBy:1,OrderEOrderStatus:1,OrderEPaymentStatus:1,OrderEPaymentType:1,OrderEShippingStatus:1,OrderEShippingType:1,OrderESourceType:1,OrderEmailSendCount:1,OrderExpectedShippingDate:1,OrderFranchiseeDiscountAmount:1,OrderFranchiseeDiscountValue:1,OrderFranchiseeId:1,OrderFreezeData:1,OrderGrossAmount:1,OrderGstin:1,OrderId:1,OrderInsertDate:1,OrderInsertUserId:1,OrderInvoiceCompanyId:1,OrderIsActive:1,OrderIsEmailSent:1,OrderLastEmailSentDate:1,OrderMailId:1,OrderMode:1,OrderNetAmount:1,OrderNetAmountAfterFrDiscount:1,OrderOrderDate:1,OrderOrderNumber:1,OrderShippingAddress1:1,OrderShippingAddress2:1,OrderShippingCity:1,OrderShippingCountry:1,OrderShippingNote:1,OrderShippingPincode:1,OrderShippingProviderId:1,OrderShippingStateId:1,OrderShippingToName:1,OrderSourceName:1,OrderSourceOrderNumber:1,OrderTaxAmount:1,OrderTaxableAmount:1,OrderUpdateDate:1,OrderUpdateUserId:1,OrderVendorId:1,UpdateDate:1,UpdateUserId:1},OrderInstallments:{Amount:1,EStatus:1,Id:1,InsertDate:1,InsertUserId:1,InstallmentDate:1,IsActive:1,Note:1,OrderBillingAddress1:1,OrderBillingAddress2:1,OrderBillingCity:1,OrderBillingCountry:1,OrderBillingPincode:1,OrderBillingStateId:1,OrderCurrencyAmount:1,OrderCurrencyId:1,OrderCustomerEmail1:1,OrderCustomerEmail2:1,OrderCustomerId:1,OrderCustomerMobile1:1,OrderCustomerMobile2:1,OrderCustomerName:1,OrderDiscountAmount:1,OrderDiscountCoupon:1,OrderDiscountPer:1,OrderEFranchiseeDiscount:1,OrderEFranchiseeDiscountType:1,OrderEInvoiceStatus:1,OrderEInvoiceTo:1,OrderEOrderProcessBy:1,OrderEOrderStatus:1,OrderEPaymentStatus:1,OrderEPaymentType:1,OrderEShippingStatus:1,OrderEShippingType:1,OrderESourceType:1,OrderEmailSendCount:1,OrderExpectedShippingDate:1,OrderFranchiseeDiscountAmount:1,OrderFranchiseeDiscountValue:1,OrderFranchiseeId:1,OrderFreezeData:1,OrderGrossAmount:1,OrderGstin:1,OrderId:1,OrderInsertDate:1,OrderInsertUserId:1,OrderInvoiceCompanyId:1,OrderIsActive:1,OrderIsEmailSent:1,OrderLastEmailSentDate:1,OrderMailId:1,OrderMode:1,OrderNetAmount:1,OrderNetAmountAfterFrDiscount:1,OrderOrderDate:1,OrderOrderNumber:1,OrderShippingAddress1:1,OrderShippingAddress2:1,OrderShippingCity:1,OrderShippingCountry:1,OrderShippingNote:1,OrderShippingPincode:1,OrderShippingProviderId:1,OrderShippingStateId:1,OrderShippingToName:1,OrderSourceName:1,OrderSourceOrderNumber:1,OrderTaxAmount:1,OrderTaxableAmount:1,OrderUpdateDate:1,OrderUpdateUserId:1,OrderVendorId:1,OutstandingAmount:1,UpdateDate:1,UpdateUserId:1},OrderPayment:{Amount:1,BankName:1,ChequeNumber:1,EPaymentMode:1,EStatus:1,Id:1,InsertDate:1,InsertUserId:1,IsActive:1,Note:1,OrderBillingAddress1:1,OrderBillingAddress2:1,OrderBillingCity:1,OrderBillingPincode:1,OrderBillingStateId:1,OrderCustomerEmail1:1,OrderCustomerEmail2:1,OrderCustomerId:1,OrderCustomerMobile1:1,OrderCustomerMobile2:1,OrderCustomerName:1,OrderDiscountAmount:1,OrderDiscountCoupon:1,OrderDiscountPer:1,OrderEFranchiseeDiscount:1,OrderEFranchiseeDiscountType:1,OrderEInvoiceStatus:1,OrderEInvoiceTo:1,OrderEOrderProcessBy:1,OrderEOrderStatus:1,OrderEPaymentStatus:1,OrderEPaymentType:1,OrderEShippingStatus:1,OrderEShippingType:1,OrderESourceType:1,OrderEmailSendCount:1,OrderExpectedShippingDate:1,OrderFranchiseeDiscountAmount:1,OrderFranchiseeDiscountValue:1,OrderFranchiseeId:1,OrderGrossAmount:1,OrderGstin:1,OrderId:1,OrderInsertDate:1,OrderInsertUserId:1,OrderInvoiceCompanyId:1,OrderIsActive:1,OrderIsEmailSent:1,OrderLastEmailSentDate:1,OrderMailId:1,OrderNetAmount:1,OrderOrderDate:1,OrderOrderNumber:1,OrderShippingAddress1:1,OrderShippingAddress2:1,OrderShippingCity:1,OrderShippingNote:1,OrderShippingPincode:1,OrderShippingStateId:1,OrderShippingToName:1,OrderSourceName:1,OrderSourceOrderNumber:1,OrderTaxableAmount:1,OrderUpdateDate:1,OrderUpdateUserId:1,OrderVendorId:1,PaymentDate:1,TransactionId:1,UpdateDate:1,UpdateUserId:1},OrderProductBillingItems:{DiscountAmount:1,GrossAmount:1,Id:1,InsertDate:1,InsertUserId:1,InvoiceCompanyAddress:1,InvoiceCompanyFooterNote:1,InvoiceCompanyGstIn:1,InvoiceCompanyId:1,InvoiceCompanyInvoiceChangeDate:1,InvoiceCompanyInvoiceCode:1,InvoiceCompanyIsDefault:1,InvoiceCompanyIsTaxApplicable:1,InvoiceCompanyLogo1:1,InvoiceCompanyLogo2:1,InvoiceCompanyName:1,InvoiceCompanyStampImage:1,IsActive:1,NetAmount:1,OrderBillingAddress1:1,OrderBillingAddress2:1,OrderBillingCity:1,OrderBillingPincode:1,OrderBillingStateId:1,OrderCustomerEmail1:1,OrderCustomerEmail2:1,OrderCustomerId:1,OrderCustomerMobile1:1,OrderCustomerMobile2:1,OrderCustomerName:1,OrderDiscountAmount:1,OrderDiscountCoupon:1,OrderDiscountPer:1,OrderEFranchiseeDiscount:1,OrderEFranchiseeDiscountType:1,OrderEInvoiceStatus:1,OrderEInvoiceTo:1,OrderEOrderProcessBy:1,OrderEOrderStatus:1,OrderEPaymentStatus:1,OrderEPaymentType:1,OrderEShippingStatus:1,OrderEShippingType:1,OrderESourceType:1,OrderEmailSendCount:1,OrderExpectedShippingDate:1,OrderFranchiseeDiscountAmount:1,OrderFranchiseeDiscountValue:1,OrderFranchiseeId:1,OrderGrossAmount:1,OrderGstin:1,OrderId:1,OrderInsertDate:1,OrderInsertUserId:1,OrderInvoiceCompanyId:1,OrderIsActive:1,OrderIsEmailSent:1,OrderLastEmailSentDate:1,OrderMailId:1,OrderNetAmount:1,OrderOrderDate:1,OrderOrderNumber:1,OrderProductBillingItemsTax:1,OrderProductsAllowedDevices:1,OrderProductsCost:1,OrderProductsDiscountAmt:1,OrderProductsDownloadUrl1:1,OrderProductsDownloadUrl2:1,OrderProductsEAccessStatus:1,OrderProductsEFranchiseeDiscountType:1,OrderProductsEOpens:1,OrderProductsESerialkeyStatus:1,OrderProductsEValidity:1,OrderProductsEValidityType:1,OrderProductsEWatchTime:1,OrderProductsFranchiseeDiscountAmount:1,OrderProductsFranchiseeDiscountValue:1,OrderProductsGrossAmount:1,OrderProductsHasBooks:1,OrderProductsHasCourier:1,OrderProductsHasPendrive:1,OrderProductsId:1,OrderProductsInsertDate:1,OrderProductsInsertUserId:1,OrderProductsInvoiceCompanyId:1,OrderProductsIsActive:1,OrderProductsIsLive:1,OrderProductsIsTemplateSerialKey:1,OrderProductsNetAmount:1,OrderProductsNote:1,OrderProductsOrderId:1,OrderProductsProductId:1,OrderProductsQuantity:1,OrderProductsSerialKey:1,OrderProductsTaxableAmount:1,OrderProductsTotalAllowedDuration:1,OrderProductsUpdateDate:1,OrderProductsUpdateUserId:1,OrderProductsValidTill:1,OrderShippingAddress1:1,OrderShippingAddress2:1,OrderShippingCity:1,OrderShippingNote:1,OrderShippingPincode:1,OrderShippingStateId:1,OrderShippingToName:1,OrderSourceName:1,OrderSourceOrderNumber:1,OrderTaxableAmount:1,OrderUpdateDate:1,OrderUpdateUserId:1,OrderVendorId:1,ProductBillingItemBillingItemName:1,ProductBillingItemEDiscountType:1,ProductBillingItemEndDate:1,ProductBillingItemGrossAmount:1,ProductBillingItemHsnMasterId:1,ProductBillingItemId:1,ProductBillingItemIncludingTax:1,ProductBillingItemInsertDate:1,ProductBillingItemInsertUserId:1,ProductBillingItemInvoiceCompanyId:1,ProductBillingItemIsActive:1,ProductBillingItemProductId:1,ProductBillingItemSpecialGrossAmount:1,ProductBillingItemStartDate:1,ProductBillingItemTaxCategoryId:1,ProductBillingItemUpdateDate:1,ProductBillingItemUpdateUserId:1,TaxCategoryId:1,TaxCategoryInsertDate:1,TaxCategoryInsertUserId:1,TaxCategoryIsActive:1,TaxCategoryName:1,TaxCategoryUpdateDate:1,TaxCategoryUpdateUserId:1,TaxableAmount:1,UpdateDate:1,UpdateUserId:1},OrderProductBillingItemsTax:{Id:1,InsertDate:1,InsertUserId:1,IsActive:1,OrderBillingAddress1:1,OrderBillingAddress2:1,OrderBillingCity:1,OrderBillingPincode:1,OrderBillingStateId:1,OrderCustomerEmail1:1,OrderCustomerEmail2:1,OrderCustomerId:1,OrderCustomerMobile1:1,OrderCustomerMobile2:1,OrderCustomerName:1,OrderDiscountAmount:1,OrderDiscountCoupon:1,OrderDiscountPer:1,OrderEFranchiseeDiscount:1,OrderEFranchiseeDiscountType:1,OrderEInvoiceStatus:1,OrderEInvoiceTo:1,OrderEOrderProcessBy:1,OrderEOrderStatus:1,OrderEPaymentStatus:1,OrderEPaymentType:1,OrderEShippingStatus:1,OrderEShippingType:1,OrderESourceType:1,OrderEmailSendCount:1,OrderExpectedShippingDate:1,OrderFranchiseeDiscountAmount:1,OrderFranchiseeDiscountValue:1,OrderFranchiseeId:1,OrderGrossAmount:1,OrderGstin:1,OrderId:1,OrderInsertDate:1,OrderInsertUserId:1,OrderInvoiceCompanyId:1,OrderIsActive:1,OrderIsEmailSent:1,OrderLastEmailSentDate:1,OrderMailId:1,OrderNetAmount:1,OrderOrderDate:1,OrderOrderNumber:1,OrderProductBillingItemsDiscountAmount:1,OrderProductBillingItemsGrossAmount:1,OrderProductBillingItemsId:1,OrderProductBillingItemsInsertDate:1,OrderProductBillingItemsInsertUserId:1,OrderProductBillingItemsInvoiceCompanyId:1,OrderProductBillingItemsIsActive:1,OrderProductBillingItemsNetAmount:1,OrderProductBillingItemsOrderId:1,OrderProductBillingItemsOrderProductsId:1,OrderProductBillingItemsProductBillingItemId:1,OrderProductBillingItemsTaxCategoryId:1,OrderProductBillingItemsUpdateDate:1,OrderProductBillingItemsUpdateUserId:1,OrderProductsAllowedDevices:1,OrderProductsCost:1,OrderProductsDiscountAmt:1,OrderProductsDownloadUrl1:1,OrderProductsDownloadUrl2:1,OrderProductsEAccessStatus:1,OrderProductsEFranchiseeDiscountType:1,OrderProductsEOpens:1,OrderProductsESerialkeyStatus:1,OrderProductsEValidity:1,OrderProductsEValidityType:1,OrderProductsEWatchTime:1,OrderProductsFranchiseeDiscountAmount:1,OrderProductsFranchiseeDiscountValue:1,OrderProductsGrossAmount:1,OrderProductsHasBooks:1,OrderProductsHasCourier:1,OrderProductsHasPendrive:1,OrderProductsId:1,OrderProductsInsertDate:1,OrderProductsInsertUserId:1,OrderProductsInvoiceCompanyId:1,OrderProductsIsActive:1,OrderProductsIsLive:1,OrderProductsIsTemplateSerialKey:1,OrderProductsNetAmount:1,OrderProductsNote:1,OrderProductsOrderId:1,OrderProductsProductId:1,OrderProductsQuantity:1,OrderProductsSerialKey:1,OrderProductsTaxableAmount:1,OrderProductsTotalAllowedDuration:1,OrderProductsUpdateDate:1,OrderProductsUpdateUserId:1,OrderProductsValidTill:1,OrderShippingAddress1:1,OrderShippingAddress2:1,OrderShippingCity:1,OrderShippingNote:1,OrderShippingPincode:1,OrderShippingStateId:1,OrderShippingToName:1,OrderSourceName:1,OrderSourceOrderNumber:1,OrderTaxableAmount:1,OrderUpdateDate:1,OrderUpdateUserId:1,OrderVendorId:1,Rate:1,TaxAmount:1,TaxTypeId:1,TaxTypeName:1,UpdateDate:1,UpdateUserId:1},OrderProductSpecifications:{Id:1,InsertDate:1,InsertUserId:1,IsActive:1,OrderBillingAddress1:1,OrderBillingAddress2:1,OrderBillingCity:1,OrderBillingPincode:1,OrderBillingStateId:1,OrderCustomerEmail1:1,OrderCustomerEmail2:1,OrderCustomerId:1,OrderCustomerMobile1:1,OrderCustomerMobile2:1,OrderCustomerName:1,OrderDiscountAmount:1,OrderDiscountCoupon:1,OrderDiscountPer:1,OrderEFranchiseeDiscount:1,OrderEFranchiseeDiscountType:1,OrderEInvoiceStatus:1,OrderEInvoiceTo:1,OrderEOrderProcessBy:1,OrderEOrderStatus:1,OrderEPaymentStatus:1,OrderEPaymentType:1,OrderEShippingStatus:1,OrderEShippingType:1,OrderESourceType:1,OrderEmailSendCount:1,OrderExpectedShippingDate:1,OrderFranchiseeDiscountAmount:1,OrderFranchiseeDiscountValue:1,OrderFranchiseeId:1,OrderGrossAmount:1,OrderGstin:1,OrderId:1,OrderInsertDate:1,OrderInsertUserId:1,OrderInvoiceCompanyId:1,OrderIsActive:1,OrderIsEmailSent:1,OrderLastEmailSentDate:1,OrderMailId:1,OrderNetAmount:1,OrderOrderDate:1,OrderOrderNumber:1,OrderProductsAllowedDevices:1,OrderProductsCost:1,OrderProductsDiscountAmt:1,OrderProductsDownloadUrl1:1,OrderProductsDownloadUrl2:1,OrderProductsEAccessStatus:1,OrderProductsEFranchiseeDiscountType:1,OrderProductsEOpens:1,OrderProductsESerialkeyStatus:1,OrderProductsEValidity:1,OrderProductsEValidityType:1,OrderProductsEWatchTime:1,OrderProductsFranchiseeDiscountAmount:1,OrderProductsFranchiseeDiscountValue:1,OrderProductsGrossAmount:1,OrderProductsHasBooks:1,OrderProductsHasCourier:1,OrderProductsHasPendrive:1,OrderProductsId:1,OrderProductsInsertDate:1,OrderProductsInsertUserId:1,OrderProductsInvoiceCompanyId:1,OrderProductsIsActive:1,OrderProductsIsLive:1,OrderProductsIsTemplateSerialKey:1,OrderProductsNetAmount:1,OrderProductsNote:1,OrderProductsOrderId:1,OrderProductsProductId:1,OrderProductsQuantity:1,OrderProductsSerialKey:1,OrderProductsTaxableAmount:1,OrderProductsTotalAllowedDuration:1,OrderProductsUpdateDate:1,OrderProductsUpdateUserId:1,OrderProductsValidTill:1,OrderShippingAddress1:1,OrderShippingAddress2:1,OrderShippingCity:1,OrderShippingNote:1,OrderShippingPincode:1,OrderShippingStateId:1,OrderShippingToName:1,OrderSourceName:1,OrderSourceOrderNumber:1,OrderTaxableAmount:1,OrderUpdateDate:1,OrderUpdateUserId:1,OrderVendorId:1,ProductSpecificationAllowedDevices:1,ProductSpecificationEValidity:1,ProductSpecificationEValidityType:1,ProductSpecificationEWatchtime:1,ProductSpecificationEopens:1,ProductSpecificationHasBooks:1,ProductSpecificationHasCourier:1,ProductSpecificationHasPendrive:1,ProductSpecificationId:1,ProductSpecificationInsertDate:1,ProductSpecificationInsertUserId:1,ProductSpecificationIsLive:1,ProductSpecificationProcessOrderOnPaid:1,ProductSpecificationProductId:1,ProductSpecificationSpecificationCode:1,ProductSpecificationSpecificationName:1,ProductSpecificationUpdateDate:1,ProductSpecificationUpdateUserId:1,ProductSpecificationValidTill:1,UpdateDate:1,UpdateUserId:1},OrderProducts:{AllowedDevice:1,AllowedDevices:1,Cost:1,DiscountAmt:1,DownloadUrl1:1,DownloadUrl2:1,EAccessStatus:1,EFranchiseeDiscountType:1,EOpens:1,ERioplayVersion:1,ESerialkeyStatus:1,EValidity:1,EValidityType:1,EWatchTime:1,FranchiseeDiscountAmount:1,FranchiseeDiscountValue:1,FranchiseeId:1,GrossAmount:1,HasBooks:1,HasCourier:1,HasPendrive:1,Id:1,InsertDate:1,InsertUserId:1,InvoiceCompanyAddress:1,InvoiceCompanyFooterNote:1,InvoiceCompanyGstIn:1,InvoiceCompanyId:1,InvoiceCompanyInvoiceChangeDate:1,InvoiceCompanyInvoiceCode:1,InvoiceCompanyIsDefault:1,InvoiceCompanyIsTaxApplicable:1,InvoiceCompanyLogo1:1,InvoiceCompanyLogo2:1,InvoiceCompanyName:1,InvoiceCompanyStampImage:1,IsActive:1,IsLive:1,IsTemplateSerialKey:1,NetAmount:1,NetAmountAfterFrDiscount:1,Note:1,OrderBillingAddress1:1,OrderBillingAddress2:1,OrderBillingCity:1,OrderBillingPincode:1,OrderBillingStateId:1,OrderCustomerEmail1:1,OrderCustomerEmail2:1,OrderCustomerId:1,OrderCustomerMobile1:1,OrderCustomerMobile2:1,OrderCustomerName:1,OrderDiscountAmount:1,OrderDiscountCoupon:1,OrderDiscountPer:1,OrderEFranchiseeDiscount:1,OrderEFranchiseeDiscountType:1,OrderEInvoiceStatus:1,OrderEInvoiceTo:1,OrderEOrderProcessBy:1,OrderEOrderStatus:1,OrderEPaymentStatus:1,OrderEPaymentType:1,OrderEShippingStatus:1,OrderEShippingType:1,OrderESourceType:1,OrderEmailSendCount:1,OrderExpectedShippingDate:1,OrderFranchiseeDiscountAmount:1,OrderFranchiseeDiscountValue:1,OrderFranchiseeId:1,OrderGrossAmount:1,OrderGstin:1,OrderId:1,OrderInsertDate:1,OrderInsertUserId:1,OrderInvoiceCompanyId:1,OrderIsActive:1,OrderIsEmailSent:1,OrderLastEmailSentDate:1,OrderMailId:1,OrderNetAmount:1,OrderOrderDate:1,OrderOrderNumber:1,OrderProduct:1,OrderProductSpecificationId:1,OrderShippingAddress1:1,OrderShippingAddress2:1,OrderShippingCity:1,OrderShippingNote:1,OrderShippingPincode:1,OrderShippingStateId:1,OrderShippingToName:1,OrderSourceName:1,OrderSourceOrderNumber:1,OrderTaxableAmount:1,OrderUpdateDate:1,OrderUpdateUserId:1,OrderVendorId:1,ProductActivateSerialKey:1,ProductAllowSerialKeyGeneration:1,ProductAllowedDevices:1,ProductDescription:1,ProductDownloadUrl1:1,ProductDownloadUrl2:1,ProductEAccessStatus:1,ProductEOpens:1,ProductEPackingType:1,ProductEProductType:1,ProductERioplayVersion:1,ProductEShippedby:1,ProductEValidity:1,ProductEValidityType:1,ProductEWatchTime:1,ProductGrossAmount:1,ProductHasBooks:1,ProductHasCourier:1,ProductHasPenDrive:1,ProductHasVod:1,ProductHeight:1,ProductId:1,ProductInAppDownload:1,ProductInsertDate:1,ProductInsertUserId:1,ProductIsActive:1,ProductIsCombo:1,ProductIsLive:1,ProductLength:1,ProductNote:1,ProductProcesOrderOnPaid:1,ProductProductIds:1,ProductProductName:1,ProductProductQueryInfo:1,ProductRioplayProductCode:1,ProductSkuCode:1,ProductSupportInfo:1,ProductTeacherName:1,ProductTemplateSerialKeyId:1,ProductTotalAllowedDuration:1,ProductUpdateDate:1,ProductUpdateUserId:1,ProductValidTill:1,ProductVendorId:1,ProductWebsiteUrl:1,ProductWeight:1,ProductWidth:1,Quantity:1,Rioplay8AllowedDevices:1,Rioplay8DeviceCount:1,Rioplay8EDeviceRestrictionType:1,Rioplay8ESubscriptionType:1,Rioplay8EViewsType:1,Rioplay8EWatchTimetype:1,Rioplay8ProductCode:1,Rioplay8SwitchCount:1,Rioplay8TenantId:1,Rioplay8ValidDate:1,Rioplay8ValidityInDays:1,Rioplay8ViewsPerContent:1,Rioplay8WatchTime:1,SerialKey:1,TaxAmount:1,TaxableAmount:1,TotalAllowedDuration:1,UpdateDate:1,UpdateUserId:1,ValidTill:1},OrderShipping:{CustomerName:1,EStatus:1,Id:1,InsertDate:1,InsertUserId:1,IsActive:1,OrderBillingAddress1:1,OrderBillingAddress2:1,OrderBillingCity:1,OrderBillingPincode:1,OrderBillingStateId:1,OrderCustomerEmail1:1,OrderCustomerEmail2:1,OrderCustomerId:1,OrderCustomerMobile1:1,OrderCustomerMobile2:1,OrderCustomerName:1,OrderDiscountAmount:1,OrderDiscountCoupon:1,OrderDiscountPer:1,OrderEFranchiseeDiscount:1,OrderEFranchiseeDiscountType:1,OrderEInvoiceStatus:1,OrderEInvoiceTo:1,OrderEOrderProcessBy:1,OrderEOrderStatus:1,OrderEPaymentStatus:1,OrderEPaymentType:1,OrderEShippingStatus:1,OrderEShippingType:1,OrderESourceType:1,OrderEmailSendCount:1,OrderExpectedShippingDate:1,OrderFranchiseeDiscountAmount:1,OrderFranchiseeDiscountValue:1,OrderFranchiseeId:1,OrderGrossAmount:1,OrderGstin:1,OrderId:1,OrderInsertDate:1,OrderInsertUserId:1,OrderInvoiceCompanyId:1,OrderIsActive:1,OrderIsEmailSent:1,OrderLastEmailSentDate:1,OrderMailId:1,OrderNetAmount:1,OrderOrderDate:1,OrderOrderNumber:1,OrderShippingAddress1:1,OrderShippingAddress2:1,OrderShippingCity:1,OrderShippingNote:1,OrderShippingPincode:1,OrderShippingStateId:1,OrderShippingToName:1,OrderSourceName:1,OrderSourceOrderNumber:1,OrderTaxableAmount:1,OrderUpdateDate:1,OrderUpdateUserId:1,OrderVendorId:1,OrdershippingBooks:1,OrdershippingPendrives:1,ShippingCost:1,ShippingDate:1,ShippingProviderBankAccountNo:1,ShippingProviderBankIfscCode:1,ShippingProviderBankName:1,ShippingProviderDescription:1,ShippingProviderEApiStatus:1,ShippingProviderEShippingProviderType:1,ShippingProviderGstCertificate:1,ShippingProviderGstin:1,ShippingProviderId:1,ShippingProviderInsertDate:1,ShippingProviderInsertUserId:1,ShippingProviderIsActive:1,ShippingProviderIsDefault:1,ShippingProviderPan:1,ShippingProviderSecret:1,ShippingProviderShippingProviderName:1,ShippingProviderTrackingUrl:1,ShippingProviderUpdateDate:1,ShippingProviderUpdateUserId:1,ShippingProviderVendorId:1,TrackingId:1,TrackingUrl:1,UpdateDate:1,UpdateUserId:1},OrderTeacherShareCalculation:{ESettelementStatus:1,Id:1,InsertDate:1,InsertUserId:1,IsActive:1,OrderBillingAddress1:1,OrderBillingAddress2:1,OrderBillingCity:1,OrderBillingPincode:1,OrderBillingStateId:1,OrderCustomerEmail1:1,OrderCustomerEmail2:1,OrderCustomerId:1,OrderCustomerMobile1:1,OrderCustomerMobile2:1,OrderCustomerName:1,OrderDiscountAmount:1,OrderDiscountCoupon:1,OrderDiscountPer:1,OrderEFranchiseeDiscount:1,OrderEFranchiseeDiscountType:1,OrderEInvoiceStatus:1,OrderEInvoiceTo:1,OrderEOrderProcessBy:1,OrderEOrderStatus:1,OrderEPaymentStatus:1,OrderEPaymentType:1,OrderEShippingStatus:1,OrderEShippingType:1,OrderESourceType:1,OrderEmailSendCount:1,OrderExpectedShippingDate:1,OrderFranchiseeDiscountAmount:1,OrderFranchiseeDiscountValue:1,OrderFranchiseeId:1,OrderGrossAmount:1,OrderGstin:1,OrderId:1,OrderInsertDate:1,OrderInsertUserId:1,OrderInvoiceCompanyId:1,OrderIsActive:1,OrderIsEmailSent:1,OrderLastEmailSentDate:1,OrderMailId:1,OrderNetAmount:1,OrderOrderDate:1,OrderOrderNumber:1,OrderProductsAllowedDevices:1,OrderProductsCost:1,OrderProductsDiscountAmt:1,OrderProductsDownloadUrl1:1,OrderProductsDownloadUrl2:1,OrderProductsEAccessStatus:1,OrderProductsEFranchiseeDiscountType:1,OrderProductsEOpens:1,OrderProductsESerialkeyStatus:1,OrderProductsEValidity:1,OrderProductsEValidityType:1,OrderProductsEWatchTime:1,OrderProductsFranchiseeDiscountAmount:1,OrderProductsFranchiseeDiscountValue:1,OrderProductsGrossAmount:1,OrderProductsHasBooks:1,OrderProductsHasCourier:1,OrderProductsHasPendrive:1,OrderProductsId:1,OrderProductsInsertDate:1,OrderProductsInsertUserId:1,OrderProductsInvoiceCompanyId:1,OrderProductsIsActive:1,OrderProductsIsLive:1,OrderProductsIsTemplateSerialKey:1,OrderProductsNetAmount:1,OrderProductsNote:1,OrderProductsOrderId:1,OrderProductsProductId:1,OrderProductsQuantity:1,OrderProductsSerialKey:1,OrderProductsTaxableAmount:1,OrderProductsTotalAllowedDuration:1,OrderProductsUpdateDate:1,OrderProductsUpdateUserId:1,OrderProductsValidTill:1,OrderProdutcsCost:1,OrderShippingAddress1:1,OrderShippingAddress2:1,OrderShippingCity:1,OrderShippingNote:1,OrderShippingPincode:1,OrderShippingStateId:1,OrderShippingToName:1,OrderSourceName:1,OrderSourceOrderNumber:1,OrderTaxableAmount:1,OrderUpdateDate:1,OrderUpdateUserId:1,OrderVendorId:1,Qty:1,SettelmentId:1,ShareAmount:1,SharePercentage:1,TeacherAddress:1,TeacherAlternateEmail:1,TeacherAlternateMobile:1,TeacherBankAccountName:1,TeacherBankAccountNo:1,TeacherBankAccountType:1,TeacherBankIfscCode:1,TeacherBankName:1,TeacherCity:1,TeacherDescription:1,TeacherEmail:1,TeacherGstCertificate:1,TeacherGstin:1,TeacherId:1,TeacherInsertDate:1,TeacherInsertUserId:1,TeacherIsActive:1,TeacherMobile:1,TeacherName:1,TeacherPan:1,TeacherPincode:1,TeacherStateId:1,TeacherUpdateDate:1,TeacherUpdateUserId:1,TeacherUserId:1,TotalShare:1,UpdateDate:1,UpdateUserId:1},OrderWebhook:{ErrorNote:1,Id:1,InsertDate:1,InsertUserId:1,IsActive:1,IsSynced:1,OrderId:1,Orderguid:1,SiteName:1,UpdateDate:1,UpdateUserId:1,hasError:1},Orders:{BillingAddress1:1,BillingAddress2:1,BillingCity:1,BillingCountry:1,BillingPincode:1,BillingStateId:1,BillingStateInsertDate:1,BillingStateInsertUserId:1,BillingStateIsActive:1,BillingStateIsHomeState:1,BillingStateName:1,BillingStateUpdateDate:1,BillingStateUpdateUserId:1,CalculationCurrency:1,CartId:1,CurrencyAmount:1,CurrencyId:1,CustomerCouponCode:1,CustomerDisplayName:1,CustomerECustomerType:1,CustomerEmail1:1,CustomerEmail2:1,CustomerGstin:1,CustomerId:1,CustomerInsertDate:1,CustomerInsertUserId:1,CustomerIsActive:1,CustomerMobile11:1,CustomerMobile21:1,CustomerName1:1,CustomerUpdateDate:1,CustomerUpdateUserId:1,DiscountAmount:1,DiscountCoupon:1,DiscountPer:1,EFranchiseeDiscount:1,EFranchiseeDiscountType:1,EInvoiceStatus:1,EInvoiceTo:1,EOrderProcessBy:1,EOrderStatus:1,EPaymentStatus:1,EPaymentType:1,EShippingStatus:1,EShippingType:1,ESourceType:1,EmailSendCount:1,ExpectedShippingDate:1,FranchiseeAddress:1,FranchiseeAlternateEmail:1,FranchiseeAlternateMobile:1,FranchiseeBankAccountName:1,FranchiseeBankAccountNo:1,FranchiseeBankAccountType:1,FranchiseeBankIfscCode:1,FranchiseeBankName:1,FranchiseeCity:1,FranchiseeCustomerId:1,FranchiseeDescription:1,FranchiseeDiscountAmount:1,FranchiseeDiscountCoupon:1,FranchiseeDiscountValue:1,FranchiseeEmail:1,FranchiseeGstCertificate:1,FranchiseeGstin:1,FranchiseeId:1,FranchiseeInsertDate:1,FranchiseeInsertUserId:1,FranchiseeIsActive:1,FranchiseeIsCustomer:1,FranchiseeIsPostPayAllowed:1,FranchiseeMobile:1,FranchiseeName:1,FranchiseePan:1,FranchiseePincode:1,FranchiseeStateId:1,FranchiseeUpdateDate:1,FranchiseeUpdateUserId:1,FranchiseeUserId:1,FreezeData:1,GrossAmount:1,Gstin:1,HasBooks:1,Id:1,InsertDate:1,InsertUserId:1,InvoiceCompanyAddress:1,InvoiceCompanyFooterNote:1,InvoiceCompanyGstIn:1,InvoiceCompanyId:1,InvoiceCompanyInvoiceChangeDate:1,InvoiceCompanyInvoiceCode:1,InvoiceCompanyIsDefault:1,InvoiceCompanyIsTaxApplicable:1,InvoiceCompanyLogo1:1,InvoiceCompanyLogo2:1,InvoiceCompanyName:1,InvoiceCompanyStampImage:1,IsActive:1,IsEmailSent:1,LastEmailSentDate:1,Level:1,MailId:1,Mode:1,NetAmount:1,NetAmountAfterFrDiscount:1,Note:1,OrderDate:1,OrderInstallments:1,OrderNumber:1,OrderProducts:1,ShippingAddress1:1,ShippingAddress2:1,ShippingCity:1,ShippingCountry:1,ShippingNote:1,ShippingPincode:1,ShippingProviderId:1,ShippingProviderName:1,ShippingStateId:1,ShippingStateInsertDate:1,ShippingStateInsertUserId:1,ShippingStateIsActive:1,ShippingStateIsHomeState:1,ShippingStateName:1,ShippingStateUpdateDate:1,ShippingStateUpdateUserId:1,ShippingToName:1,SourceName:1,SourceOrderNumber:1,TaxAmount:1,TaxableAmount:1,UpdateDate:1,UpdateUserId:1,VendorAddress:1,VendorBankAccountName:1,VendorBankAccountNo:1,VendorBankAccountType:1,VendorBankIfscCode:1,VendorBankName:1,VendorCity:1,VendorCountry:1,VendorDescription:1,VendorEmail:1,VendorGstCertificate:1,VendorGstin:1,VendorId:1,VendorInsertDate:1,VendorInsertUserId:1,VendorIsActive:1,VendorName:1,VendorPan:1,VendorPincode:1,VendorStateId:1,VendorUpdateDate:1,VendorUpdateUserId:1,VendorUserId:1,WebsiteOrderProducts:1,eBookStatus:1},OrdershippingBooks:{InsertDate:1,InsertUserId:1,IsActive:1,OrderBillingAddress1:1,OrderBillingAddress2:1,OrderBillingCity:1,OrderBillingPincode:1,OrderBillingStateId:1,OrderCustomerEmail1:1,OrderCustomerEmail2:1,OrderCustomerId:1,OrderCustomerMobile1:1,OrderCustomerMobile2:1,OrderCustomerName:1,OrderDiscountAmount:1,OrderDiscountCoupon:1,OrderDiscountPer:1,OrderEFranchiseeDiscount:1,OrderEFranchiseeDiscountType:1,OrderEInvoiceStatus:1,OrderEInvoiceTo:1,OrderEOrderProcessBy:1,OrderEOrderStatus:1,OrderEPaymentStatus:1,OrderEPaymentType:1,OrderEShippingStatus:1,OrderEShippingType:1,OrderESourceType:1,OrderEmailSendCount:1,OrderExpectedShippingDate:1,OrderFranchiseeDiscountAmount:1,OrderFranchiseeDiscountValue:1,OrderFranchiseeId:1,OrderGrossAmount:1,OrderGstin:1,OrderId:1,OrderInsertDate:1,OrderInsertUserId:1,OrderInvoiceCompanyId:1,OrderIsActive:1,OrderIsEmailSent:1,OrderLastEmailSentDate:1,OrderMailId:1,OrderNetAmount:1,OrderOrderDate:1,OrderOrderNumber:1,OrderShippingAddress1:1,OrderShippingAddress2:1,OrderShippingCity:1,OrderShippingId:1,OrderShippingNote:1,OrderShippingPincode:1,OrderShippingStateId:1,OrderShippingToName:1,OrderSourceName:1,OrderSourceOrderNumber:1,OrderTaxableAmount:1,OrderUpdateDate:1,OrderUpdateUserId:1,OrderVendorId:1,OrdershippingBooksId:1,ProductActivateSerialKey:1,ProductAllowSerialKeyGeneration:1,ProductAllowedDevices:1,ProductBookid:1,ProductDescription:1,ProductDownloadUrl1:1,ProductDownloadUrl2:1,ProductEAccessStatus:1,ProductEOpens:1,ProductEPackingType:1,ProductEProductType:1,ProductERioplayVersion:1,ProductEShippedby:1,ProductEValidity:1,ProductEValidityType:1,ProductEWatchTime:1,ProductGrossAmount:1,ProductHasBooks:1,ProductHasCourier:1,ProductHasPenDrive:1,ProductHasVod:1,ProductHeight:1,ProductId:1,ProductInAppDownload:1,ProductInsertDate:1,ProductInsertUserId:1,ProductIsActive:1,ProductIsCombo:1,ProductIsLive:1,ProductLength:1,ProductNote:1,ProductProcesOrderOnPaid:1,ProductProductIds:1,ProductProductName:1,ProductProductQueryInfo:1,ProductRioplayProductCode:1,ProductSkuCode:1,ProductSupportInfo:1,ProductTeacherName:1,ProductTemplateSerialKeyId:1,ProductTotalAllowedDuration:1,ProductUpdateDate:1,ProductUpdateUserId:1,ProductValidTill:1,ProductVendorId:1,ProductWebsiteUrl:1,ProductWeight:1,ProductWidth:1,Quantity:1,UpdateDate:1,UpdateUserId:1},OrdershippingPendrives:{InsertDate:1,InsertUserId:1,IsActive:1,OrderBillingAddress1:1,OrderBillingAddress2:1,OrderBillingCity:1,OrderBillingPincode:1,OrderBillingStateId:1,OrderCustomerEmail1:1,OrderCustomerEmail2:1,OrderCustomerId:1,OrderCustomerMobile1:1,OrderCustomerMobile2:1,OrderCustomerName:1,OrderDiscountAmount:1,OrderDiscountCoupon:1,OrderDiscountPer:1,OrderEFranchiseeDiscount:1,OrderEFranchiseeDiscountType:1,OrderEInvoiceStatus:1,OrderEInvoiceTo:1,OrderEOrderProcessBy:1,OrderEOrderStatus:1,OrderEPaymentStatus:1,OrderEPaymentType:1,OrderEShippingStatus:1,OrderEShippingType:1,OrderESourceType:1,OrderEmailSendCount:1,OrderExpectedShippingDate:1,OrderFranchiseeDiscountAmount:1,OrderFranchiseeDiscountValue:1,OrderFranchiseeId:1,OrderGrossAmount:1,OrderGstin:1,OrderId:1,OrderInsertDate:1,OrderInsertUserId:1,OrderInvoiceCompanyId:1,OrderIsActive:1,OrderIsEmailSent:1,OrderLastEmailSentDate:1,OrderMailId:1,OrderNetAmount:1,OrderOrderDate:1,OrderOrderNumber:1,OrderShippingAddress1:1,OrderShippingAddress2:1,OrderShippingCity:1,OrderShippingId:1,OrderShippingNote:1,OrderShippingPincode:1,OrderShippingStateId:1,OrderShippingToName:1,OrderSourceName:1,OrderSourceOrderNumber:1,OrderTaxableAmount:1,OrderUpdateDate:1,OrderUpdateUserId:1,OrderVendorId:1,OrdershippingPendrivesId:1,PenDriveTypeId:1,PendriveType:1,ProductActivateSerialKey:1,ProductAllowSerialKeyGeneration:1,ProductAllowedDevices:1,ProductDescription:1,ProductDownloadUrl1:1,ProductDownloadUrl2:1,ProductEAccessStatus:1,ProductEOpens:1,ProductEPackingType:1,ProductEProductType:1,ProductERioplayVersion:1,ProductEShippedby:1,ProductEValidity:1,ProductEValidityType:1,ProductEWatchTime:1,ProductGrossAmount:1,ProductHasBooks:1,ProductHasCourier:1,ProductHasPenDrive:1,ProductHasVod:1,ProductHeight:1,ProductId:1,ProductInAppDownload:1,ProductInsertDate:1,ProductInsertUserId:1,ProductIsActive:1,ProductIsCombo:1,ProductIsLive:1,ProductLength:1,ProductNote:1,ProductProcesOrderOnPaid:1,ProductProductIds:1,ProductProductName:1,ProductProductQueryInfo:1,ProductRioplayProductCode:1,ProductSkuCode:1,ProductSupportInfo:1,ProductTeacherName:1,ProductTemplateSerialKeyId:1,ProductTotalAllowedDuration:1,ProductUpdateDate:1,ProductUpdateUserId:1,ProductValidTill:1,ProductVendorId:1,ProductWebsiteUrl:1,ProductWeight:1,ProductWidth:1,Quantity:1,UpdateDate:1,UpdateUserId:1},TeacherPayments:{BankName:1,Comment:1,Id:1,InsertDate:1,InsertUserId:1,IsActive:1,PaidAmount:1,PaymentDate:1,PaymentMode:1,PaymentRefNo:1,ReceiptNo:1,Remark:1,RowIds:1,TeacherAddress:1,TeacherAlternateEmail:1,TeacherAlternateMobile:1,TeacherBankAccountName:1,TeacherBankAccountNo:1,TeacherBankAccountType:1,TeacherBankIfscCode:1,TeacherBankName:1,TeacherCity:1,TeacherDescription:1,TeacherEmail:1,TeacherGstCertificate:1,TeacherGstin:1,TeacherId:1,TeacherInsertDate:1,TeacherInsertUserId:1,TeacherIsActive:1,TeacherMobile:1,TeacherName:1,TeacherPan:1,TeacherPincode:1,TeacherStateId:1,TeacherUpdateDate:1,TeacherUpdateUserId:1,TeacherUserId:1,UpdateDate:1,UpdateUserId:1},WebsiteOrderProducts:{AccessStatus:1,AllowedDevices:1,EOpens:1,EValidity:1,EValidityType:1,EWatchTime:1,HasBooks:1,HasCourier:1,HasPendrive:1,Id:1,IsTemplateSerialKey:1,Islive:1,MappingStatus:1,OrderBillingAddress1:1,OrderBillingAddress2:1,OrderBillingCity:1,OrderBillingPincode:1,OrderBillingStateId:1,OrderCustomerEmail1:1,OrderCustomerEmail2:1,OrderCustomerId:1,OrderCustomerMobile1:1,OrderCustomerMobile2:1,OrderCustomerName:1,OrderDiscountAmount:1,OrderDiscountCoupon:1,OrderDiscountPer:1,OrderEFranchiseeDiscount:1,OrderEFranchiseeDiscountType:1,OrderEInvoiceStatus:1,OrderEInvoiceTo:1,OrderEOrderProcessBy:1,OrderEOrderStatus:1,OrderEPaymentStatus:1,OrderEPaymentType:1,OrderEShippingStatus:1,OrderEShippingType:1,OrderESourceType:1,OrderEmailSendCount:1,OrderExpectedShippingDate:1,OrderFranchiseeDiscountAmount:1,OrderFranchiseeDiscountValue:1,OrderFranchiseeId:1,OrderFreezeData:1,OrderGrossAmount:1,OrderGstin:1,OrderId:1,OrderInsertDate:1,OrderInsertUserId:1,OrderInvoiceCompanyId:1,OrderIsActive:1,OrderIsEmailSent:1,OrderLastEmailSentDate:1,OrderMailId:1,OrderNetAmount:1,OrderOrderDate:1,OrderOrderNumber:1,OrderShippingAddress1:1,OrderShippingAddress2:1,OrderShippingCity:1,OrderShippingNote:1,OrderShippingPincode:1,OrderShippingStateId:1,OrderShippingToName:1,OrderSourceName:1,OrderSourceOrderNumber:1,OrderTaxAmount:1,OrderTaxableAmount:1,OrderUpdateDate:1,OrderUpdateUserId:1,OrderVendorId:1,ProductId:1,Qty:1,SerialkeyStatus:1,SkuCode:1,SpecificationCode:1,TotalAllowedDuration:1,ValidTill:1}},Products:{Category:{Description:1,Id:1,InsertDate:1,InsertUserId:1,IsActive:1,IsWebsiteCategory:1,Name:1,ParentId:1,ParentName:1,UpdateDate:1,UpdateUserId:1,WebsiteCategoryId:1},ProductBillingItemSpecifications:{EAdjustmentType:1,Id:1,InsertDate:1,InsertUserId:1,IsActive:1,IsApplicable:1,PriceAdjustment:1,ProductBillingItemBillingItemName:1,ProductBillingItemEDiscountType:1,ProductBillingItemEndDate:1,ProductBillingItemGrossAmount:1,ProductBillingItemHsnMasterId:1,ProductBillingItemId:1,ProductBillingItemIncludingTax:1,ProductBillingItemInsertDate:1,ProductBillingItemInsertUserId:1,ProductBillingItemInvoiceCompanyId:1,ProductBillingItemIsActive:1,ProductBillingItemProductId:1,ProductBillingItemSpecialGrossAmount:1,ProductBillingItemStartDate:1,ProductBillingItemTaxCategoryId:1,ProductBillingItemUpdateDate:1,ProductBillingItemUpdateUserId:1,ProductId:1,ProductSpecificationAllowedDevices:1,ProductSpecificationEValidity:1,ProductSpecificationEValidityType:1,ProductSpecificationEWatchtime:1,ProductSpecificationEopens:1,ProductSpecificationHasBooks:1,ProductSpecificationHasCourier:1,ProductSpecificationHasPendrive:1,ProductSpecificationId:1,ProductSpecificationInsertDate:1,ProductSpecificationInsertUserId:1,ProductSpecificationIsLive:1,ProductSpecificationProcessOrderOnPaid:1,ProductSpecificationProductId:1,ProductSpecificationSpecificationCode:1,ProductSpecificationSpecificationName:1,ProductSpecificationUpdateDate:1,ProductSpecificationUpdateUserId:1,ProductSpecificationValidTill:1,UpdateDate:1,UpdateUserId:1},ProductBillingItems:{BillingItemName:1,EDiscountType:1,EndDate:1,GrossAmount:1,HsnMasterHsnCode:1,HsnMasterId:1,HsnMasterInsertDate:1,HsnMasterInsertUserId:1,HsnMasterIsActive:1,HsnMasterName:1,HsnMasterTaxCategoryId:1,HsnMasterUpdateDate:1,HsnMasterUpdateUserId:1,Id:1,IncludingTax:1,InsertDate:1,InsertUserId:1,InvoiceCompanyAddress:1,InvoiceCompanyFooterNote:1,InvoiceCompanyGstIn:1,InvoiceCompanyId:1,InvoiceCompanyInvoiceChangeDate:1,InvoiceCompanyInvoiceCode:1,InvoiceCompanyIsDefault:1,InvoiceCompanyIsTaxApplicable:1,InvoiceCompanyLogo1:1,InvoiceCompanyLogo2:1,InvoiceCompanyName:1,InvoiceCompanyStampImage:1,IsActive:1,ProductActivateSerialKey:1,ProductAllowSerialKeyGeneration:1,ProductAllowedDevices:1,ProductDescription:1,ProductDownloadUrl1:1,ProductDownloadUrl2:1,ProductEAccessStatus:1,ProductEOpens:1,ProductEPackingType:1,ProductEProductType:1,ProductERioplayVersion:1,ProductEShippedby:1,ProductEValidity:1,ProductEValidityType:1,ProductEWatchTime:1,ProductGrossAmount:1,ProductHasBooks:1,ProductHasCourier:1,ProductHasPenDrive:1,ProductHasVod:1,ProductHeight:1,ProductId:1,ProductInAppDownload:1,ProductInsertDate:1,ProductInsertUserId:1,ProductIsActive:1,ProductIsCombo:1,ProductIsLive:1,ProductLength:1,ProductNote:1,ProductProcesOrderOnPaid:1,ProductProductIds:1,ProductProductName:1,ProductProductQueryInfo:1,ProductRioplayProductCode:1,ProductSkuCode:1,ProductSupportInfo:1,ProductTeacherName:1,ProductTemplateSerialKeyId:1,ProductTotalAllowedDuration:1,ProductUpdateDate:1,ProductUpdateUserId:1,ProductValidTill:1,ProductVendorId:1,ProductWebsiteUrl:1,ProductWeight:1,ProductWidth:1,SpecialGrossAmount:1,StartDate:1,TaxCategoryId:1,TaxCategoryInsertDate:1,TaxCategoryInsertUserId:1,TaxCategoryIsActive:1,TaxCategoryName:1,TaxCategoryUpdateDate:1,TaxCategoryUpdateUserId:1,UpdateDate:1,UpdateUserId:1},ProductBooks:{BookBookName:1,BookCost:1,BookEBookType:1,BookId:1,BookInsertDate:1,BookInsertUserId:1,BookIsActive:1,BookIsbn:1,BookNoOfPages:1,BookTaxCategoryId:1,BookUpdateDate:1,BookUpdateUserId:1,Id:1,InsertDate:1,InsertUserId:1,IsActive:1,ProductActivateSerialKey:1,ProductAllowSerialKeyGeneration:1,ProductAllowedDevices:1,ProductDescription:1,ProductDownloadUrl1:1,ProductDownloadUrl2:1,ProductEAccessStatus:1,ProductEOpens:1,ProductEPackingType:1,ProductEProductType:1,ProductERioplayVersion:1,ProductEShippedby:1,ProductEValidity:1,ProductEValidityType:1,ProductEWatchTime:1,ProductGrossAmount:1,ProductHasBooks:1,ProductHasCourier:1,ProductHasPenDrive:1,ProductHasVod:1,ProductHeight:1,ProductId:1,ProductInAppDownload:1,ProductInsertDate:1,ProductInsertUserId:1,ProductIsActive:1,ProductIsCombo:1,ProductIsLive:1,ProductLength:1,ProductNote:1,ProductProcesOrderOnPaid:1,ProductProductIds:1,ProductProductName:1,ProductProductQueryInfo:1,ProductRioplayProductCode:1,ProductSkuCode:1,ProductSupportInfo:1,ProductTeacherName:1,ProductTemplateSerialKeyId:1,ProductTotalAllowedDuration:1,ProductUpdateDate:1,ProductUpdateUserId:1,ProductValidTill:1,ProductVendorId:1,ProductWebsiteUrl:1,ProductWeight:1,ProductWidth:1,UpdateDate:1,UpdateUserId:1},ProductCategory:{CategoryDescription:1,CategoryId:1,CategoryInsertDate:1,CategoryInsertUserId:1,CategoryIsActive:1,CategoryIsWebsiteCategory:1,CategoryName:1,CategoryParentId:1,CategoryUpdateDate:1,CategoryUpdateUserId:1,CategoryWebsiteCategoryId:1,Id:1,InsertDate:1,InsertUserId:1,IsActive:1,ProductActivateSerialKey:1,ProductAllowSerialKeyGeneration:1,ProductAllowedDevices:1,ProductDescription:1,ProductDownloadUrl1:1,ProductDownloadUrl2:1,ProductEAccessStatus:1,ProductEOpens:1,ProductEPackingType:1,ProductEProductType:1,ProductERioplayVersion:1,ProductEShippedby:1,ProductEValidity:1,ProductEValidityType:1,ProductEWatchTime:1,ProductGrossAmount:1,ProductHasBooks:1,ProductHasCourier:1,ProductHasPenDrive:1,ProductHasVod:1,ProductHeight:1,ProductId:1,ProductInAppDownload:1,ProductInsertDate:1,ProductInsertUserId:1,ProductIsActive:1,ProductIsCombo:1,ProductIsLive:1,ProductLength:1,ProductNote:1,ProductProcesOrderOnPaid:1,ProductProductIds:1,ProductProductName:1,ProductProductQueryInfo:1,ProductRioplayProductCode:1,ProductSkuCode:1,ProductSupportInfo:1,ProductTeacherName:1,ProductTemplateSerialKeyId:1,ProductTotalAllowedDuration:1,ProductUpdateDate:1,ProductUpdateUserId:1,ProductValidTill:1,ProductVendorId:1,ProductWebsiteUrl:1,ProductWeight:1,ProductWidth:1,UpdateDate:1,UpdateUserId:1},ProductFranchiseeShare:{ESharingType:1,FranchiseeAddress:1,FranchiseeAlternateEmail:1,FranchiseeAlternateMobile:1,FranchiseeBankAccountName:1,FranchiseeBankAccountNo:1,FranchiseeBankAccountType:1,FranchiseeBankIfscCode:1,FranchiseeBankName:1,FranchiseeCity:1,FranchiseeCustomerId:1,FranchiseeDescription:1,FranchiseeDiscountCoupon:1,FranchiseeEmail:1,FranchiseeGstCertificate:1,FranchiseeGstin:1,FranchiseeId:1,FranchiseeInsertDate:1,FranchiseeInsertUserId:1,FranchiseeIsActive:1,FranchiseeIsCustomer:1,FranchiseeIsPostPayAllowed:1,FranchiseeMobile:1,FranchiseeName:1,FranchiseePan:1,FranchiseePincode:1,FranchiseeStateId:1,FranchiseeUpdateDate:1,FranchiseeUpdateUserId:1,FranchiseeUserId:1,Id:1,InsertDate:1,InsertUserId:1,IsActive:1,ProductActivateSerialKey:1,ProductAllowSerialKeyGeneration:1,ProductAllowedDevices:1,ProductDescription:1,ProductDownloadUrl1:1,ProductDownloadUrl2:1,ProductEAccessStatus:1,ProductEOpens:1,ProductEPackingType:1,ProductEProductType:1,ProductERioplayVersion:1,ProductEShippedby:1,ProductEValidity:1,ProductEValidityType:1,ProductEWatchTime:1,ProductGrossAmount:1,ProductHasBooks:1,ProductHasCourier:1,ProductHasPenDrive:1,ProductHasVod:1,ProductHeight:1,ProductId:1,ProductInAppDownload:1,ProductInsertDate:1,ProductInsertUserId:1,ProductIsActive:1,ProductIsCombo:1,ProductIsLive:1,ProductLength:1,ProductNote:1,ProductProcesOrderOnPaid:1,ProductProductIds:1,ProductProductName:1,ProductProductQueryInfo:1,ProductRioplayProductCode:1,ProductSkuCode:1,ProductSupportInfo:1,ProductTeacherName:1,ProductTemplateSerialKeyId:1,ProductTotalAllowedDuration:1,ProductUpdateDate:1,ProductUpdateUserId:1,ProductValidTill:1,ProductVendorId:1,ProductWebsiteUrl:1,ProductWeight:1,ProductWidth:1,RowIds:1,SIds:1,SharingAmount:1,UpdateDate:1,UpdateUserId:1},ProductPendrives:{Id:1,InsertDate:1,InsertUserId:1,IsActive:1,PenDriveTypeId:1,PendriveType:1,ProductActivateSerialKey:1,ProductAllowSerialKeyGeneration:1,ProductAllowedDevices:1,ProductDescription:1,ProductDownloadUrl1:1,ProductDownloadUrl2:1,ProductEAccessStatus:1,ProductEOpens:1,ProductEPackingType:1,ProductEProductType:1,ProductERioplayVersion:1,ProductEShippedby:1,ProductEValidity:1,ProductEValidityType:1,ProductEWatchTime:1,ProductGrossAmount:1,ProductHasBooks:1,ProductHasCourier:1,ProductHasPenDrive:1,ProductHasVod:1,ProductHeight:1,ProductId:1,ProductInAppDownload:1,ProductInsertDate:1,ProductInsertUserId:1,ProductIsActive:1,ProductIsCombo:1,ProductIsLive:1,ProductLength:1,ProductNote:1,ProductProcesOrderOnPaid:1,ProductProductIds:1,ProductProductName:1,ProductProductQueryInfo:1,ProductRioplayProductCode:1,ProductSkuCode:1,ProductSupportInfo:1,ProductTeacherName:1,ProductTemplateSerialKeyId:1,ProductTotalAllowedDuration:1,ProductUpdateDate:1,ProductUpdateUserId:1,ProductValidTill:1,ProductVendorId:1,ProductWebsiteUrl:1,ProductWeight:1,ProductWidth:1,Quantity:1,UpdateDate:1,UpdateUserId:1},ProductSpecifications:{AllowedDevice:1,AllowedDevices:1,EValidity:1,EValidityType:1,EWatchtime:1,Eopens:1,HasBooks:1,HasCourier:1,HasPendrive:1,Id:1,InsertDate:1,InsertUserId:1,IsLive:1,ProcessOrderOnPaid:1,ProductActivateSerialKey:1,ProductAllowSerialKeyGeneration:1,ProductAllowedDevices:1,ProductDescription:1,ProductDownloadUrl1:1,ProductDownloadUrl2:1,ProductEAccessStatus:1,ProductEOpens:1,ProductEPackingType:1,ProductEProductType:1,ProductERioplayVersion:1,ProductEShippedby:1,ProductEValidity:1,ProductEValidityType:1,ProductEWatchTime:1,ProductGrossAmount:1,ProductHasBooks:1,ProductHasCourier:1,ProductHasPenDrive:1,ProductHasVod:1,ProductHeight:1,ProductId:1,ProductInAppDownload:1,ProductInsertDate:1,ProductInsertUserId:1,ProductIsActive:1,ProductIsCombo:1,ProductIsLive:1,ProductLength:1,ProductNote:1,ProductProcesOrderOnPaid:1,ProductProductIds:1,ProductProductName:1,ProductProductQueryInfo:1,ProductRioplayProductCode:1,ProductSkuCode:1,ProductSpecificationBookId:1,ProductSupportInfo:1,ProductTeacherName:1,ProductTemplateSerialKeyId:1,ProductTotalAllowedDuration:1,ProductUpdateDate:1,ProductUpdateUserId:1,ProductValidTill:1,ProductVendorId:1,ProductWebsiteUrl:1,ProductWeight:1,ProductWidth:1,Rioplay8AllowedDevices:1,Rioplay8ESubscriptionType:1,Rioplay8EViewsType:1,Rioplay8EWatchTimetype:1,Rioplay8ValidDate:1,Rioplay8ValidityInDays:1,Rioplay8ViewsPerContent:1,Rioplay8WatchTime:1,SpecificationCode:1,SpecificationName:1,UpdateDate:1,UpdateUserId:1,ValidTill:1},ProductSpecificationsBooks:{BookId:1,Id:1,InsertDate:1,InsertUserId:1,IsActive:1,ProductId:1,ProductSpecificationAllowedDevices:1,ProductSpecificationEValidity:1,ProductSpecificationEValidityType:1,ProductSpecificationEWatchtime:1,ProductSpecificationEopens:1,ProductSpecificationHasBooks:1,ProductSpecificationHasCourier:1,ProductSpecificationHasPendrive:1,ProductSpecificationId:1,ProductSpecificationInsertDate:1,ProductSpecificationInsertUserId:1,ProductSpecificationIsLive:1,ProductSpecificationProcessOrderOnPaid:1,ProductSpecificationProductId:1,ProductSpecificationSpecificationCode:1,ProductSpecificationSpecificationName:1,ProductSpecificationUpdateDate:1,ProductSpecificationUpdateUserId:1,ProductSpecificationValidTill:1,UpdateDate:1,UpdateUserId:1},ProductTeacherShare:{ESharingType:1,Id:1,InsertDate:1,InsertUserId:1,IsActive:1,ProductActivateSerialKey:1,ProductAllowSerialKeyGeneration:1,ProductAllowedDevices:1,ProductDescription:1,ProductDownloadUrl1:1,ProductDownloadUrl2:1,ProductEAccessStatus:1,ProductEOpens:1,ProductEPackingType:1,ProductEProductType:1,ProductERioplayVersion:1,ProductEShippedby:1,ProductEValidity:1,ProductEValidityType:1,ProductEWatchTime:1,ProductGrossAmount:1,ProductHasBooks:1,ProductHasCourier:1,ProductHasPenDrive:1,ProductHasVod:1,ProductHeight:1,ProductId:1,ProductInAppDownload:1,ProductInsertDate:1,ProductInsertUserId:1,ProductIsActive:1,ProductIsCombo:1,ProductIsLive:1,ProductLength:1,ProductNote:1,ProductProcesOrderOnPaid:1,ProductProductIds:1,ProductProductName:1,ProductProductQueryInfo:1,ProductRioplayProductCode:1,ProductSkuCode:1,ProductSupportInfo:1,ProductTeacherName:1,ProductTemplateSerialKeyId:1,ProductTotalAllowedDuration:1,ProductUpdateDate:1,ProductUpdateUserId:1,ProductValidTill:1,ProductVendorId:1,ProductWebsiteUrl:1,ProductWeight:1,ProductWidth:1,RowIds:1,SharingAmount:1,TeacherAddress:1,TeacherAlternateEmail:1,TeacherAlternateMobile:1,TeacherBankAccountName:1,TeacherBankAccountNo:1,TeacherBankAccountType:1,TeacherBankIfscCode:1,TeacherBankName:1,TeacherCity:1,TeacherDescription:1,TeacherEmail:1,TeacherGstCertificate:1,TeacherGstin:1,TeacherId:1,TeacherInsertDate:1,TeacherInsertUserId:1,TeacherIsActive:1,TeacherMobile:1,TeacherName:1,TeacherPan:1,TeacherPincode:1,TeacherStateId:1,TeacherUpdateDate:1,TeacherUpdateUserId:1,TeacherUserId:1,UpdateDate:1,UpdateUserId:1},Products:{ActivateSerialKey:1,AllowSerialKeyGeneration:1,AllowedDevice:1,AllowedDevices:1,ComboProductId:1,Description:1,DownloadUrl1:1,DownloadUrl2:1,EAccessStatus:1,EOpens:1,EPackingType:1,EProductType:1,ERioplayVersion:1,EShippedby:1,EValidity:1,EValidityType:1,EWatchTime:1,GrossAmount:1,HasBooks:1,HasCourier:1,HasPenDrive:1,HasVod:1,Height:1,Id:1,InAppDownload:1,InsertDate:1,InsertUserId:1,IsActive:1,IsCombo:1,IsLive:1,Length:1,Note:1,ProcesOrderOnPaid:1,ProductCategList:1,ProductDisplayName:1,ProductIds:1,ProductName:1,ProductQueryInfo:1,RioPlayTenantId:1,Rioplay8AllowedDevice:1,Rioplay8AllowedDevices:1,Rioplay8DeviceCount:1,Rioplay8EDeviceRestrictionType:1,Rioplay8ESubscriptionType:1,Rioplay8EViewsType:1,Rioplay8EWatchTimetype:1,Rioplay8PlaylistIds:1,Rioplay8ProductCode:1,Rioplay8SwitchCount:1,Rioplay8TenantId:1,Rioplay8ValidDate:1,Rioplay8ValidityInDays:1,Rioplay8ViewsPerContent:1,Rioplay8WatchTime:1,RioplayProductCode:1,RowIds:1,Secretkey:1,SkuCode:1,SupportInfo:1,TeacherName:1,TemplateSerialKeyId:1,Thumbnail:1,TotalAllowedDuration:1,UpdateDate:1,UpdateUserId:1,UserName:1,ValidTill:1,VendorId:1,VendorUserId:1,WebsiteUrl:1,Weight:1,Width:1}},Reports:{FranchiseeOutstanding:{ESettelementStatus:1,FranchiseeAddress:1,FranchiseeAlternateEmail:1,FranchiseeAlternateMobile:1,FranchiseeBankAccountName:1,FranchiseeBankAccountNo:1,FranchiseeBankAccountType:1,FranchiseeBankIfscCode:1,FranchiseeBankName:1,FranchiseeCity:1,FranchiseeCustomerId:1,FranchiseeDescription:1,FranchiseeDiscountCoupon:1,FranchiseeEmail:1,FranchiseeGstCertificate:1,FranchiseeGstin:1,FranchiseeId:1,FranchiseeInsertDate:1,FranchiseeInsertUserId:1,FranchiseeIsActive:1,FranchiseeIsCustomer:1,FranchiseeIsPostPayAllowed:1,FranchiseeMobile:1,FranchiseeName:1,FranchiseePan:1,FranchiseePincode:1,FranchiseeStateId:1,FranchiseeUpdateDate:1,FranchiseeUpdateUserId:1,FranchiseeUserId:1,Id:1,InsertDate:1,InsertUserId:1,IsActive:1,OrderBillingAddress1:1,OrderBillingAddress2:1,OrderBillingCity:1,OrderBillingPincode:1,OrderBillingStateId:1,OrderCustomerEmail1:1,OrderCustomerEmail2:1,OrderCustomerId:1,OrderCustomerMobile1:1,OrderCustomerMobile2:1,OrderCustomerName:1,OrderDiscountAmount:1,OrderDiscountCoupon:1,OrderDiscountPer:1,OrderEFranchiseeDiscount:1,OrderEFranchiseeDiscountType:1,OrderEInvoiceStatus:1,OrderEInvoiceTo:1,OrderEOrderProcessBy:1,OrderEOrderStatus:1,OrderEPaymentStatus:1,OrderEPaymentType:1,OrderEShippingStatus:1,OrderEShippingType:1,OrderESourceType:1,OrderEmailSendCount:1,OrderExpectedShippingDate:1,OrderFranchiseeDiscountAmount:1,OrderFranchiseeDiscountValue:1,OrderFranchiseeId:1,OrderGrossAmount:1,OrderGstin:1,OrderId:1,OrderInsertDate:1,OrderInsertUserId:1,OrderInvoiceCompanyId:1,OrderIsActive:1,OrderIsEmailSent:1,OrderLastEmailSentDate:1,OrderMailId:1,OrderNetAmount:1,OrderOrderDate:1,OrderOrderNumber:1,OrderProductsAllowedDevices:1,OrderProductsCost:1,OrderProductsDiscountAmt:1,OrderProductsDownloadUrl1:1,OrderProductsDownloadUrl2:1,OrderProductsEAccessStatus:1,OrderProductsEFranchiseeDiscountType:1,OrderProductsEOpens:1,OrderProductsESerialkeyStatus:1,OrderProductsEValidity:1,OrderProductsEValidityType:1,OrderProductsEWatchTime:1,OrderProductsFranchiseeDiscountAmount:1,OrderProductsFranchiseeDiscountValue:1,OrderProductsGrossAmount:1,OrderProductsHasBooks:1,OrderProductsHasCourier:1,OrderProductsHasPendrive:1,OrderProductsId:1,OrderProductsInsertDate:1,OrderProductsInsertUserId:1,OrderProductsInvoiceCompanyId:1,OrderProductsIsActive:1,OrderProductsIsLive:1,OrderProductsIsTemplateSerialKey:1,OrderProductsNetAmount:1,OrderProductsNote:1,OrderProductsOrderId:1,OrderProductsProductId:1,OrderProductsQuantity:1,OrderProductsSerialKey:1,OrderProductsTaxableAmount:1,OrderProductsTotalAllowedDuration:1,OrderProductsUpdateDate:1,OrderProductsUpdateUserId:1,OrderProductsValidTill:1,OrderProdutcsGrossAmount:1,OrderShippingAddress1:1,OrderShippingAddress2:1,OrderShippingCity:1,OrderShippingNote:1,OrderShippingPincode:1,OrderShippingStateId:1,OrderShippingToName:1,OrderSourceName:1,OrderSourceOrderNumber:1,OrderTaxableAmount:1,OrderUpdateDate:1,OrderUpdateUserId:1,OrderVendorId:1,Quantity:1,SettelmentId:1,ShareAmount:1,SharePercentage:1,TotalShare:1,UpdateDate:1,UpdateUserId:1},FranchiseeSalesReport:{CgstAmount:1,CgstRate:1,City:1,CustomerId:1,CustomerName:1,DiscountAmount:1,EInvoiceTo:1,EPaymentStatus:1,EPaymentType:1,FranchiseeDiscountAmount:1,FranchiseeGstin:1,FranchiseeId:1,FranchiseeName:1,Id:1,IgstAmount:1,IgstRate:1,InvoiceCompanyId:1,InvoiceDate:1,InvoiceId:1,Invoicenumber:1,NetAmount:1,OrderDate:1,OrderDiscount:1,OrderNumber:1,ProductDiscount:1,ProductId:1,ProductName:1,SgstAmount:1,SgstRate:1,StateName:1,TaxCategoryName:1,TaxableAmount:1,Total:1,TotalTax:1},InvoiceBillingItemsReport:{BillingItemName:1,CgstAmount:1,CgstRate:1,City:1,CustomerId:1,CustomerName:1,DiscountAmount:1,EInvoiceTo:1,EPaymentStatus:1,EPaymentType:1,FranchiseeDiscountAmount:1,FranchiseeId:1,FranchiseeName:1,HsnName:1,Id:1,IgstAmount:1,IgstRate:1,InvoiceCompanyId:1,InvoiceDate:1,InvoiceId:1,Invoicenumber:1,NetAmount:1,OrderDate:1,OrderDiscount:1,OrderNumber:1,OrderProductBillingItemId:1,ProductBillingItemId:1,ProductDiscount:1,ProductId:1,ProductName:1,Quantity:1,Rate:1,SgstAmount:1,SgstRate:1,TaxCategoryName:1,TaxableAmount:1,Total:1,TotalTax:1},InvoiceDetailedReport:{CgstAmount:1,CgstRate:1,City:1,CustomerId:1,CustomerName:1,DiscountAmount:1,EInvoiceTo:1,EPaymentStatus:1,EPaymentType:1,FranchiseeDiscountAmount:1,FranchiseeGstin:1,FranchiseeId:1,FranchiseeName:1,Id:1,IgstAmount:1,IgstRate:1,InvoiceCompanyId:1,InvoiceDate:1,InvoiceId:1,Invoicenumber:1,NetAmount:1,OrderDate:1,OrderDiscount:1,OrderNumber:1,ProductDiscount:1,ProductId:1,ProductName:1,SgstAmount:1,SgstRate:1,StateName:1,TaxCategoryName:1,TaxableAmount:1,Total:1,TotalTax:1},LevelReport:{CustomerEmail1:1,CustomerMobile1:1,CustomerName:1,Id:1,Level:1,Mode:1,OrderDate:1,OrderId:1,OrderNumber:1,ProductName:1,ProductSpecificationName:1,TotalAmount:1},OrderCombinedReport:{Address1:1,Address2:1,CgstAmount:1,CgstRate:1,City:1,CustomerEmail1:1,CustomerMobile1:1,CustomerName:1,DiscountAmount:1,DiscountCoupen:1,EOrderStatus:1,EPaymentType:1,FranchiseeName:1,Id:1,IgstAmount:1,IgstRate:1,NetAmount:1,OrderDate:1,OrderId:1,PaymentStatus:1,PinCode:1,ProductName:1,ProductSpecificationName:1,SgstAmount:1,SgstRate:1,ShippingAddress1:1,ShippingAddress2:1,ShippingCity:1,ShippingPincode:1,SourceOrderNumber:1,SourceType:1,StateName:1,TaxableAmount:1,TaxableAmountNet:1,Total:1,TotalTax:1},OrderDetailedReport:{BillingAddress1:1,BillingAddress2:1,BillingCity:1,BillingPincode:1,BillingStateId:1,BillingStateInsertDate:1,BillingStateInsertUserId:1,BillingStateIsActive:1,BillingStateIsHomeState:1,BillingStateName:1,BillingStateUpdateDate:1,BillingStateUpdateUserId:1,CustomerAttemptId:1,CustomerCouponCode:1,CustomerCourseId:1,CustomerDisplayName:1,CustomerECustomerType:1,CustomerEmail1:1,CustomerEmail2:1,CustomerGstin:1,CustomerId:1,CustomerInsertDate:1,CustomerInsertUserId:1,CustomerIsActive:1,CustomerLevelId:1,CustomerMobile11:1,CustomerMobile21:1,CustomerName1:1,CustomerUpdateDate:1,CustomerUpdateUserId:1,DiscountAmount:1,DiscountCoupon:1,DiscountPer:1,EFranchiseeDiscount:1,EFranchiseeDiscountType:1,EInvoiceStatus:1,EInvoiceTo:1,EOrderProcessBy:1,EOrderStatus:1,EPaymentStatus:1,EPaymentType:1,EShippingStatus:1,EShippingType:1,ESourceType:1,EmailSendCount:1,ExpectedShippingDate:1,FranchiseeAddress:1,FranchiseeAffiliateId:1,FranchiseeAlternateEmail:1,FranchiseeAlternateMobile:1,FranchiseeAvailableCreditBalance:1,FranchiseeBankAccountName:1,FranchiseeBankAccountNo:1,FranchiseeBankAccountType:1,FranchiseeBankIfscCode:1,FranchiseeBankName:1,FranchiseeCity:1,FranchiseeCustomerId:1,FranchiseeDescription:1,FranchiseeDiscountAmount:1,FranchiseeDiscountCoupon:1,FranchiseeDiscountValue:1,FranchiseeEmail:1,FranchiseeGstCertificate:1,FranchiseeGstin:1,FranchiseeId:1,FranchiseeInsertDate:1,FranchiseeInsertUserId:1,FranchiseeIsActive:1,FranchiseeIsCustomer:1,FranchiseeIsPostPayAllowed:1,FranchiseeMobile:1,FranchiseeName:1,FranchiseePan:1,FranchiseePincode:1,FranchiseeStateId:1,FranchiseeUpdateDate:1,FranchiseeUpdateUserId:1,FranchiseeUserId:1,FreezeData:1,GrossAmount:1,Gstin:1,Id:1,InsertDate:1,InsertUserId:1,InvoiceCompanyAddress:1,InvoiceCompanyAppstoreUrl:1,InvoiceCompanyFacebookUrl:1,InvoiceCompanyFooterNote:1,InvoiceCompanyGstIn:1,InvoiceCompanyId:1,InvoiceCompanyInstagramUrl:1,InvoiceCompanyInvoiceChangeDate:1,InvoiceCompanyInvoiceCode:1,InvoiceCompanyIsDefault:1,InvoiceCompanyIsTaxApplicable:1,InvoiceCompanyLogo1:1,InvoiceCompanyLogo2:1,InvoiceCompanyName:1,InvoiceCompanyPlayStoreUrl:1,InvoiceCompanyStampImage:1,InvoiceCompanyTwitterUrl:1,InvoiceCompanyYouTubeUrl:1,IsActive:1,IsEmailSent:1,LastEmailSentDate:1,MailId:1,NetAmount:1,OrderDate:1,OrderNumber:1,ShippingAddress1:1,ShippingAddress2:1,ShippingCity:1,ShippingNote:1,ShippingPincode:1,ShippingProviderBankAccountNo:1,ShippingProviderBankIfscCode:1,ShippingProviderBankName:1,ShippingProviderDescription:1,ShippingProviderEApiStatus:1,ShippingProviderEShippingProviderType:1,ShippingProviderGstCertificate:1,ShippingProviderGstin:1,ShippingProviderId:1,ShippingProviderInsertDate:1,ShippingProviderInsertUserId:1,ShippingProviderIsActive:1,ShippingProviderIsDefault:1,ShippingProviderPan:1,ShippingProviderSecret:1,ShippingProviderShippingProviderName:1,ShippingProviderTrackingUrl:1,ShippingProviderUpdateDate:1,ShippingProviderUpdateUserId:1,ShippingProviderVendorId:1,ShippingStateId:1,ShippingStateInsertDate:1,ShippingStateInsertUserId:1,ShippingStateIsActive:1,ShippingStateIsHomeState:1,ShippingStateName:1,ShippingStateUpdateDate:1,ShippingStateUpdateUserId:1,ShippingToName:1,SourceName:1,SourceOrderNumber:1,TaxAmount:1,TaxableAmount:1,UpdateDate:1,UpdateUserId:1,VendorAddress:1,VendorBankAccountName:1,VendorBankAccountNo:1,VendorBankAccountType:1,VendorBankIfscCode:1,VendorBankName:1,VendorCity:1,VendorCountry:1,VendorDescription:1,VendorEmail:1,VendorGstCertificate:1,VendorGstin:1,VendorId:1,VendorInsertDate:1,VendorInsertUserId:1,VendorIsActive:1,VendorName:1,VendorPan:1,VendorPincode:1,VendorStateId:1,VendorUpdateDate:1,VendorUpdateUserId:1,VendorUserId:1},OrderInstallmentReport:{CustomerEmail1:1,CustomerMobile1:1,CustomerName:1,GrossAmount:1,Id:1,InstallmentAmount:1,InstallmentDate:1,OrderDate:1,OrderId:1,OrderNumber:1,ProductName:1,ProductSpecificationName:1},OrderOutstandingReport:{CustomerEmail1:1,CustomerMobile1:1,CustomerName:1,Id:1,NetAmount:1,OrderDate:1,OrderId:1,OrderNumber:1,OutstandingAmt:1,Recdamount:1,SourceType:1,Status:1},OrderPayment:{Amount:1,BankName:1,ChequeNumber:1,EPaymentMode:1,EStatus:1,Id:1,InsertDate:1,InsertUserId:1,IsActive:1,Note:1,OrderBillingAddress1:1,OrderBillingAddress2:1,OrderBillingCity:1,OrderBillingPincode:1,OrderBillingStateId:1,OrderCustomerEmail1:1,OrderCustomerEmail2:1,OrderCustomerId:1,OrderCustomerMobile1:1,OrderCustomerMobile2:1,OrderCustomerName:1,OrderDiscountAmount:1,OrderDiscountCoupon:1,OrderDiscountPer:1,OrderEFranchiseeDiscount:1,OrderEFranchiseeDiscountType:1,OrderEInvoiceStatus:1,OrderEInvoiceTo:1,OrderEOrderProcessBy:1,OrderEOrderStatus:1,OrderEPaymentStatus:1,OrderEPaymentType:1,OrderEShippingStatus:1,OrderEShippingType:1,OrderESourceType:1,OrderEmailSendCount:1,OrderExpectedShippingDate:1,OrderFranchiseeDiscountAmount:1,OrderFranchiseeDiscountValue:1,OrderFranchiseeId:1,OrderFreezeData:1,OrderGrossAmount:1,OrderGstin:1,OrderId:1,OrderInsertDate:1,OrderInsertUserId:1,OrderInvoiceCompanyId:1,OrderIsActive:1,OrderIsEmailSent:1,OrderLastEmailSentDate:1,OrderMailId:1,OrderNetAmount:1,OrderOrderDate:1,OrderOrderNumber:1,OrderShippingAddress1:1,OrderShippingAddress2:1,OrderShippingCity:1,OrderShippingNote:1,OrderShippingPincode:1,OrderShippingProviderId:1,OrderShippingStateId:1,OrderShippingToName:1,OrderSourceName:1,OrderSourceOrderNumber:1,OrderTaxAmount:1,OrderTaxableAmount:1,OrderUpdateDate:1,OrderUpdateUserId:1,OrderVendorId:1,PaymentDate:1,TransactionId:1,UpdateDate:1,UpdateUserId:1},OrderProducts:{AllowedDevices:1,Cost:1,DiscountAmt:1,DownloadUrl1:1,DownloadUrl2:1,EAccessStatus:1,EFranchiseeDiscountType:1,EOpens:1,ESerialkeyStatus:1,EValidity:1,EValidityType:1,EWatchTime:1,FranchiseeDiscountAmount:1,FranchiseeDiscountValue:1,FranchiseeId:1,FranchiseeName:1,GrossAmount:1,HasBooks:1,HasCourier:1,HasPendrive:1,Id:1,InsertDate:1,InsertUserId:1,InvoiceCompanyAddress:1,InvoiceCompanyFooterNote:1,InvoiceCompanyGstIn:1,InvoiceCompanyId:1,InvoiceCompanyInvoiceChangeDate:1,InvoiceCompanyInvoiceCode:1,InvoiceCompanyIsDefault:1,InvoiceCompanyIsTaxApplicable:1,InvoiceCompanyLogo1:1,InvoiceCompanyLogo2:1,InvoiceCompanyName:1,InvoiceCompanyStampImage:1,IsActive:1,IsLive:1,IsTemplateSerialKey:1,NetAmount:1,Note:1,OrderBillingAddress1:1,OrderBillingAddress2:1,OrderBillingCity:1,OrderBillingPincode:1,OrderBillingStateId:1,OrderCustomerEmail1:1,OrderCustomerEmail2:1,OrderCustomerId:1,OrderCustomerMobile1:1,OrderCustomerMobile2:1,OrderCustomerName:1,OrderDiscountAmount:1,OrderDiscountCoupon:1,OrderDiscountPer:1,OrderEFranchiseeDiscount:1,OrderEFranchiseeDiscountType:1,OrderEInvoiceStatus:1,OrderEInvoiceTo:1,OrderEOrderProcessBy:1,OrderEOrderStatus:1,OrderEPaymentStatus:1,OrderEPaymentType:1,OrderEShippingStatus:1,OrderEShippingType:1,OrderESourceType:1,OrderEmailSendCount:1,OrderExpectedShippingDate:1,OrderFranchiseeDiscountAmount:1,OrderFranchiseeDiscountValue:1,OrderFranchiseeId:1,OrderFreezeData:1,OrderGrossAmount:1,OrderGstin:1,OrderId:1,OrderInsertDate:1,OrderInsertUserId:1,OrderInvoiceCompanyId:1,OrderIsActive:1,OrderIsEmailSent:1,OrderLastEmailSentDate:1,OrderMailId:1,OrderNetAmount:1,OrderOrderDate:1,OrderOrderNumber:1,OrderShippingAddress1:1,OrderShippingAddress2:1,OrderShippingCity:1,OrderShippingNote:1,OrderShippingPincode:1,OrderShippingProviderId:1,OrderShippingStateId:1,OrderShippingStateName:1,OrderShippingToName:1,OrderSourceName:1,OrderSourceOrderNumber:1,OrderTaxAmount:1,OrderTaxableAmount:1,OrderUpdateDate:1,OrderUpdateUserId:1,OrderVendorId:1,ProductActivateSerialKey:1,ProductAllowSerialKeyGeneration:1,ProductAllowedDevices:1,ProductDescription:1,ProductDownloadUrl1:1,ProductDownloadUrl2:1,ProductEAccessStatus:1,ProductEOpens:1,ProductEPackingType:1,ProductEProductType:1,ProductERioplayVersion:1,ProductEShippedby:1,ProductEValidity:1,ProductEValidityType:1,ProductEWatchTime:1,ProductGrossAmount:1,ProductHasBooks:1,ProductHasCourier:1,ProductHasPenDrive:1,ProductHasVod:1,ProductHeight:1,ProductId:1,ProductInAppDownload:1,ProductInsertDate:1,ProductInsertUserId:1,ProductIsActive:1,ProductIsCombo:1,ProductIsLive:1,ProductLength:1,ProductNote:1,ProductProcesOrderOnPaid:1,ProductProductIds:1,ProductProductName:1,ProductProductQueryInfo:1,ProductRioPlayTenantId:1,ProductRioplayProductCode:1,ProductSecretkey:1,ProductSkuCode:1,ProductSupportInfo:1,ProductTeacherName:1,ProductTemplateSerialKeyId:1,ProductTotalAllowedDuration:1,ProductUpdateDate:1,ProductUpdateUserId:1,ProductValidTill:1,ProductVendorId:1,ProductWebsiteUrl:1,ProductWeight:1,ProductWidth:1,Quantity:1,SerialKey:1,TaxAmount:1,TaxableAmount:1,TotalAllowedDuration:1,UpdateDate:1,UpdateUserId:1,ValidTill:1},OrderSaleReport:{Address1:1,Address2:1,AffiliateId:1,CgstAmount:1,CgstRate:1,City:1,Currencies:1,CustomerEmail1:1,CustomerMobile1:1,CustomerName:1,DiscountAmount:1,DiscountCode:1,Gstin:1,Id:1,IgstAmount:1,IgstRate:1,InvoiceNumber:1,NetAmount:1,OrderDate:1,OrderId:1,PaymentDate:1,PaymentMode:1,PaymentStatus:1,PinCode:1,ProductName:1,ProductSpecificationName:1,SgstAmount:1,SgstRate:1,SourceType:1,StateName:1,TaxableAmount:1,TaxableAmountNet:1,Total:1,TotalTax:1,TransactionId:1},OrderShipping:{EStatus:1,Id:1,InsertDate:1,InsertUserId:1,IsActive:1,OrderBillingAddress1:1,OrderBillingAddress2:1,OrderBillingCity:1,OrderBillingPincode:1,OrderBillingStateId:1,OrderCustomerEmail1:1,OrderCustomerEmail2:1,OrderCustomerId:1,OrderCustomerMobile1:1,OrderCustomerMobile2:1,OrderCustomerName:1,OrderDiscountAmount:1,OrderDiscountCoupon:1,OrderDiscountPer:1,OrderEFranchiseeDiscount:1,OrderEFranchiseeDiscountType:1,OrderEInvoiceStatus:1,OrderEInvoiceTo:1,OrderEOrderProcessBy:1,OrderEOrderStatus:1,OrderEPaymentStatus:1,OrderEPaymentType:1,OrderEShippingStatus:1,OrderEShippingType:1,OrderESourceType:1,OrderEmailSendCount:1,OrderExpectedShippingDate:1,OrderFranchiseeDiscountAmount:1,OrderFranchiseeDiscountValue:1,OrderFranchiseeId:1,OrderGrossAmount:1,OrderGstin:1,OrderId:1,OrderInsertDate:1,OrderInsertUserId:1,OrderInvoiceCompanyId:1,OrderIsActive:1,OrderIsEmailSent:1,OrderLastEmailSentDate:1,OrderMailId:1,OrderNetAmount:1,OrderOrderDate:1,OrderOrderNumber:1,OrderShippingAddress1:1,OrderShippingAddress2:1,OrderShippingCity:1,OrderShippingNote:1,OrderShippingPincode:1,OrderShippingStateId:1,OrderShippingStateName:1,OrderShippingToName:1,OrderSourceName:1,OrderSourceOrderNumber:1,OrderTaxableAmount:1,OrderUpdateDate:1,OrderUpdateUserId:1,OrderVendorId:1,ShippingCost:1,ShippingDate:1,ShippingProviderBankAccountNo:1,ShippingProviderBankIfscCode:1,ShippingProviderBankName:1,ShippingProviderDescription:1,ShippingProviderEApiStatus:1,ShippingProviderEShippingProviderType:1,ShippingProviderGstCertificate:1,ShippingProviderGstin:1,ShippingProviderId:1,ShippingProviderInsertDate:1,ShippingProviderInsertUserId:1,ShippingProviderIsActive:1,ShippingProviderIsDefault:1,ShippingProviderPan:1,ShippingProviderSecret:1,ShippingProviderShippingProviderName:1,ShippingProviderTrackingUrl:1,ShippingProviderUpdateDate:1,ShippingProviderUpdateUserId:1,ShippingProviderVendorId:1,TrackingId:1,TrackingUrl:1,UpdateDate:1,UpdateUserId:1},OrderShippingItemsReport:{BookName:1,Id:1,OrderId:1,OrderNumber:1,OrdershippingBooksId:1,PenDriveTypeId:1,PendriveType:1,ProductBookid:1,ProductId:1,ProductName:1,Quantity:1,ShippingProviderId:1,ShippingProviderName:1,SourceType:1,TrackingId:1,TrackingUrl:1},OrderShippingReport:{BookStatus:1,CustomerName:1,HasBooks:1,Id:1,OrderDate:1,OrderId:1,OrderNumber:1,ProductName:1,ProductSpecificationName:1,SourceType:1},OrderTransactionReport:{BillingAddress1:1,BillingAddress2:1,BillingCity:1,BillingCountry:1,BillingPincode:1,BillingStateId:1,CurrencyAmount:1,CurrencyId:1,CustomerEmail1:1,CustomerEmail2:1,CustomerId:1,CustomerMobile1:1,CustomerMobile2:1,CustomerName:1,DiscountAmount:1,DiscountCoupon:1,DiscountPer:1,EFranchiseeDiscount:1,EFranchiseeDiscountType:1,EInvoiceStatus:1,EInvoiceTo:1,EOrderProcessBy:1,EOrderStatus:1,EPaymentStatus:1,EPaymentType:1,EShippingStatus:1,EShippingType:1,ESourceType:1,EmailSendCount:1,ExpectedShippingDate:1,FranchiseeDiscountAmount:1,FranchiseeDiscountValue:1,FranchiseeId:1,FreezeData:1,GrossAmount:1,Gstin:1,Id:1,InsertDate:1,InsertUserId:1,InvoiceCompanyId:1,IsActive:1,IsEmailSent:1,LastEmailSentDate:1,MailId:1,Mode:1,NetAmount:1,NetAmountAfterFrDiscount:1,OrderDate:1,OrderNumber:1,PaymentMode:1,ShippingAddress1:1,ShippingAddress2:1,ShippingCity:1,ShippingCountry:1,ShippingNote:1,ShippingPincode:1,ShippingProviderId:1,ShippingStateId:1,ShippingToName:1,SourceName:1,SourceOrderNumber:1,SrId:1,TaxAmount:1,TaxableAmount:1,TransactionId:1,UpdateDate:1,UpdateUserId:1,VendorId:1},ShippingReport:{CustomerEmail1:1,CustomerEmail2:1,CustomerMobile1:1,CustomerMobile2:1,CustomerName:1,Id:1,OrderDate:1,OrderId:1,OrderNumber:1,ShippingAddress1:1,ShippingAddress2:1,ShippingCity:1,ShippingDate:1,ShippingPincode:1,ShippingProviderId:1,ShippingProviderName:1,SourceType:1,Status:1,TrackingId:1,TrackingUrl:1},TeacherOutstanding:{ESettelementStatus:1,Id:1,InsertDate:1,InsertUserId:1,IsActive:1,OrderBillingAddress1:1,OrderBillingAddress2:1,OrderBillingCity:1,OrderBillingPincode:1,OrderBillingStateId:1,OrderCurrencyAmount:1,OrderCurrencyId:1,OrderCustomerEmail1:1,OrderCustomerEmail2:1,OrderCustomerId:1,OrderCustomerMobile1:1,OrderCustomerMobile2:1,OrderCustomerName:1,OrderDiscountAmount:1,OrderDiscountCoupon:1,OrderDiscountPer:1,OrderEFranchiseeDiscount:1,OrderEFranchiseeDiscountType:1,OrderEInvoiceStatus:1,OrderEInvoiceTo:1,OrderEOrderProcessBy:1,OrderEOrderStatus:1,OrderEPaymentStatus:1,OrderEPaymentType:1,OrderEShippingStatus:1,OrderEShippingType:1,OrderESourceType:1,OrderEmailSendCount:1,OrderExpectedShippingDate:1,OrderFranchiseeDiscountAmount:1,OrderFranchiseeDiscountValue:1,OrderFranchiseeId:1,OrderFreezeData:1,OrderGrossAmount:1,OrderGstin:1,OrderId:1,OrderInsertDate:1,OrderInsertUserId:1,OrderInvoiceCompanyId:1,OrderIsActive:1,OrderIsEmailSent:1,OrderLastEmailSentDate:1,OrderMailId:1,OrderNetAmount:1,OrderOrderDate:1,OrderOrderNumber:1,OrderProductsAllowedDevices:1,OrderProductsCost:1,OrderProductsDiscountAmt:1,OrderProductsDownloadUrl1:1,OrderProductsDownloadUrl2:1,OrderProductsEAccessStatus:1,OrderProductsEFranchiseeDiscountType:1,OrderProductsEOpens:1,OrderProductsESerialkeyStatus:1,OrderProductsEValidity:1,OrderProductsEValidityType:1,OrderProductsEWatchTime:1,OrderProductsFranchiseeDiscountAmount:1,OrderProductsFranchiseeDiscountValue:1,OrderProductsGrossAmount:1,OrderProductsHasBooks:1,OrderProductsHasCourier:1,OrderProductsHasPendrive:1,OrderProductsId:1,OrderProductsInsertDate:1,OrderProductsInsertUserId:1,OrderProductsInvoiceCompanyId:1,OrderProductsIsActive:1,OrderProductsIsLive:1,OrderProductsIsTemplateSerialKey:1,OrderProductsNetAmount:1,OrderProductsNote:1,OrderProductsOrderId:1,OrderProductsProductId:1,OrderProductsQuantity:1,OrderProductsSerialKey:1,OrderProductsTaxAmount:1,OrderProductsTaxableAmount:1,OrderProductsTotalAllowedDuration:1,OrderProductsUpdateDate:1,OrderProductsUpdateUserId:1,OrderProductsValidTill:1,OrderProdutcsCost:1,OrderShippingAddress1:1,OrderShippingAddress2:1,OrderShippingCity:1,OrderShippingNote:1,OrderShippingPincode:1,OrderShippingProviderId:1,OrderShippingStateId:1,OrderShippingToName:1,OrderSourceName:1,OrderSourceOrderNumber:1,OrderTaxAmount:1,OrderTaxableAmount:1,OrderUpdateDate:1,OrderUpdateUserId:1,OrderVendorId:1,Qty:1,SettelmentId:1,ShareAmount:1,SharePercentage:1,TeacherAddress:1,TeacherAlternateEmail:1,TeacherAlternateMobile:1,TeacherBankAccountName:1,TeacherBankAccountNo:1,TeacherBankAccountType:1,TeacherBankIfscCode:1,TeacherBankName:1,TeacherCity:1,TeacherDescription:1,TeacherEmail:1,TeacherGstCertificate:1,TeacherGstin:1,TeacherId:1,TeacherInsertDate:1,TeacherInsertUserId:1,TeacherIsActive:1,TeacherMobile:1,TeacherName:1,TeacherPan:1,TeacherPincode:1,TeacherStateId:1,TeacherUpdateDate:1,TeacherUpdateUserId:1,TeacherUserId:1,TotalShare:1,UpdateDate:1,UpdateUserId:1}},Shipping:{ShippingProviders:{BankAccountNo:1,BankIfscCode:1,BankName:1,Description:1,EApiStatus:1,EShippingProviderType:1,GstCertificate:1,Gstin:1,Id:1,InsertDate:1,InsertUserId:1,IsActive:1,IsDefault:1,Pan:1,Secret:1,ShippingProviderName:1,TrackingId:1,TrackingUrl:1,UpdateDate:1,UpdateUserId:1,VendorAddress:1,VendorBankAccountName:1,VendorBankAccountNo:1,VendorBankAccountType:1,VendorBankIfscCode:1,VendorBankName:1,VendorCity:1,VendorCountry:1,VendorDescription:1,VendorEmail:1,VendorGstCertificate:1,VendorGstin:1,VendorId:1,VendorInsertDate:1,VendorInsertUserId:1,VendorIsActive:1,VendorName:1,VendorPan:1,VendorPincode:1,VendorStateId:1,VendorUpdateDate:1,VendorUpdateUserId:1,VendorUserId:1},ShippingRules:{EPaymentMode:1,EPriority:1,Id:1,ShippingProviderBankAccountNo:1,ShippingProviderBankIfscCode:1,ShippingProviderBankName:1,ShippingProviderDescription:1,ShippingProviderEApiStatus:1,ShippingProviderEShippingProviderType:1,ShippingProviderGstCertificate:1,ShippingProviderGstin:1,ShippingProviderId:1,ShippingProviderInsertDate:1,ShippingProviderInsertUserId:1,ShippingProviderIsActive:1,ShippingProviderIsDefault:1,ShippingProviderPan:1,ShippingProviderSecret:1,ShippingProviderShippingProviderName:1,ShippingProviderTrackingUrl:1,ShippingProviderUpdateDate:1,ShippingProviderUpdateUserId:1,ShippingProviderVendorId:1},ShippingTrackingNumbers:{BarcodeImage:1,BarcodeType:1,ESource:1,EStatus:1,Id:1,InsertDate:1,InsertUserId:1,IsActive:1,IssueDate:1,OrderBillingAddress1:1,OrderBillingAddress2:1,OrderBillingCity:1,OrderBillingPincode:1,OrderBillingStateId:1,OrderCustomerEmail1:1,OrderCustomerEmail2:1,OrderCustomerId:1,OrderCustomerMobile1:1,OrderCustomerMobile2:1,OrderCustomerName:1,OrderDiscountAmount:1,OrderDiscountCoupon:1,OrderDiscountPer:1,OrderEFranchiseeDiscount:1,OrderEFranchiseeDiscountType:1,OrderEInvoiceStatus:1,OrderEInvoiceTo:1,OrderEOrderProcessBy:1,OrderEOrderStatus:1,OrderEPaymentStatus:1,OrderEPaymentType:1,OrderEShippingStatus:1,OrderEShippingType:1,OrderESourceType:1,OrderEmailSendCount:1,OrderExpectedShippingDate:1,OrderFranchiseeDiscountAmount:1,OrderFranchiseeDiscountValue:1,OrderFranchiseeId:1,OrderFreezeData:1,OrderGrossAmount:1,OrderGstin:1,OrderId:1,OrderInsertDate:1,OrderInsertUserId:1,OrderInvoiceCompanyId:1,OrderIsActive:1,OrderIsEmailSent:1,OrderLastEmailSentDate:1,OrderMailId:1,OrderNetAmount:1,OrderOrderDate:1,OrderOrderNumber:1,OrderShippingAddress1:1,OrderShippingAddress2:1,OrderShippingCity:1,OrderShippingNote:1,OrderShippingPincode:1,OrderShippingStateId:1,OrderShippingToName:1,OrderSourceName:1,OrderSourceOrderNumber:1,OrderTaxAmount:1,OrderTaxableAmount:1,OrderUpdateDate:1,OrderUpdateUserId:1,OrderVendorId:1,ShippingProviderBankAccountNo:1,ShippingProviderBankIfscCode:1,ShippingProviderBankName:1,ShippingProviderDescription:1,ShippingProviderEApiStatus:1,ShippingProviderEShippingProviderType:1,ShippingProviderGstCertificate:1,ShippingProviderGstin:1,ShippingProviderId:1,ShippingProviderInsertDate:1,ShippingProviderInsertUserId:1,ShippingProviderIsActive:1,ShippingProviderIsDefault:1,ShippingProviderPan:1,ShippingProviderSecret:1,ShippingProviderShippingProviderName:1,ShippingProviderTrackingUrl:1,ShippingProviderUpdateDate:1,ShippingProviderUpdateUserId:1,ShippingProviderVendorId:1,TrackingNumber:1,UpdateDate:1,UpdateUserId:1}},Users:{BrandAmbassador:{Address:1,AlternateEmail:1,AlternateMobile:1,BankAccountName:1,BankAccountNo:1,BankAccountType:1,BankIfscCode:1,BankName:1,City:1,CustomerAttemptId:1,CustomerCouponCode:1,CustomerCourseId:1,CustomerECustomerType:1,CustomerEmailId1:1,CustomerEmailId2:1,CustomerGstin:1,CustomerId:1,CustomerInsertDate:1,CustomerInsertUserId:1,CustomerIsActive:1,CustomerLevelId:1,CustomerMobile1:1,CustomerMobile2:1,CustomerName:1,CustomerUpdateDate:1,CustomerUpdateUserId:1,Description:1,DiscountCoupon:1,Email:1,GstCertificate:1,Gstin:1,Id:1,InsertDate:1,InsertUserId:1,IsActive:1,Mobile:1,Name:1,Pan:1,Pincode:1,StateId:1,StateInsertDate:1,StateInsertUserId:1,StateIsActive:1,StateIsHomeState:1,StateName:1,StateUpdateDate:1,StateUpdateUserId:1,UpdateDate:1,UpdateUserId:1,UserAllowedIps:1,UserCcEmails:1,UserDisplayName:1,UserEmail:1,UserId:1,UserInsertDate:1,UserInsertUserId:1,UserIsActive:1,UserLastDirectoryUpdate:1,UserMobilePhoneNumber:1,UserMobilePhoneVerified:1,UserSecretkey:1,UserSource:1,UserTwoFactorAuth:1,UserUpdateDate:1,UserUpdateUserId:1,UserUserImage:1,UserUsername:1,UserXapikey:1,UserXapisecret:1},CustomerAddress:{Address1:1,Address2:1,City:1,Country:1,CustomerCouponCode:1,CustomerECustomerType:1,CustomerEmailId1:1,CustomerEmailId2:1,CustomerGstin:1,CustomerId:1,CustomerInsertDate:1,CustomerInsertUserId:1,CustomerIsActive:1,CustomerMobile1:1,CustomerMobile2:1,CustomerName:1,CustomerUpdateDate:1,CustomerUpdateUserId:1,Id:1,InsertDate:1,InsertUserId:1,IsActive:1,PinCode:1,StateId:1,StateName:1,UpdateDate:1,UpdateUserId:1},Customers:{AttemptId:1,AttemptName:1,CouponCode:1,CourseId:1,CourseName:1,CustomerDisplayName:1,ECustomerType:1,EmailId1:1,EmailId2:1,Gstin:1,HasPurchased:1,Id:1,InsertDate:1,InsertUserId:1,IsActive:1,LevelId:1,LevelName:1,Mobile1:1,Mobile2:1,Name:1,UpdateDate:1,UpdateUserId:1},Franchisee:{Address:1,AffiliateId:1,AlternateEmail:1,AlternateMobile:1,AvailableCreditBalance:1,BankAccountName:1,BankAccountNo:1,BankAccountType:1,BankIfscCode:1,BankName:1,City:1,CustomerCouponCode:1,CustomerECustomerType:1,CustomerEmailId1:1,CustomerEmailId2:1,CustomerGstin:1,CustomerId:1,CustomerInsertDate:1,CustomerInsertUserId:1,CustomerIsActive:1,CustomerMobile1:1,CustomerMobile2:1,CustomerName:1,CustomerUpdateDate:1,CustomerUpdateUserId:1,Description:1,DiscountCoupon:1,Email:1,GstCertificate:1,Gstin:1,Id:1,InsertDate:1,InsertUserId:1,IsActive:1,IsCustomer:1,IsGstInApplied:1,IsPostPayAllowed:1,Mobile:1,Name:1,Pan:1,Pincode:1,StateId:1,StateInsertDate:1,StateInsertUserId:1,StateIsActive:1,StateIsHomeState:1,StateName:1,StateUpdateDate:1,StateUpdateUserId:1,UpdateDate:1,UpdateUserId:1,UserDisplayName:1,UserEmail:1,UserId:1,UserInsertDate:1,UserInsertUserId:1,UserIsActive:1,UserLastDirectoryUpdate:1,UserMobilePhoneNumber:1,UserMobilePhoneVerified:1,UserSource:1,UserTwoFactorAuth:1,UserUpdateDate:1,UserUpdateUserId:1,UserUserImage:1,UserUsername:1},Support:{AllowedIps:1,DisplayName:1,Email:1,InsertDate:1,InsertUserId:1,IsActive:1,LastDirectoryUpdate:1,MobilePhoneNumber:1,MobilePhoneVerified:1,PasswordHash:1,PasswordSalt:1,Secretkey:1,Source:1,TwoFactorAuth:1,UpdateDate:1,UpdateUserId:1,UserId:1,UserImage:1,UserRole:1,Username:1},Teachers:{Address:1,AlternateEmail:1,AlternateMobile:1,BankAccountName:1,BankAccountNo:1,BankAccountType:1,BankIfscCode:1,BankName:1,City:1,Description:1,Email:1,GstCertificate:1,Gstin:1,Id:1,InsertDate:1,InsertUserId:1,IsActive:1,IsGstApplicable:1,Mobile:1,Name:1,Pan:1,Pincode:1,StateId:1,StateInsertDate:1,StateInsertUserId:1,StateIsActive:1,StateIsHomeState:1,StateName:1,StateUpdateDate:1,StateUpdateUserId:1,UpdateDate:1,UpdateUserId:1,UserDisplayName:1,UserEmail:1,UserId:1,UserInsertDate:1,UserInsertUserId:1,UserIsActive:1,UserLastDirectoryUpdate:1,UserMobilePhoneNumber:1,UserMobilePhoneVerified:1,UserSource:1,UserTwoFactorAuth:1,UserUpdateDate:1,UserUpdateUserId:1,UserUserImage:1,UserUsername:1},Vendors:{Address:1,BankAccountName:1,BankAccountNo:1,BankAccountType:1,BankIfscCode:1,BankName:1,City:1,Country:1,Description:1,Email:1,GstCertificate:1,Gstin:1,Id:1,InsertDate:1,InsertUserId:1,IsActive:1,Name:1,Pan:1,Pincode:1,StateId:1,StateInsertDate:1,StateInsertUserId:1,StateIsActive:1,StateIsHomeState:1,StateName:1,StateUpdateDate:1,StateUpdateUserId:1,UpdateDate:1,UpdateUserId:1,UserDisplayName:1,UserEmail:1,UserId:1,UserInsertDate:1,UserInsertUserId:1,UserIsActive:1,UserLastDirectoryUpdate:1,UserMobilePhoneNumber:1,UserMobilePhoneVerified:1,UserSource:1,UserTwoFactorAuth:1,UserUpdateDate:1,UserUpdateUserId:1,UserUserImage:1,UserUsername:1}},Wallet:{CreditJournal:{Description:1,Id:1,Kind:1,Name:1},CreditWallet:{AssetTypeId:1,CreditBalance:1,Credits:1,FranchiseeAddress:1,FranchiseeAffiliateId:1,FranchiseeAlternateEmail:1,FranchiseeAlternateMobile:1,FranchiseeBankAccountName:1,FranchiseeBankAccountNo:1,FranchiseeBankAccountType:1,FranchiseeBankIfscCode:1,FranchiseeBankName:1,FranchiseeCity:1,FranchiseeCustomerId:1,FranchiseeDescription:1,FranchiseeDiscountCoupon:1,FranchiseeEmail:1,FranchiseeGstCertificate:1,FranchiseeGstin:1,FranchiseeId:1,FranchiseeInsertDate:1,FranchiseeInsertUserId:1,FranchiseeIsActive:1,FranchiseeIsCustomer:1,FranchiseeIsPostPayAllowed:1,FranchiseeMobile:1,FranchiseeName:1,FranchiseePan:1,FranchiseePincode:1,FranchiseeStateId:1,FranchiseeUpdateDate:1,FranchiseeUpdateUserId:1,FranchiseeUserId:1,Id:1,JournalDescription:1,JournalId:1,JournalKind:1,JournalName:1,TransactionDate:1,TransactionDetails:1,TransactionId:1,TransactionNo:1}}},Forms:{Membership:{ChangePassword:{FormTitle:1,SubmitButton:1,Success:1},ForgotPassword:{BackToLogin:1,FormInfo:1,FormTitle:1,SubmitButton:1,Success:1},Login:{FacebookButton:1,ForgotPassword:1,GoogleButton:1,LoginToYourAccount:1,OR:1,RememberMe:1,SignInButton:1,SignUpButton:1},ResetPassword:{BackToLogin:1,EmailSubject:1,FormTitle:1,SubmitButton:1,Success:1},SignUp:{AcceptTerms:1,ActivateEmailSubject:1,ActivationCompleteMessage:1,BackToLogin:1,ConfirmEmail:1,ConfirmPassword:1,DisplayName:1,Email:1,FormInfo:1,FormTitle:1,Password:1,SubmitButton:1,Success:1}}},Navigation:{LogoutLink:1,SiteTitle:1},Site:{AccessDenied:{ClickToChangeUser:1,ClickToLogin:1,LackPermissions:1,NotLoggedIn:1,PageTitle:1},BasicProgressDialog:{CancelTitle:1,PleaseWait:1},BulkServiceAction:{AllHadErrorsFormat:1,AllSuccessFormat:1,ConfirmationFormat:1,ErrorCount:1,NothingToProcess:1,SomeHadErrorsFormat:1,SuccessCount:1},Dashboard:{ContentDescription:1},Dialogs:{PendingChangesConfirmation:1},Layout:{FooterCopyright:1,FooterInfo:1,FooterRights:1,GeneralSettings:1,Language:1,Theme:1,ThemeAzure:1,ThemeAzureLight:1,ThemeBlack:1,ThemeBlackLight:1,ThemeBlue:1,ThemeBlueLight:1,ThemeCosmos:1,ThemeCosmosLight:1,ThemeGlassy:1,ThemeGlassyLight:1,ThemeGreen:1,ThemeGreenLight:1,ThemePurple:1,ThemePurpleLight:1,ThemeRed:1,ThemeRedLight:1,ThemeYellow:1,ThemeYellowLight:1},RolePermissionDialog:{DialogTitle:1,EditButton:1,SaveSuccess:1},UserDialog:{EditPermissionsButton:1,EditRolesButton:1},UserPermissionDialog:{DialogTitle:1,Grant:1,Permission:1,Revoke:1,SaveSuccess:1},UserRoleDialog:{DialogTitle:1,SaveSuccess:1},ValidationError:{Title:1}},Validation:{AuthenticationError:1,CantFindUserWithEmail:1,CurrentPasswordMismatch:1,DeleteForeignKeyError:1,EmailConfirm:1,EmailInUse:1,InvalidActivateToken:1,InvalidResetToken:1,MinRequiredPasswordLength:1,SavePrimaryKeyError:1}});
}
